"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[66933,62780],{

/***/ 62582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ modalUnavailableStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var modalUnavailableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        show: function() {
            set({
                visible: true
            });
        },
        hide: function() {
            set({
                visible: false
            });
        }
    };
});



/***/ }),

/***/ 80842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70175);
/* harmony import */ var global_TradingModal_RealTradingModal_ModalBonds_stores_useBondsModalStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81557);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64999);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62582);




var useOnClickBuyFR = function(symbol) {
    var openBuyModal = (0,global_TradingModal_RealTradingModal_ModalBonds_stores_useBondsModalStore__WEBPACK_IMPORTED_MODULE_1__/* .useBondsModalStore */ .H)(function(store) {
        return store.openBuyModal;
    });
    var showAuthModal = (0,features_securities_AuthModal_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(store) {
        return store.showModal;
    });
    var showModalUnavailable = (0,_store__WEBPACK_IMPORTED_MODULE_3__/* .modalUnavailableStore */ .T)(function(store) {
        return store.show;
    });
    var ref = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), tradingType = ref.tradingType, isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading;
    var onClickBuy = function() {
        if (!tradingType) {
            showAuthModal({
                onRealLoginSuccess: function() {
                    return openBuyModal(symbol);
                },
                onVirtualLoginSuccess: function() {
                    return showModalUnavailable();
                }
            });
        } else if (isRealTrading) {
            openBuyModal(symbol);
        } else if (isVirtualTrading) {
            showModalUnavailable();
        }
    };
    return onClickBuy;
};
/* harmony default export */ __webpack_exports__["Z"] = (useOnClickBuyFR);


/***/ }),

/***/ 54855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AUTH_MODAL_CONFIG; },
/* harmony export */   "q": function() { return /* binding */ AUTH_ORDER_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var AUTH_ORDER_TYPE = {
    BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
    SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
    AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
    AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
};
var AUTH_MODAL_CONFIG = {
    real: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    },
    virtual: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_SELL */ .Jm.VIRTUAL_SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL
    }
};


/***/ }),

/***/ 24293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ showTradingModalWithAuth; }
/* harmony export */ });
/* unused harmony export getAuthModalError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11763);
/* harmony import */ var global_MainLayout_ModalErrorMessage_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5728);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34385);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70175);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54855);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4621);











var showTradingModalWithAuth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tradingModalConfig, needLoginCallback) {
        var tradingType, showAuthModal, showTradingModal, getTradingBalance, res;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tradingType = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTradingAccountType */ .Z.getTradingAccountType();
                    showAuthModal = _store__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getState */ .Z.getState().showModal;
                    showTradingModal = global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getState */ .Z.getState().showModal;
                    getTradingBalance = lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().getTradingBalance;
                    if (tradingType) {
                        _ctx.next = 8;
                        break;
                    }
                    showAuthModal(tradingModalConfig);
                    if (needLoginCallback) {
                        needLoginCallback();
                    }
                    return _ctx.abrupt("return");
                case 8:
                    if (!(tradingType === "virtual")) {
                        _ctx.next = 11;
                        break;
                    }
                    showTradingModal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, tradingModalConfig), {
                        orderType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .AUTH_MODAL_CONFIG */ .n[tradingType][tradingModalConfig.orderType]
                    }));
                    return _ctx.abrupt("return");
                case 11:
                    _ctx.next = 13;
                    return getTradingBalance();
                case 13:
                    res = _ctx.sent;
                    if (res === null || res === void 0 ? void 0 : res.aggregated_portfolio_summary) {
                        showTradingModal((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, tradingModalConfig), {
                            orderType: _constants__WEBPACK_IMPORTED_MODULE_6__/* .AUTH_MODAL_CONFIG */ .n[tradingType][tradingModalConfig.orderType]
                        }));
                    }
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function showTradingModalWithAuth(tradingModalConfig, needLoginCallback) {
        return _ref.apply(this, arguments);
    };
}();
var getAuthModalError = function(errorCode, errorType) {
    var ref;
    if (isNewCoreUser() && errorType) {
        return errorType !== "INVALID_CREDS";
    }
    var errorTradingModalConfig = tradingErrorModalList === null || tradingErrorModalList === void 0 ? void 0 : (ref = tradingErrorModalList[errorCode]) === null || ref === void 0 ? void 0 : ref[errorType];
    return !!errorTradingModalConfig;
};


/***/ }),

/***/ 20510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ModalNames; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var ModalNames;
(function(ModalNames) {
    ModalNames["COMPOSE_ERROR_LINK"] = "COMPOSE_ERROR_LINK";
    ModalNames["SECURITIES_REGISTER"] = "SECURITIES_REGISTER";
    ModalNames["STREAM_POST_LIMIT"] = "STREAM_POST_LIMIT";
})(ModalNames || (ModalNames = {}));
var useModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        activeModal: null,
        title: "",
        type: "",
        openModal: function(modalName) {
            var title = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            return set({
                activeModal: modalName,
                title: title,
                type: type
            });
        },
        closeModal: function() {
            return set({
                activeModal: null,
                title: "",
                type: ""
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useModalStore);


/***/ }),

/***/ 90506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var EVENTS = {
    navigate: "Stream Compose Setting Viewed",
    action: "Comment Management Action"
};
var ACTIONS = {
    selectSetting: "Comment Management Compose Setting Selected",
    chooseSetting: "Comment Management Choose Who Can Comment Selected",
    changeSetting: "Comment Management Change Who Can Comment Selected"
};
var DEFAULT_USER = "Author";
var CommentAnalytics = {
    Navigate: {
        ViewPage: function() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.navigate);
        }
    },
    Action: {
        CommentInfo: function() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.action, {
                Action: ACTIONS.selectSetting,
                "User Type": DEFAULT_USER
            });
        },
        ChangeComment: function() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.action, {
                Action: ACTIONS.changeSetting
            });
        },
        ChooseComment: function(selected) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.action, {
                Action: ACTIONS.chooseSetting,
                "Choose Who Can Comment": selected
            });
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (CommentAnalytics);


/***/ }),

/***/ 99093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nP": function() { return /* binding */ PAGE_SOURCE; }
/* harmony export */ });
/* unused harmony export STREAM_VIEW */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);
/* eslint-disable camelcase */ 
var STREAM_VIEW = {
    trending: {
        key: "trending",
        label: "Trending",
        arg: "trending"
    },
    following: {
        key: "following",
        label: "Followed",
        arg: "all watchlist"
    },
    latest: {
        key: "latest",
        label: "All",
        arg: "latest"
    },
    following_people: {
        key: "following_people",
        label: "People",
        arg: "people watchlist"
    },
    following_company: {
        key: "following_company",
        label: "Watchlist",
        arg: "company watchlist"
    }
};
var PAGE_SOURCE = {
    STREAM: "Stream",
    PROFILE: "Profile",
    COMPANY: "Company",
    LIKES: "Likes",
    STREAM_HOME: "Stream Home",
    COMPANY_VIEW: "Company View",
    COMPANY_PAGE: "Company Page"
};
var transformPageSource = function(pageSource) {
    switch(pageSource){
        case "Profile":
            return PAGE_SOURCE.PROFILE;
        case "Company":
            return PAGE_SOURCE.COMPANY_VIEW;
        default:
            return PAGE_SOURCE.STREAM_HOME;
    }
};
var transformExtendStream = function(pageSource) {
    if (pageSource === "Stream") {
        return PAGE_SOURCE.STREAM;
    }
    return transformPageSource(pageSource);
};
var transformExtendLikes = function(pageSource) {
    if (pageSource === "Likes") {
        return PAGE_SOURCE.LIKES;
    }
    if (pageSource === "Company") {
        return PAGE_SOURCE.COMPANY_PAGE;
    }
    return transformPageSource(pageSource);
};
var transformGetPostType = function(defaultValue, props) {
    var polling = props.polling, target_price = props.target_price, isNews = props.isnews, reposted = props.reposted;
    var isPolling = Array.isArray(polling) && polling.length > 0;
    var isPrediction = Array.isArray(target_price) && target_price.length > 0;
    var postType = defaultValue;
    if (isPolling) {
        postType = "Polling";
    } else if (isPrediction) {
        postType = "Prediction";
    } else if (isNews) {
        postType = "News";
    }
    if (reposted) {
        postType = "Repost";
    }
    return postType;
};
var transformPostLink = function(postId) {
    return(// return `${window && window.location && window.location.origin}/post/${postId}`;
    "".concat(postId));
};
var EVENTS = {
    // common
    streamTabViewed: "Stream View",
    streamPostViewed: "Stream Post Viewed",
    likeList: "Stream Likes List",
    postLike: "Stream Post Liked",
    likesViewed: "Stream Likes Viewed",
    postFollow: "Stream User Followed",
    viewProfile: "Stream View Profile",
    // share
    sharePost: "Stream Share Post",
    sharePostViewed: "Stream Share Post Viewed",
    shareMedia: "Stream Post Shared",
    shareMoreSelected: "Stream Share More Selected",
    shareMoreViewed: "Stream Share More Viewed",
    shareCopyLink: "Stream Copy Link Post Selected",
    shareCopyLinkViewed: "Stream Link Post Copied",
    shareRepostSelected: "Stream Repost Stream",
    shareRepostViewed: "Stream Repost Viewed",
    shareRepostCanceled: "Stream Post Canceled",
    shareRepostSend: "Stream Reposted",
    shareSearch: "Stream Search User Filled",
    shareSearchViewed: "Stream Search User Result Viewed",
    // tipping
    tipButtonClicked: "Stream Tip Post",
    tipModalViewed: "Stream Tip Viewed",
    tipAmountFilled: "Stream Tip Amount Selected",
    tipMessageFilled: "Stream Message Filled",
    tipSubmitted: "Stream Tip Submitted",
    // comments
    commentClicked: "Stream Comment",
    commentViewed: "Stream Comments Viewed",
    commentFilled: "Stream Comment Filled",
    commentSubmitted: "Stream Comment Submitted",
    // ideas
    ideasViewed: "Ideas Viewed",
    // reports
    reportsViewed: "Reports Viewed",
    reportsClicked: "Reports Clicked",
    reportsOpened: "Reports Detail Opened",
    reportCompanyClicked: "Report Company Selected",
    reportDownloaded: "Report Downloaded",
    // predictions
    predictionsViewed: "Predictions Viewed",
    predictionsVoted: "Predictions Voted",
    predictionsBuySelected: "Predictions Buy Stock Selected",
    // insiders
    insidersViewed: "Insiders Viewed",
    // charts
    chartsViewed: "Chart Viewed",
    chartImageClicked: "Chart Image Opened",
    chartImageViewed: "Chart Image Viewed"
};
var getLastStreamView = function() {
    return localStorage.getItem("stbx-active-stream");
};
var getLastStreamViewFilter = function() {
    return localStorage.getItem("stbx-active-stream-filter");
};
var StreamTabAnalytics = {
    common: {
        View: {
            onStreamViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.streamTabViewed);
            },
            onPostViewed: function(param) {
                var pageSource = param.pageSource, username = param.username, likes = param.likes, comment = param.comment, postid = param.postid, polling = param.polling, target_price = param.target_price, isnews = param.isnews, reposted = param.reposted;
                var activeFilter = getLastStreamView();
                var activeTab = getLastStreamViewFilter();
                var page = transformExtendStream(pageSource);
                var streamFilter = page === PAGE_SOURCE.STREAM && activeTab === "ideas" ? STREAM_VIEW[activeFilter].label : "All";
                var sendData = {
                    "Stream Filter": streamFilter,
                    "Page Source": page,
                    Username: username,
                    Likes: likes,
                    Comments: Number(comment) !== undefined ? Number(comment) : comment,
                    "Stream ID": transformPostLink(postid),
                    "Post Type": transformGetPostType("Ideas", {
                        polling: polling,
                        target_price: target_price,
                        isnews: isnews,
                        reposted: reposted
                    })
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.streamPostViewed, sendData);
            },
            onLikesViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.likesViewed);
            },
            onShareModalViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.sharePostViewed);
            },
            onTabChanged: function(tabName) {
                if (tabName === "Polling") {
                    return;
                }
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("".concat(tabName, " Menu Selected"));
            },
            onLoadMore: function(tabName) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("".concat(tabName, " Load More"));
            }
        },
        Action: {
            clickLikeInscription: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.likeList);
            },
            clickLikeButton: function(pageSource) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.postLike, {
                    "Page Source": transformPageSource(pageSource)
                });
            },
            clickFollowButton: function(pageSource) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.postFollow, {
                    "Page Source": transformExtendLikes(pageSource)
                });
            },
            clickProfile: function(pageSource) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.viewProfile, {
                    "Page Source": transformExtendLikes(pageSource)
                });
            },
            clickShareButton: function(pageSource) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.sharePost, {
                    "Page Source": transformPageSource(pageSource)
                });
            },
            selectShareMedia: function(param) {
                var media = param.media, pageSource = param.pageSource, postid = param.postid, polling = param.polling, target_price = param.target_price, isnews = param.isnews, reposted = param.reposted;
                var sendData = {
                    Media: media,
                    "Page Source": transformPageSource(pageSource),
                    "Stream ID": transformPostLink(postid),
                    "Post Type": transformGetPostType("Normal", {
                        polling: polling,
                        target_price: target_price,
                        isnews: isnews,
                        reposted: reposted
                    })
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareMedia, sendData);
            },
            clickMoreShare: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareMoreSelected);
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareMoreViewed);
            },
            selectCopyLink: function(param) {
                var pageSource = param.pageSource, username = param.username, postid = param.postid, polling = param.polling, target_price = param.target_price, isnews = param.isnews, reposted = param.reposted;
                var sendData = {
                    "Page Source": transformPageSource(pageSource),
                    Username: username,
                    "Post Type": transformGetPostType("Normal", {
                        polling: polling,
                        target_price: target_price,
                        isnews: isnews,
                        reposted: reposted
                    }),
                    "Stream ID": transformPostLink(postid)
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareCopyLink, sendData);
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareCopyLinkViewed);
            },
            selectRepost: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareRepostSelected);
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareRepostViewed);
            },
            selectCancelRepost: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareRepostCanceled);
            },
            selectSendRepost: function(param) {
                var pageSource = param.pageSource, postid = param.postid, polling = param.polling, target_price = param.target_price, isnews = param.isnews, reposted = param.reposted;
                var sendData = {
                    "Page Source": transformPageSource(pageSource),
                    "Post Type": transformGetPostType("Normal", {
                        polling: polling,
                        target_price: target_price,
                        isnews: isnews,
                        reposted: reposted
                    }),
                    "Stream ID": transformPostLink(postid)
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareRepostSend, sendData);
            },
            selectSearch: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareSearch);
            },
            selectSearchResult: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.shareSearchViewed);
            },
            clickTipping: function(param) {
                var pageSource = param.pageSource, streamId = param.streamId, userId = param.userId;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.tipButtonClicked, {
                    "Page Source": transformPageSource(pageSource),
                    "Stream ID": transformPostLink(streamId),
                    "Recipient User id": transformPostLink(userId)
                });
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.tipModalViewed, {
                    "Stream ID": transformPostLink(streamId),
                    "Recipient User id": transformPostLink(userId)
                });
            },
            clickTippingAmount: function(param) {
                var streamId = param.streamId, userId = param.userId;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.tipAmountFilled, {
                    "Stream ID": transformPostLink(streamId),
                    "Recipient User id": transformPostLink(userId)
                });
            },
            changeTippingMessage: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.tipMessageFilled);
            },
            clickSubmitTip: function(param) {
                var pageSource = param.pageSource, amount = param.amount, message = param.message, postid = param.postid, username = param.username, userId = param.userId;
                var sendData = {
                    "Page Source": transformPageSource(pageSource),
                    Amount: amount,
                    Message: message,
                    "Stream ID": transformPostLink(postid),
                    Username: username,
                    "Recipient User id": transformPostLink(userId)
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.tipSubmitted, sendData);
            },
            clickComment: function(param) {
                var pageSource = param.pageSource, username = param.username, postid = param.postid, likes = param.likes;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.commentClicked, {
                    "Page Source": transformExtendStream(pageSource)
                });
                var viewData = {
                    "Page Source": transformPageSource(pageSource),
                    Username: username,
                    Likes: likes,
                    "Stream ID": transformPostLink(postid)
                };
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.commentViewed, viewData);
            },
            changeComment: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.commentFilled);
            },
            clickSubmitComment: function(pageSource) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.commentSubmitted, {
                    "Page Source": transformPageSource(pageSource)
                });
            }
        }
    },
    ideas: {
        View: {
            onIdeasViewed: function(filter) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.ideasViewed, {
                    Filter: filter
                });
            }
        }
    },
    reports: {
        View: {
            onReportsViewed: function(filter) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.reportsViewed, {
                    Filter: filter
                });
            }
        },
        Action: {
            onReportClicked: function(param) {
                var postid = param.postid, title = param.title;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.reportsClicked, {
                    "Stream ID": transformPostLink(postid),
                    "Reports Name": title
                });
            },
            onReportOpened: function(param) {
                var postid = param.postid, title = param.title;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.reportsOpened, {
                    "Stream ID": transformPostLink(postid),
                    "Reports Name": title
                });
            },
            onReportCompanyClicked: function(param) {
                var symbol = param.symbol;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.reportCompanyClicked, {
                    Stock: symbol
                });
            },
            onReportDownloaded: function(param) {
                var fileName = param.fileName;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.reportDownloaded, {
                    "File Name": fileName
                });
            }
        }
    },
    predictions: {
        View: {
            onPredictionsViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.predictionsViewed);
            }
        },
        Action: {
            onPredictionVoted: function(param) {
                var vote = param.vote, symbol = param.symbol, targetPrice = param.targetPrice, initialPrice = param.initialPrice, upside = param.upside, timing = param.timing, postid = param.postid;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.predictionsVoted, {
                    Vote: vote,
                    Symbol: symbol,
                    "Target Price": targetPrice,
                    "Initial Price": initialPrice,
                    Upside: upside,
                    Timing: timing,
                    "Stream ID": transformPostLink(postid)
                });
            },
            onPredictionBuy: function(param) {
                var postid = param.postid, symbol = param.symbol;
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.predictionsBuySelected, {
                    "Stream ID": transformPostLink(postid),
                    Symbol: symbol
                });
            }
        }
    },
    insiders: {
        View: {
            onInsidersViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.insidersViewed);
            }
        }
    },
    charts: {
        View: {
            onChartsViewed: function() {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chartsViewed);
            }
        },
        Action: {
            onChartsImageClicked: function(postid) {
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chartImageClicked, {
                    "Stream ID": transformPostLink(postid)
                });
                (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENTS.chartImageViewed, {
                    "Stream ID": transformPostLink(postid)
                });
            }
        }
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (StreamTabAnalytics);


/***/ }),

/***/ 52579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImageSlider_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/ImageSlider/Modal/styled.ts
/* eslint-disable import/prefer-default-export */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 100%;\n  max-width: 100%;\n  height: auto;\n  @media ",
        " {\n    max-height: 767px;\n    max-width: 1389px;\n    height: auto;\n    width: auto;\n  }\n  vertical-align: middle;\n  display: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 0px !important;\n  margin: 0;\n  max-width: unset;\n  .ant-modal-content {\n    position: unset;\n    background-color: transparent;\n    box-shadow: none;\n  }\n  .ant-modal-body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  border-radius: 50%;\n  padding: 10px;\n  border: none;\n  cursor: pointer;\n  background: ",
        "",
        ";\n\n  p {\n    font-size: 19.5px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 50%;\n  border-radius: 50%;\n  padding: 10px;\n  border: none;\n  cursor: pointer;\n  background: ",
        "",
        ";\n  right: ",
        ";\n  left: ",
        ";\n\n  p {\n    font-size: 19.5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var ImageItem = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-a5e8a49-0"
})(_templateObject(), device/* default.tablet */.Z.tablet, function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, color/* default.light */.Z.light);
var ModalImage = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-a5e8a49-1"
})(_templateObject1());
var CloseIconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a5e8a49-2"
})(_templateObject2(), color/* default.black */.Z.black, (0,hexOpacity/* default */.Z)(45));
var ActionIconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a5e8a49-3"
})(_templateObject3(), color/* default.black */.Z.black, (0,hexOpacity/* default */.Z)(45), function(param) {
    var position = param.position;
    return position === "left" ? "unset" : "20px";
}, function(param) {
    var position = param.position;
    return position === "left" ? "20px" : "unset";
});


;// CONCATENATED MODULE: ./src/global/ImageSlider/Modal/SliderButton.tsx





function SliderButton(param) {
    var type = param.type, onClick = param.onClick;
    var position = type === "next" ? "right" : "left";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIconWrapper, {
        position: position,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
            className: "icon-toolbar_".concat(type),
            color: color/* default.light */.Z.light,
            hoverColor: color/* default.light */.Z.light
        })
    });
}
/* harmony default export */ var Modal_SliderButton = (SliderButton);

;// CONCATENATED MODULE: ./src/global/ImageSlider/Modal/index.tsx






function ModalImageSlider(param) {
    var images = param.images, visible = param.visible, onClose = param.onClose, active = param.active, setActive = param.setActive;
    if (images.length === 0) {
        return null;
    }
    var hasNextButton = active < images.length - 1;
    var hasPrevButton = active > 0;
    var handleNext = function() {
        setActive(active + 1);
    };
    var handlePrev = function() {
        setActive(active - 1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalImage, {
        centered: true,
        closable: true,
        footer: null,
        visible: visible,
        onCancel: onClose,
        style: {
            position: "unset"
        },
        destroyOnClose: true,
        transitionName: "",
        maskTransitionName: "",
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconWrapper, {
            onClick: onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                className: "icon-compose_close",
                color: color/* default.light */.Z.light
            })
        }),
        maskStyle: {
            backgroundColor: "rgba(18,18,18,0.7)"
        },
        maskClosable: true,
        children: [
            hasPrevButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SliderButton, {
                type: "prev",
                onClick: handlePrev
            }),
            images.map(function(image, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageItem, {
                    visible: i === active,
                    alt: "stream image",
                    src: image
                });
            }),
            hasNextButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SliderButton, {
                type: "next",
                onClick: handleNext
            })
        ]
    });
}
/* harmony default export */ var ImageSlider_Modal = (ModalImageSlider);


/***/ }),

/***/ 9649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_ImageSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/global/ImageSlider/Modal/index.tsx + 2 modules
var Modal = __webpack_require__(52579);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/ImageSlider/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    aspect-ratio: 1;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    aspect-ratio: 0.8;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    aspect-ratio: 1.78;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 888px;\n      width: 100%;\n      max-width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 888px;\n      width: 100%;\n      height: max-content;\n      max-width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 697.5px;\n      width: 100%;\n      max-width: 100%;\n      height: fit-content;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 697.5px;\n      width: 100%;\n      max-width: 100%;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 100%;\n      width: auto;\n      max-width: 100%;\n      height: auto;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 100%;\n      /* height: auto; */\n      max-width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      max-width: 100%;\n      width: 100%;\n      object-fit: cover;\n      height: 100%;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      width: 100%;\n      object-fit: fill;\n      height: 100%;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 697.5px;\n      width: auto;\n      max-width: 100%;\n      /* height: 100%; */\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: 431.25px;\n      width: auto;\n      max-width: 100%;\n      object-fit: fill;\n      height: 100%;\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      width: 100%;\n      max-width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-height: max-content;\n      width: 100%;\n      max-width: 100%;\n      object-fit: fill;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n  border-radius: 3px;\n  ",
        ";\n\n  width: calc(100% + 40px);\n  left: -20px;\n  @media ",
        " {\n    width: 100%;\n    left: unset;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: max-content;\n  ",
        "\n  /* background: ",
        "; */\n\n  width: calc(100% + 40px);\n  left: -20px;\n  @media ",
        " {\n    width: unset;\n    left: unset;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: fill;\n  ",
        "\n  display: ",
        ";\n  aspect-ratio: ",
        ";\n  background: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 200px;\n      width: auto;\n      max-width: 100%;\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: fill;\n  object-position: 50% 50%;\n  border-radius: 3px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  position: absolute;\n  top: 50%;\n  border-radius: 50%;\n  padding: 2px;\n  border: none;\n  cursor: pointer;\n  background: ",
        ";\n  right: ",
        ";\n  left: ",
        ";\n  opacity: 0.8;\n\n  p {\n    font-size: 19.5px;\n    color: ",
        ";\n    padding: 4.5px;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  opacity: 0.8;\n  border-radius: 12px;\n  height: 24px;\n  width: 34px;\n  position: absolute;\n  right: 12px;\n  top: 12px;\n  padding: 4px 8px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-inline-start: 0;\n  text-align: center;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid #00ab6b;\n      background-color: #00ab6b;\n      width: 16px;\n      height: 4px;\n      border-radius: 20px;\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-block;\n  margin-right: 6px;\n\n  border: 1px solid #ededed;\n  width: 4px;\n  height: 4px;\n  border-radius: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}



var FrameStyle = {
    FRAME_TYPE_SQUARE: (0,styled_components_browser_esm/* css */.iv)(_templateObject()),
    FRAME_TYPE_PORTRAIT: (0,styled_components_browser_esm/* css */.iv)(_templateObject1()),
    FRAME_TYPE_LANDSCAPE: (0,styled_components_browser_esm/* css */.iv)(_templateObject2())
};
var ImageItemStyle = {
    FRAME_TYPE_SQUARE: {
        FRAME_TYPE_LANDSCAPE: (0,styled_components_browser_esm/* css */.iv)(_templateObject3()),
        FRAME_TYPE_SQUARE: (0,styled_components_browser_esm/* css */.iv)(_templateObject4()),
        FRAME_TYPE_PORTRAIT: (0,styled_components_browser_esm/* css */.iv)(_templateObject5())
    },
    FRAME_TYPE_PORTRAIT: {
        FRAME_TYPE_LANDSCAPE: (0,styled_components_browser_esm/* css */.iv)(_templateObject6()),
        FRAME_TYPE_SQUARE: (0,styled_components_browser_esm/* css */.iv)(_templateObject7()),
        FRAME_TYPE_PORTRAIT: (0,styled_components_browser_esm/* css */.iv)(_templateObject8())
    },
    FRAME_TYPE_LANDSCAPE: {
        FRAME_TYPE_LANDSCAPE: (0,styled_components_browser_esm/* css */.iv)(_templateObject9()),
        FRAME_TYPE_SQUARE: (0,styled_components_browser_esm/* css */.iv)(_templateObject10()),
        FRAME_TYPE_PORTRAIT: (0,styled_components_browser_esm/* css */.iv)(_templateObject11())
    }
};
var ImageStyle = {
    FRAME_TYPE_UNSPECIFIED: {
        post: (0,styled_components_browser_esm/* css */.iv)(_templateObject12()),
        comment: (0,styled_components_browser_esm/* css */.iv)(_templateObject13())
    },
    FRAME_TYPE_SQUARE: {
        post: (0,styled_components_browser_esm/* css */.iv)(_templateObject14()),
        comment: (0,styled_components_browser_esm/* css */.iv)(_templateObject15())
    },
    FRAME_TYPE_PORTRAIT: {
        post: (0,styled_components_browser_esm/* css */.iv)(_templateObject16()),
        comment: (0,styled_components_browser_esm/* css */.iv)(_templateObject17())
    },
    FRAME_TYPE_LANDSCAPE: {
        post: (0,styled_components_browser_esm/* css */.iv)(_templateObject18()),
        comment: (0,styled_components_browser_esm/* css */.iv)(_templateObject19())
    }
};
var ContainerImages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90d30bd6-0"
})(_templateObject20(), color/* default.downgray */.Z.downgray, function(param) {
    var frameType = param.frameType;
    return FrameStyle[frameType];
}, device/* default.tablet */.Z.tablet);
var ContainerImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90d30bd6-1"
})(_templateObject22(), function(param) {
    var isGif = param.isGif;
    return isGif && (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), color/* default.downgray */.Z.downgray);
}, color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet);
var ImageItem = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    loading: "lazy"
}).withConfig({
    componentId: "sc-90d30bd6-2"
})(_templateObject23(), function(param) {
    var imageFrameType = param.imageFrameType, frameType = param.frameType;
    return ImageItemStyle[frameType][imageFrameType];
}, function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, function(param) {
    var ratio = param.ratio;
    return ratio || "unset";
}, color/* default.light */.Z.light);
var ImageSingle = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    loading: "lazy"
}).withConfig({
    componentId: "sc-90d30bd6-3"
})(_templateObject25(), function(param) {
    var imageFrameType = param.imageFrameType, mode = param.mode;
    return ImageStyle[imageFrameType][mode];
}, function(param) {
    var isGif = param.isGif;
    return isGif && (0,styled_components_browser_esm/* css */.iv)(_templateObject24());
});
var ActionIconWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-90d30bd6-4"
})(_templateObject26(), function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, color/* default.component */.Z.component, function(param) {
    var position = param.position;
    return position === "left" ? "unset" : "10px";
}, function(param) {
    var position = param.position;
    return position === "left" ? "10px" : "unset";
}, color/* default.dimgray */.Z.dimgray);
var CounterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-90d30bd6-5"
})(_templateObject27(), color/* default.component */.Z.component);
var SliderFooterContainer = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-90d30bd6-6"
})(_templateObject28());
var SliderDot = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-90d30bd6-7"
})(_templateObject30(), function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm/* css */.iv)(_templateObject29());
});


;// CONCATENATED MODULE: ./src/global/ImageSlider/utils.ts
/* eslint-disable array-callback-return */ var decideFrameType = function(images) {
    var potrait = 0;
    var square = 0;
    images.map(function(image) {
        if (image.frame_type === "FRAME_TYPE_PORTRAIT") {
            potrait += 1;
        } else if (image.frame_type === "FRAME_TYPE_SQUARE") {
            square += 1;
        }
    });
    if (potrait > 0) {
        return "FRAME_TYPE_PORTRAIT";
    }
    if (square > 0) {
        return "FRAME_TYPE_SQUARE";
    }
    return "FRAME_TYPE_LANDSCAPE";
};
var getFileExtension = function(url) {
    var exts = url.split(".");
    if (exts.length > 1) {
        return exts.pop();
    }
    return "";
};


;// CONCATENATED MODULE: ./src/global/ImageSlider/SingleImage.tsx




function SingleImage(param) {
    var image = param.image, onClick = param.onClick, isLoggedIn = param.isLoggedIn, mode = param.mode;
    var extension = getFileExtension(image.image);
    var isGifExt = extension.toLowerCase().includes("gif");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerImage, {
        isGif: isGifExt,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isLoggedIn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSingle, {
                    src: image.image,
                    imageFrameType: image.frame_type || "FRAME_TYPE_UNSPECIFIED",
                    isGif: isGifExt,
                    onClick: onClick,
                    mode: mode
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !isLoggedIn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSingle, {
                    src: image.image,
                    imageFrameType: "FRAME_TYPE_UNSPECIFIED",
                    isGif: isGifExt,
                    onClick: onClick,
                    mode: "post"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/ImageSlider/SliderNavigation.tsx





function SliderNavigation(param) {
    var type = param.type, visible = param.visible, onClick = param.onClick;
    var position = type === "next" ? "right" : "left";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIconWrapper, {
        type: "button",
        position: position,
        onClick: function(e) {
            e.stopPropagation();
            onClick();
        },
        visible: visible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
            className: "icon-toolbar_".concat(type),
            color: color/* default.light */.Z.light,
            hoverColor: color/* default.dimgray */.Z.dimgray
        })
    });
}
/* harmony default export */ var ImageSlider_SliderNavigation = (/*#__PURE__*/(0,react.memo)(SliderNavigation));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
;// CONCATENATED MODULE: ./src/global/ImageSlider/ImagesCounter.tsx



function ImagesCounter(param) {
    var current = param.current, total = param.total;
    if (total === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CounterContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "12px",
            height: "135%",
            weight: "400",
            children: [
                current + 1,
                "/",
                total
            ]
        })
    });
}
/* harmony default export */ var ImageSlider_ImagesCounter = (ImagesCounter);

;// CONCATENATED MODULE: ./src/global/ImageSlider/SliderFooter.tsx



function SliderFooter(param) {
    var current = param.current, total = param.total, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderFooterContainer, {
        children: Array.from(Array(total).keys()).map(function(__dat, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDot, {
                active: index === current,
                onClick: function() {
                    return onClick(index);
                }
            });
        })
    });
}
/* harmony default export */ var ImageSlider_SliderFooter = (/*#__PURE__*/(0,react.memo)(SliderFooter));

;// CONCATENATED MODULE: ./src/global/ImageSlider/MultipleImage.tsx







function MultipleImage(param) {
    var images = param.images, active = param.active, frameType = param.frameType, isSinglePost = param.isSinglePost, setActive = param.setActive, onClick = param.onClick;
    var hasNextButton = active < images.length - 1;
    var hasPrevButton = active > 0;
    var handleNext = function() {
        setActive(active + 1);
    };
    var handlePrev = function() {
        setActive(active - 1);
    };
    var imageFrameType = frameType !== "FRAME_TYPE_UNSPECIFIED" ? frameType : decideFrameType(images);
    var generateCustomStyle = function(image) {
        var style = {};
        if (image.frame_type === "FRAME_TYPE_LANDSCAPE") {
            if (image.ratio < 1.78 && imageFrameType === "FRAME_TYPE_LANDSCAPE") {
                style.width = "max-content";
                style.height = "100%";
            }
        }
        if (image.frame_type === "FRAME_TYPE_PORTRAIT") {
            style.width = "auto";
            if (image.ratio <= 0.8) {
                style.height = "100%";
            }
            if (image.ratio > 0.8) {
                style.width = "100%";
            }
        }
        if (image.frame_type === "FRAME_TYPE_SQUARE") {
            if (image.ratio < 1 && imageFrameType === "FRAME_TYPE_SQUARE") {
                style.width = "max-content";
                style.height = "100%";
            }
        }
        // unspecified, ratio = 0
        if (image.frame_type === "FRAME_TYPE_UNSPECIFIED") {
            style.width = "max-content";
            style.height = "100%";
        }
        if (isSinglePost) {
            style.maxHeight = "auto";
        }
        return style;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerImages, {
                frameType: imageFrameType,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_ImagesCounter, {
                        current: active,
                        total: images.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_SliderNavigation, {
                        type: "prev",
                        visible: hasPrevButton,
                        onClick: handlePrev
                    }),
                    images.map(function(image, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ImageItem, {
                            visible: active === i,
                            src: image.image,
                            alt: "tes",
                            imageFrameType: image.frame_type,
                            frameType: imageFrameType,
                            ratio: image === null || image === void 0 ? void 0 : image.ratio,
                            onClick: onClick,
                            style: generateCustomStyle(image)
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_SliderNavigation, {
                        type: "next",
                        visible: hasNextButton,
                        onClick: handleNext
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider_SliderFooter, {
                current: active,
                total: images.length,
                onClick: setActive
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/ImageSlider/index.tsx








function ImageSlider(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images, frameType = param.frameType, _clickable = param.clickable, clickable = _clickable === void 0 ? true : _clickable, _mode = param.mode, mode = _mode === void 0 ? "post" : _mode, _isRepost = param.isRepost, isRepost = _isRepost === void 0 ? false : _isRepost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    if ((images === null || images === void 0 ? void 0 : images.length) === 0) return null;
    var imageUrls = images.map(function(image) {
        return image.image;
    });
    var onClick = function() {
        if (isRepost) {
            return;
        }
        if (isLoggedIn) {
            if (clickable) {
                setShowModal(true);
            }
        } else {
            router.push("/register");
        }
    };
    var onCloseModal = function() {
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            images.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleImage, {
                image: images[0],
                onClick: onClick,
                isLoggedIn: isLoggedIn,
                mode: mode
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MultipleImage, {
                images: images,
                active: active,
                frameType: frameType,
                isSinglePost: isSinglePost,
                onClick: onClick,
                setActive: setActive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                images: imageUrls,
                visible: showModal,
                onClose: onCloseModal,
                active: active,
                setActive: setActive
            })
        ]
    });
}
/* harmony default export */ var global_ImageSlider = (ImageSlider);


/***/ }),

/***/ 5728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ tradingErrorModalList; },
/* harmony export */   "c0": function() { return /* binding */ tradingErrorModalConfig; },
/* harmony export */   "qO": function() { return /* binding */ errorInfoList; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var errorInfoList = [
    {
        error: 401,
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama",
        isLogoutUser: true
    },
    {
        error: 500,
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        isShowButton: true,
        buttonText: "Tutup"
    },
    {
        error: 503,
        imageUrl: "/img/maintenance-mode.svg",
        title: "Maintenance Sedang Berlangsung",
        description: "Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama"
    }, 
];
var tradingErrorModalConfig = {
    sessionExpired: {
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: true,
        isLogoutUser: true
    },
    maintenance: {
        imageUrl: "/img/maintenance-mode.svg",
        title: "Pemeliharaan Sedang Berlangsung",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    dailyMaintenance: {
        imageUrl: "/img/daily-maintenance.svg",
        title: "Persiapan Harian",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    systemError: {
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        buttonText: "Tutup",
        isShowButton: true
    },
    userSuspend: {
        imageUrl: "/img/trading-limit-user-suspended.svg",
        title: "Tidak Dapat Melakukan Transaksi",
        description: "Deposit atau jual saham untuk melakukan transaksi.",
        buttonText: "Deposit Sekarang",
        isShowButton: true,
        redirectTo: "/securities/deposit",
        needToCloseTradingModal: true,
        isFullWidthButton: true
    }
};
var tradingErrorModalList = {
    401: {
        NO_SERVER_RESPONSE: "sessionExpired",
        INVALID_AUTH: "sessionExpired",
        // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
        INVALID_TOKEN: "sessionExpired",
        INVALID_SESSION: "sessionExpired",
        MOCK_TRADING: "sessionExpired",
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance",
        UNAUTHORIZED: "sessionExpired"
    },
    403: {
        USER_SUSPEND: "userSuspend",
        USER_SUSPEND_BACK_OFFICE: "userSuspend"
    },
    503: {
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance"
    },
    500: {
        SYSTEM_ERROR: "systemError"
    }
};


/***/ }),

/***/ 33722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37213);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2497);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42227);
/* harmony import */ var lib_entities_watchlist__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14675);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(579);
/* harmony import */ var global_Labels__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94493);
/* harmony import */ var features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63576);
/* harmony import */ var global_Common_If__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3897);


















function UserItem(param) {
    var pageSource = param.pageSource, pageSourceIndex = param.pageSourceIndex, user = param.user, activeUserId = param.activeUserId, onSuccessFollowUnfollow = param.onSuccessFollowUnfollow;
    var avatar = user.avatar, username = user.username, fullname = user.fullname, id = user.id, followed = user.is_followed, is_verified = user.is_verified;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_10__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(Boolean(followed)), isFollowed = ref[0], setFollowed = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var handleFollowUser = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var type, data, toggleFollow, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = !isFollowed ? "FOLLOW" : "UNFOLLOW";
                        data = {
                            userid: id,
                            type: type
                        };
                        setIsLoading(true);
                        _ctx.next = 5;
                        return dispatch(lib_entities_watchlist__WEBPACK_IMPORTED_MODULE_12__/* .effects.followUser */ .Sz.followUser(data));
                    case 5:
                        toggleFollow = _ctx.sent;
                        error = toggleFollow.payload.error;
                        if (toggleFollow) {
                            setIsLoading(false);
                            if (!error) {
                                setFollowed(!isFollowed);
                                onSuccessFollowUnfollow === null || onSuccessFollowUnfollow === void 0 ? void 0 : onSuccessFollowUnfollow();
                            }
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollowUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var buttonType = isFollowed ? "default" : "outline-primary";
    var followingText = isFollowed ? "Following" : "Follow";
    var avatarUrl = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith("http")) ? avatar : "".concat(constants_api__WEBPACK_IMPORTED_MODULE_7__/* .AVATAR_URL */ .q$, "/").concat(avatar);
    return(// @ts-expect-error
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        align: "center",
        justify: "space-between",
        py: "10px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                mr: "20px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        size: "small",
                        mr: "16px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            src: avatarUrl,
                            onError: function(e) {
                                return (0,utils_general__WEBPACK_IMPORTED_MODULE_11__/* .handleErrorAvatar */ .Tk)(e, username);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: "/".concat(username, "?source=").concat(String(pageSourceIndex)),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            as: "a",
                                            onClick: function() {
                                                return features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_15__/* .mainProfileEvents.onViewProfile */ .j4.onViewProfile(pageSource);
                                            },
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            size: "16px",
                                            color: "#333333 !important",
                                            children: username
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        align: "center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Labels__WEBPACK_IMPORTED_MODULE_14__/* .LabelVerifiedAccount */ .uC, {
                                            deprecatedVerifiedStatus: is_verified
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                size: "16px",
                                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray,
                                children: fullname
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Common_If__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                condition: activeUserId !== Number(id),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    type: buttonType,
                    height: "32px",
                    width: "100px",
                    onClick: handleFollowUser,
                    style: {
                        flexShrink: "0"
                    },
                    loading: isLoading,
                    radius: "4px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        family: "bold",
                        color: "inherit",
                        children: followingText
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_9__.memo)(UserItem));


/***/ }),

/***/ 10738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ UserItemContainer; },
/* harmony export */   "x": function() { return /* binding */ ModalFollowSearchInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47756);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 40px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  border: 1px solid transparent;\n  box-shadow: unset !important;\n\n  &:hover,\n  &:focus {\n    border-color: transparent !important;\n  }\n\n  input {\n    background-color: ",
        ";\n    &::placeholder,\n    &::-webkit-input-placeholder {\n      font-weight: 700;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px -20px 0;\n  padding: 0 20px;\n  height: calc(100% - 80px);\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ModalFollowSearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73b23ad4-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].snow */ .Z.snow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].snow */ .Z.snow);
var UserItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-73b23ad4-1"
})(_templateObject1());


/***/ }),

/***/ 31359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yC": function() { return /* reexport */ Modals_ModalBlockUnblockUser; },
  "y2": function() { return /* reexport */ Modals_ModalBlockUser; },
  "ZZ": function() { return /* reexport */ ModalFollow_ModalFollower; },
  "Mw": function() { return /* reexport */ ModalFollow_ModalFollowing; },
  "uF": function() { return /* reexport */ Modals_ModalShareIdea; },
  "qb": function() { return /* reexport */ Modals_ModalSuspendUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/moderation.js
var moderation = __webpack_require__(56214);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/styled.js
var styled = __webpack_require__(74673);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalBlockUser.jsx















function ModalBlockUser(_param) {
    var username = _param.username, userId = _param.userId, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "onCancel"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /**
   * @param {Event} e
   */ var handleBlock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var block, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.stopPropagation();
                        _ctx.next = 3;
                        return dispatch(moderation/* effects.blockUser */.Sz.blockUser(userId));
                    case 3:
                        block = _ctx.sent;
                        error = block.payload.error;
                        queryClient.invalidateQueries();
                        if (!error) {
                            onCancel(e);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleBlock(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "16px",
            height: "40px",
            weight: "bold",
            color: color/* default.black */.Z.black,
            children: "Block User"
        }),
        centered: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                type: "primary",
                height: "40px",
                margin: "0px !important",
                onClick: handleBlock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    color: color/* default.light */.Z.light,
                    children: "Block"
                })
            }, "confirm"), 
        ],
        width: 432,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            align: "center",
            children: [
                "You are about to block ",
                username,
                ". Do you want to proceed?"
            ]
        })
    }));
}
ModalBlockUser.propTypes = {
    username: (prop_types_default()).string.isRequired,
    userId: (prop_types_default()).number.isRequired,
    onCancel: (prop_types_default()).func
};
ModalBlockUser.defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel: function() {}
};
function ModalBlockWithQuery(_param) {
    var username = _param.username, userId = _param.userId, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "onCancel"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBlockUser, (0,_object_spread/* default */.Z)({
            username: username,
            userId: userId,
            onCancel: onCancel
        }, props))
    });
}
/* harmony default export */ var Modals_ModalBlockUser = (ModalBlockWithQuery);

// EXTERNAL MODULE: ./src/global/StreamCompose/index.tsx + 25 modules
var StreamCompose = __webpack_require__(76897);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/user/analytics/ProfileAnalytics.ts
var ProfileAnalytics = __webpack_require__(63576);
// EXTERNAL MODULE: ./src/utils/streamError.ts
var streamError = __webpack_require__(6426);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalShareIdea.tsx
















function ModalShareIdea(_param) {
    var visible = _param.visible, username = _param.username, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "visible",
        "username",
        "onCancel"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(entities_stream/* selectors */.wl), isLoading = ref.composeStream.isLoading;
    var initialValues = (0,stream/* parseStreamPostContent */.vO)({
        content_original: "@".concat(username, " ")
    });
    var handleSharePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var compose, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(entities_stream/* effects.postStream */.Sz.postStream(val));
                    case 2:
                        compose = _ctx.sent;
                        error = compose.payload.error;
                        (0,streamError/* handleErrorPostStream */.R)(error);
                        if (!error) {
                            onCancel();
                        }
                        return _ctx.abrupt("return", error);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSharePost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (visible) ProfileAnalytics/* mainProfileEvents.onComposePostViewed */.j4.onComposePostViewed();
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        visible: visible,
        // @ts-expect-error
        noBorder: true,
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            height: "44px",
            align: "center",
            family: "bold",
            children: "Share an Idea"
        }),
        footer: null,
        centered: true,
        bodyStyle: {
            padding: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose/* default */.Z, {
            mode: constants/* COMPOSE_MODE.SHARE */.ZX.SHARE,
            initialValues: initialValues,
            isLoading: isLoading,
            onSubmit: handleSharePost,
            onCancel: onCancel
        })
    }));
}
/* harmony default export */ var Modals_ModalShareIdea = (ModalShareIdea);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/hooks/useForm.js
var useForm = __webpack_require__(15077);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var StreamWidget_constants = __webpack_require__(21390);
;// CONCATENATED MODULE: ./src/global/Moderation/constants.js
var BLOCK_TYPES = [
    {
        key: 2,
        label: "Mute"
    },
    {
        key: 4,
        label: "Mute Chat"
    },
    {
        key: 5,
        label: "Mute All"
    }, 
];
var BLOCK_NO_VOTE = {
    key: 3,
    label: "No Vote"
};
var reportOptions = [
    {
        key: "1",
        label: "Improper Use of $ Tag"
    },
    {
        key: "2",
        label: "Incorrect Writing Standard"
    },
    {
        key: "3",
        label: "Advertising"
    },
    {
        key: "4",
        label: "Junk Post"
    },
    {
        key: "5",
        label: "Spam"
    },
    {
        key: "6",
        label: "Out of Topic"
    },
    {
        key: "7",
        label: "Vulgarity"
    },
    {
        key: "8",
        label: "Abusive Behaviour"
    },
    {
        key: "9",
        label: "Provoking Other Users"
    },
    {
        key: "10",
        label: "Inapropriate Username & Photo"
    },
    {
        key: "11",
        label: "Stocks Cheering"
    }, 
];
var BLOCK_DURATION = [
    {
        label: "1 day",
        value: "1"
    },
    {
        label: "3 days",
        value: "3"
    },
    {
        label: "7 days",
        value: "7"
    },
    {
        label: "Indefinitely",
        value: "0"
    }, 
];


;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalSuspendUser.jsx























function ModalSuspendUser(_param) {
    var username = _param.username, userId = _param.userId, postId = _param.postId, onCancel = _param.onCancel, onSubmit = _param.onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "postId",
        "onCancel",
        "onSubmit"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref.data;
    var privilege = dataProfile.user_priv;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: 2
    }), 2), suspendType = ref1[0], setSuspendType = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: "0"
    }), 2), duration = ref2[0], setDuration = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: StreamWidget_constants/* defaultReportLabel */.u3
    }), 2), reason = ref3[0], setReason = ref3[1];
    var ref4 = (0,react.useState)(false), sendEmail = ref4[0], setSendEmail = ref4[1];
    var ref5 = (0,react.useState)(false), blockIp = ref5[0], setBlockIp = ref5[1];
    var ref6 = (0,react.useState)(false), isAllowBlockIp = ref6[0], setIsAllowBlockIp = ref6[1];
    var suspendTypeOptions = (0,userRole/* isAllowedToBlockIp */.AR)(privilege) ? (0,_to_consumable_array/* default */.Z)(BLOCK_TYPES).concat([
        BLOCK_NO_VOTE
    ]) : (0,_to_consumable_array/* default */.Z)(BLOCK_TYPES);
    var toggleSendEmail = function() {
        setSendEmail(!sendEmail);
    };
    var toggleBlockIp = function() {
        setBlockIp(!blockIp);
    };
    var handleSuspend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, suspend, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = {
                            blockmode: suspendType,
                            duration: duration,
                            reason: reason,
                            userid: userId,
                            postid: postId,
                            sendEmail: sendEmail,
                            blockIp: blockIp
                        };
                        _ctx.next = 3;
                        return dispatch(moderation/* effects.suspendUser */.Sz.suspendUser(data));
                    case 3:
                        suspend = _ctx.sent;
                        queryClient.invalidateQueries();
                        error = suspend.payload.error;
                        if (!error) {
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                            onCancel();
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSuspend() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        setIsAllowBlockIp((0,userRole/* isAllowedToBlockIp */.AR)(privilege));
    }, [
        privilege
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "16px",
            height: "40px",
            weight: "bold",
            color: color/* default.black */.Z.black,
            children: [
                "Mute @",
                username
            ]
        }),
        width: 280,
        centered: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                type: "primary",
                height: "40px",
                margin: "0px !important",
                onClick: handleSuspend,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    color: color/* default.light */.Z.light,
                    children: "Confirm"
                })
            }, "confirm"), 
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "12px",
                children: "Block Reason : "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                value: suspendType,
                onChange: setSuspendType,
                children: suspendTypeOptions.map(function(param) {
                    var key = param.key, label = param.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                        value: key,
                        children: label
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "12px",
                mt: "5px",
                children: [
                    "Mute Reason :",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                value: reason,
                onChange: setReason,
                children: reportOptions.map(function(param) {
                    var key = param.key, label = param.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                        value: label,
                        children: label
                    }, key);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                size: "12px",
                mt: "5px",
                children: [
                    "Duration Suspend:",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                value: duration,
                onChange: setDuration,
                children: BLOCK_DURATION.map(function(param) {
                    var label = param.label, value = param.value;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                        value: value,
                        children: label
                    }, value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "12px",
                children: "Send report to user?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                checked: sendEmail,
                onChange: toggleSendEmail
            }),
            isAllowBlockIp && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        children: "Block IP?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        checked: blockIp,
                        onChange: toggleBlockIp
                    })
                ]
            })
        ]
    }));
}
ModalSuspendUser.propTypes = {
    username: (prop_types_default()).string.isRequired,
    userId: (prop_types_default()).number.isRequired,
    postId: (prop_types_default()).number.isRequired,
    onCancel: (prop_types_default()).func,
    onSubmit: (prop_types_default()).func
};
ModalSuspendUser.defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSubmit: function() {}
};
function ModalSuspendUserWithQuery(_param) {
    var username = _param.username, userId = _param.userId, postId = _param.postId, onCancel = _param.onCancel, onSubmit = _param.onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "postId",
        "onCancel",
        "onSubmit"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalSuspendUser, (0,_object_spread/* default */.Z)({
            username: username,
            userId: userId,
            onCancel: onCancel,
            postId: postId,
            onSubmit: onSubmit
        }, props))
    });
}
/* harmony default export */ var Modals_ModalSuspendUser = (ModalSuspendUserWithQuery);

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/global/Loading/SecondarySpinner.tsx
var SecondarySpinner = __webpack_require__(32447);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/EmptySearch.tsx
var EmptySearch = __webpack_require__(16047);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Moderation/slice.ts
var slice = __webpack_require__(98170);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/ModalFollow/UserItem.tsx
var UserItem = __webpack_require__(33722);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/ModalFollow/styled.ts
var ModalFollow_styled = __webpack_require__(10738);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalFollow/ModalFollower.tsx





















var pageSourceIndex = ProfileAnalytics/* PAGE_SOURCE_INDEX.findIndex */.en.findIndex(function(sourceIndex) {
    return sourceIndex === "Followers";
});
function ModalFollower(_param) {
    var username = _param.username, userId = _param.userId, symbol = _param.symbol, companyId = _param.companyId, visible = _param.visible, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "symbol",
        "companyId",
        "visible",
        "onCancel"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var visibilityRef = (0,react.useRef)(null);
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), userFollowers = ref.userFollowers, companyFollowers = ref.companyFollowers, isLoading = ref.isLoadingFollower, pagination = ref.followersPagination;
    var more = pagination.more, page = pagination.page, keyword = pagination.search;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var ref2 = (0,react.useState)(false), isSensorVisible = ref2[0], setSensorVisible = ref2[1];
    var handleSensorChange = function() {
        var isVisible = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setSensorVisible(isVisible);
    };
    var handleGetFollowers = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!isSensorVisible || !more || isLoading)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    dispatch(slice/* effects.getFollowers */.Sz.getFollowers({
                        companyid: companyId,
                        userid: userId,
                        keyword: keyword,
                        page: page
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isSensorVisible,
        isLoading,
        page,
        more,
        keyword,
        userId,
        companyId
    ]);
    (0,react.useEffect)(function() {
        if (visible) {
            handleGetFollowers();
        } else {
            dispatch(slice/* default.actions.resetFollowersState */.ZP.actions.resetFollowersState());
        }
    }, [
        visible,
        handleGetFollowers
    ]);
    var searchFollowers = (0,react.useCallback)(lodash_debounce_default()(function(search) {
        dispatch(slice/* default.actions.searchFollowers */.ZP.actions.searchFollowers(search));
        setSensorVisible(true);
    }, 500), []);
    var modalTitle = username || symbol;
    var dataFollowers = companyId ? companyFollowers[companyId] : userFollowers[userId];
    var followers = dataFollowers || [];
    if (!visible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalFullscreen */.Sb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        // @ts-expect-error
        noBorder: true,
        visible: visible,
        onCancel: onCancel,
        footer: null,
        type: "fullscreen",
        maskClosable: false,
        title: // eslint-disable-next-line react/jsx-wrap-multilines
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "20px",
            family: "bold",
            align: "center",
            color: color/* default.suvaGray */.Z.suvaGray,
            children: [
                modalTitle,
                " is followed by"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFollow_styled/* ModalFollowSearchInput */.x, {
                placeholder: "Search",
                onChange: function(param) {
                    var value = param.target.value;
                    return searchFollowers(value || undefined);
                },
                onClear: function() {
                    return dispatch(slice/* default.actions.searchFollowers */.ZP.actions.searchFollowers());
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFollow_styled/* UserItemContainer */._, {
                ref: visibilityRef,
                children: [
                    followers.map(function(follower) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UserItem/* default */.Z, {
                            pageSource: ProfileAnalytics/* PAGE_SOURCE.followers */.nP.followers,
                            pageSourceIndex: pageSourceIndex,
                            user: follower,
                            activeUserId: Number(dataProfile === null || dataProfile === void 0 ? void 0 : dataProfile.id)
                        }, follower.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondarySpinner/* default */.Z, {
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                        containment: visibilityRef.current,
                        onChange: handleSensorChange,
                        scrollCheck: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "\xa0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: followers.length === 0 && !isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch/* default */.Z, {})
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var ModalFollow_ModalFollower = (ModalFollower);

;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalFollow/ModalFollowing.tsx





















var ModalFollowing_pageSourceIndex = ProfileAnalytics/* PAGE_SOURCE_INDEX.findIndex */.en.findIndex(function(sourceIndex) {
    return sourceIndex === "Following";
});
function ModalFollowing(_param) {
    var username = _param.username, userId = _param.userId, visible = _param.visible, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "visible",
        "onCancel"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var visibilityRef = (0,react.useRef)(null);
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), userFollowing = ref.userFollowing, isLoading = ref.isLoadingFollowing, pagination = ref.followingPagination;
    var more = pagination.more, page = pagination.page, keyword = pagination.search;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var ref2 = (0,react.useState)(false), isSensorVisible = ref2[0], setSensorVisible = ref2[1];
    var handleSensorChange = function() {
        var isVisible = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setSensorVisible(isVisible);
    };
    var handleGetFollowings = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!isSensorVisible || !more || isLoading)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    dispatch(slice/* effects.getUserFollowing */.Sz.getUserFollowing({
                        userid: userId,
                        keyword: keyword,
                        page: page
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isSensorVisible,
        isLoading,
        page,
        more,
        keyword,
        userId
    ]);
    (0,react.useEffect)(function() {
        if (visible) {
            handleGetFollowings();
        } else {
            dispatch(slice/* default.actions.resetFollowingState */.ZP.actions.resetFollowingState());
        }
    }, [
        visible,
        handleGetFollowings
    ]);
    var searchFollowing = (0,react.useCallback)(lodash_debounce_default()(function(search) {
        dispatch(slice/* default.actions.searchFollowing */.ZP.actions.searchFollowing(search));
        setSensorVisible(true);
    }, 500), []);
    var followings = userFollowing[userId] || [];
    if (!visible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalFullscreen */.Sb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        // @ts-expect-error
        noBorder: true,
        visible: visible,
        onCancel: onCancel,
        footer: null,
        type: "fullscreen",
        maskClosable: false,
        transitionName: "",
        maskTransitionName: "",
        title: // eslint-disable-next-line react/jsx-wrap-multilines
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "20px",
            family: "bold",
            align: "center",
            color: color/* default.suvaGray */.Z.suvaGray,
            children: [
                username,
                " is following"
            ]
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFollow_styled/* ModalFollowSearchInput */.x, {
                placeholder: "Search",
                onChange: function(param) {
                    var value = param.target.value;
                    return searchFollowing(value || undefined);
                },
                onClear: function() {
                    return dispatch(slice/* default.actions.searchFollowing */.ZP.actions.searchFollowing());
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFollow_styled/* UserItemContainer */._, {
                ref: visibilityRef,
                children: [
                    followings.map(function(following) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UserItem/* default */.Z, {
                            pageSource: ProfileAnalytics/* PAGE_SOURCE.following */.nP.following,
                            pageSourceIndex: ModalFollowing_pageSourceIndex,
                            user: following,
                            activeUserId: Number(dataProfile === null || dataProfile === void 0 ? void 0 : dataProfile.id)
                        }, following.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondarySpinner/* default */.Z, {
                        isLoading: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                        containment: visibilityRef.current,
                        onChange: handleSensorChange,
                        scrollCheck: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "\xa0"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: followings.length === 0 && !isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearch/* default */.Z, {})
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var ModalFollow_ModalFollowing = (ModalFollowing);

// EXTERNAL MODULE: ./src/lib/entities/user.js
var user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/features/user/slice.ts
var user_slice = __webpack_require__(52827);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var StreamWidget_slice = __webpack_require__(47225);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalBlockUnblockUser.tsx


















var contentWording = function(username) {
    return {
        block: "".concat(username, " tidak bisa mengirim pesan ke kamu atau menemukan profile, dan post kamu. \n    ").concat(username, " tidak akan diberi tahu bahwa kamu telah memblokirnya."),
        unblock: "".concat(username, " dapat melihat post kamu, follow dan mengirimkan pesan. \n    ").concat(username, " tidak akan diberi tahu bahwa kamu membuka blokirnya.")
    };
};
function ModalBlockUnblockUser(_param) {
    var username = _param.username, userId = _param.userId, type = _param.type, _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "username",
        "userId",
        "type",
        "onCancel"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    /**
   * @param {Event} e
   */ var handleBlockUnblock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var request, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.stopPropagation();
                        queryClient.invalidateQueries();
                        if (type === "block") {
                            ProfileAnalytics/* mainProfileEvents.onUserProfileBlockConfirmed */.j4.onUserProfileBlockConfirmed();
                        } else {
                            ProfileAnalytics/* mainProfileEvents.onUserProfileUnblockConfirmed */.j4.onUserProfileUnblockConfirmed();
                        }
                        if (!(type === "block")) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 6;
                        return dispatch(moderation/* effects.blockUser */.Sz.blockUser(userId));
                    case 6:
                        _ctx.t0 = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return dispatch(moderation/* effects.unblockUser */.Sz.unblockUser(userId));
                    case 11:
                        _ctx.t0 = _ctx.sent;
                    case 12:
                        request = _ctx.t0;
                        error = request.payload.error;
                        if (!error) {
                            if (type === "block") {
                                ProfileAnalytics/* mainProfileEvents.onUserProfileSuccessfullyBlocked */.j4.onUserProfileSuccessfullyBlocked();
                            } else {
                                ProfileAnalytics/* mainProfileEvents.onUserProfileSuccessfullyUnblocked */.j4.onUserProfileSuccessfullyUnblocked();
                            }
                            // @ts-ignore
                            dispatch(user/* effects.getUserProfile */.Sz.getUserProfile(username));
                            dispatch(user_slice/* effects.getPinnedPost */.Sz.getPinnedPost({
                                username: username
                            }));
                            // @ts-ignore
                            dispatch(StreamWidget_slice/* default.actions.setFilterParam */.ZP.actions.setFilterParam({}));
                            onCancel(e);
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleBlockUnblock(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            size: "16px",
            height: "40px",
            weight: "bold",
            color: color/* default.black */.Z.black,
            align: "center",
            children: [
                "Block ",
                username
            ]
        }),
        centered: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                type: "primary",
                height: "40px",
                margin: "0px !important",
                onClick: handleBlockUnblock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    color: color/* default.light */.Z.light,
                    children: type === "block" ? "Block" : "Unblock"
                })
            }, "confirm"), 
        ],
        width: 334,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            align: "center",
            children: contentWording(username)[type]
        })
    }));
}
function ModalBlockUnblockWithQuery(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBlockUnblockUser, (0,_object_spread/* default */.Z)({}, props))
    });
}
/* harmony default export */ var Modals_ModalBlockUnblockUser = (ModalBlockUnblockWithQuery);

;// CONCATENATED MODULE: ./src/global/Moderation/Modals/index.jsx








/***/ }),

/***/ 74673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; },
/* harmony export */   "Sb": function() { return /* binding */ ModalFullscreen; },
/* harmony export */   "Wx": function() { return /* binding */ Option; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* unused harmony exports TextArea, IconMedia */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border: none;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n  .ant-modal-header {\n    padding: 0 20px !important;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    height: 40px;\n    border-bottom: solid 1px ",
        ";\n\n    ",
        "\n  }\n  .ant-modal-body {\n    padding: 20px;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n\n    button:first-child {\n      border-radius: 0 0 0 3px;\n    }\n    button:last-child {\n      border-radius: 0 0 3px 0px;\n    }\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px;\n  line-height: 14px;\n  width: 100%;\n  border-radius: 2px;\n  font-size: 14px;\n  margin: 5px 0;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 5px 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  margin-right: 10px;\n  cursor: pointer;\n  img {\n    background: none;\n    padding: 10px;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    width: 100%;\n  }\n  .ant-modal-header {\n    height: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .ant-modal-close-x {\n    font-size: 20px;\n    color: #000;\n    weight: bold;\n  }\n  .ant-modal-close {\n    right: 32px;\n    top: 15px;\n    font-weight: bold;\n  }\n\n  .ant-modal-body {\n    height: calc(100vh - 60px);\n  }\n\n  @media ",
        " {\n    .ant-modal-content {\n      width: 660px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    zIndex: 1050,
    transitionName: "",
    maskTransitionName: ""
}).withConfig({
    componentId: "sc-d24ac6c7-0"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject());
});
var Select = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-d24ac6c7-1"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var Option = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "option"
}).withConfig({
    componentId: "sc-d24ac6c7-2"
})(_templateObject3());
var TextArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"].TextArea */ .Z.TextArea).withConfig({
    componentId: "sc-d24ac6c7-3"
})(_templateObject4());
// Will be replaced by icon from ui-design
var IconMedia = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs(function(props) {
    return {
        background: props.background || "none",
        align: "center",
        justify: "center"
    };
}).withConfig({
    componentId: "sc-d24ac6c7-4"
})(_templateObject5(), function(props) {
    return props.background;
});
var ModalFullscreen = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(Modal).attrs({
    type: "fullscreen"
}).withConfig({
    componentId: "sc-d24ac6c7-5"
})(_templateObject6(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tablet */ .Z.tablet);



/***/ }),

/***/ 79372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pickers_EmojiPicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/Pickers/EmojiPicker/constants.ts
var EMOJI_CDN = "https://cdn.jsdelivr.net/npm/@emoji-mart/data@1.2.1/sets/14/native.json";
var EMOJI_PICKER_CATEGORY = [
    "frequent",
    "people",
    "nature",
    "foods",
    "activity",
    "places",
    "objects",
    "symbols", 
];
var SKINS_ID = {
    NO_SKIN: 0,
    LIGHT: 1,
    MEDIUM_LIGHT: 2,
    MEDIUM: 3,
    MEDIUM_DARK: 4,
    DARK: 5
};
var EMOJI_LOCALSTORAGE_KEY = {
    EMOJI_DATA: "emoji-data",
    EMOJI_RECENT: "emoji-recent"
};
var CATEGORIES_ID = {
    FREQUENT: "frequent",
    PEOPLE: "people",
    NATURE: "nature",
    FOODS: "foods",
    ACTIVITY: "activity",
    PLACES: "places",
    OBJECTS: "objects",
    SYMBOLS: "symbols",
    FLAGS: "flags"
};
var LIMIT_FREQUENT_EMOJIS = 30;
var WORDING_NO_RECENT_EMOJI = "Belum ada emoji yang telah digunakan";
var EMOJI_LIST_ID = "emoji-list";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Pickers/EmojiPicker/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  :hover {\n    border-color: ",
        " !important;\n  }\n\n  ::placeholder {\n    font-family: var(--font-bold) !important;\n    color: #E3E3E3 !important;\n  }\n\n  input::placeholder, input::-webkit-input-placeholder {\n    color: #E4E4E4 !important;\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px\n  }\n\n  .ant-input-clear-icon {\n    display: flex;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 320px;\n  overflow: scroll;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 15px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  .active-category {\n    border-bottom: 2px solid #00ab6b;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: none;\n  outline: none;\n  width: 36px;\n  height: 42px;\n  cursor: pointer;\n\n  :hover {\n    background: transparent;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 198px;\n  overflow-y: auto;\n  padding: 0 15px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > p {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 12.63px;\n  margin-bottom: 20px;\n  border-radius: 6px;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  cursor: pointer;\n\n  span {\n    font-size: 32px;\n    line-height: 32px;\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 170px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var SearchInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-a06f3ea8-0"
})(_templateObject(), color/* default.downgray */.Z.downgray, color/* default.downgray */.Z.downgray);
var EmojiPickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06f3ea8-1"
})(_templateObject1());
var EmojiHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06f3ea8-2"
})(_templateObject2());
var EmojiCategoryContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06f3ea8-3"
})(_templateObject3());
var EmojiCategoryItem = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-a06f3ea8-4"
})(_templateObject4());
var EmojiListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06f3ea8-5"
})(_templateObject5());
var EmojiListSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-a06f3ea8-6"
})(_templateObject6());
var EmojiItem = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-a06f3ea8-7"
})(_templateObject7());
var NoRecentEmoji = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06f3ea8-8"
})(_templateObject8());


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/global/Pickers/EmojiPicker/useEmojiPicker.ts






function useEmojiPicker() {
    var lastScrollPos = (0,react.useRef)(1);
    var ref = (0,react.useState)(0), activeIndexCategory = ref[0], setActiveIndexCategory = ref[1];
    var ref1 = (0,react.useState)([]), listEmoji = ref1[0], setListEmoji = ref1[1];
    var ref2 = (0,react.useState)([]), recentListEmoji = ref2[0], setRecentListEmoji = ref2[1];
    var ref3 = (0,react.useState)(""), searchKeyword = ref3[0], setSearchKeyword = ref3[1];
    var keywordDebounce = (0,useDebounce/* default */.Z)(searchKeyword, 300);
    var handleClickCategory = function(category) {
        var element = document.getElementById("emoji-list");
        element.getElementsByClassName("".concat(category))[0].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        });
    };
    var transformToCategoryView = function(emojiData, skinId) {
        if (!emojiData) {
            return [];
        }
        var result = emojiData.categories.filter(function(param) {
            var id = param.id;
            return id !== CATEGORIES_ID.FLAGS;
        }).map(function(param) {
            var emojis = param.emojis, id = param.id;
            return {
                id: id,
                emojis: emojis.map(function(emojiId) {
                    var emoji = emojiData.emojis[emojiId];
                    if (skinId <= emoji.skins.length - 1) {
                        return emoji.skins[skinId].native;
                    }
                    return emoji.skins[SKINS_ID.NO_SKIN].native;
                })
            };
        });
        return result;
    };
    var fetchEmoji = function() {
        return new Promise(function(resolve, reject) {
            var localEmojiData = localStorage.getItem(EMOJI_LOCALSTORAGE_KEY.EMOJI_DATA);
            if (localEmojiData) {
                resolve(JSON.parse(localEmojiData));
            }
            fetch(EMOJI_CDN).then(function(res) {
                return res.json();
            }).then(function(res) {
                localStorage.setItem(EMOJI_LOCALSTORAGE_KEY.EMOJI_DATA, JSON.stringify(res));
                resolve(res);
            }).catch(function(err) {
                reject(err);
            });
        });
    };
    var initEmoji = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var emojiData, transformedEmojiData, recentEmoji;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchEmoji().then(function(res) {
                            return res;
                        });
                    case 2:
                        emojiData = _ctx.sent;
                        transformedEmojiData = transformToCategoryView(emojiData, SKINS_ID.NO_SKIN);
                        setListEmoji(transformedEmojiData);
                        recentEmoji = JSON.parse(localStorage.getItem(EMOJI_LOCALSTORAGE_KEY.EMOJI_RECENT)) || [];
                        if (recentEmoji) {
                            setRecentListEmoji(recentEmoji);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function initEmoji() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectEmoji = function(emoji) {
        var recentEmoji = JSON.parse(localStorage.getItem(EMOJI_LOCALSTORAGE_KEY.EMOJI_RECENT)) || [];
        var emojis = // @ts-ignore
        (0,_to_consumable_array/* default */.Z)(recentEmoji);
        var isEmojiUnavailable = !recentEmoji.includes(emoji);
        if (isEmojiUnavailable && recentEmoji.length < LIMIT_FREQUENT_EMOJIS) {
            emojis = [
                "".concat(emoji), 
            ].concat((0,_to_consumable_array/* default */.Z)(emojis));
        } else if (isEmojiUnavailable && recentEmoji.length === 30) {
            emojis.splice(recentEmoji.length - 1, 1);
            emojis = [
                "".concat(emoji), 
            ].concat((0,_to_consumable_array/* default */.Z)(emojis));
        }
        localStorage.setItem(EMOJI_LOCALSTORAGE_KEY.EMOJI_RECENT, JSON.stringify(emojis));
        setRecentListEmoji(emojis);
    };
    var onChangeKeyword = function(keyword) {
        setSearchKeyword(keyword);
    };
    var handleSearchEmoji = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var emojiData, emojiDataArray, searchResult;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(keyword.length > 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 3;
                        return fetchEmoji().then(function(res) {
                            return res;
                        });
                    case 3:
                        emojiData = _ctx.sent;
                        emojiDataArray = Object.keys(emojiData.emojis).map(function(id) {
                            return emojiData.emojis[id];
                        });
                        searchResult = emojiDataArray.filter(function(emoji) {
                            return emoji.keywords.some(function(emojiKeyword) {
                                return emojiKeyword.includes(keyword);
                            });
                        });
                        setListEmoji([
                            {
                                id: null,
                                emojis: searchResult.map(function(emoji) {
                                    return emoji.skins[SKINS_ID.NO_SKIN].native;
                                })
                            }
                        ]);
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            initEmoji();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSearchEmoji(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScrollEmojiList = function() {
        var container = document.getElementById(EMOJI_LIST_ID);
        if (!container) return;
        var newScrollPos = container.scrollTop;
        var newIndexActiveCategory = activeIndexCategory;
        var nextIndexCategory = activeIndexCategory + 1;
        var prevIndexCategory = activeIndexCategory > 0 ? activeIndexCategory - 1 : 0;
        if (lastScrollPos.current <= newScrollPos) {
            newIndexActiveCategory = nextIndexCategory;
        } else {
            newIndexActiveCategory = prevIndexCategory;
        }
        lastScrollPos.current = newScrollPos;
        var options = {
            root: container,
            rootMargin: "0px",
            threshold: 1.0
        };
        var observer = new IntersectionObserver(function(param) {
            if (param[0].intersectionRatio <= 0 || newIndexActiveCategory === 0 && container.scrollTop <= 100) {
                setActiveIndexCategory(newIndexActiveCategory);
            }
        }, options);
        var target = document.getElementById("section-".concat(EMOJI_PICKER_CATEGORY[activeIndexCategory]));
        if (!target) return;
        if (newScrollPos > 0) {
            observer === null || observer === void 0 ? void 0 : observer.observe(target);
        } else if (newScrollPos === 0) {
            observer === null || observer === void 0 ? void 0 : observer.unobserve(target);
        }
    };
    (0,react.useEffect)(function() {
        initEmoji();
    }, []);
    (0,react.useEffect)(function() {
        handleSearchEmoji(searchKeyword);
    }, [
        keywordDebounce
    ]);
    return {
        listEmoji: listEmoji,
        recentListEmoji: recentListEmoji,
        activeIndexCategory: activeIndexCategory,
        handleClickCategory: handleClickCategory,
        handleSelectEmoji: handleSelectEmoji,
        handleScrollEmojiList: handleScrollEmojiList,
        onChangeKeyword: onChangeKeyword
    };
}
/* harmony default export */ var EmojiPicker_useEmojiPicker = (useEmojiPicker);

;// CONCATENATED MODULE: ./src/global/Pickers/EmojiPicker/index.tsx







function EmojiPicker(param) {
    var onSelectEmoji = param.onSelectEmoji;
    var ref = EmojiPicker_useEmojiPicker(), listEmoji = ref.listEmoji, recentListEmoji = ref.recentListEmoji, activeIndexCategory = ref.activeIndexCategory, handleClickCategory = ref.handleClickCategory, handleSelectEmoji = ref.handleSelectEmoji, handleScrollEmojiList = ref.handleScrollEmojiList, onChangeKeyword = ref.onChangeKeyword;
    var handleClickEmoji = function(emoji) {
        handleSelectEmoji(emoji);
        onSelectEmoji(emoji);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmojiPickerWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmojiHeaderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiCategoryContainer, {
                        children: EMOJI_PICKER_CATEGORY.map(function(category, index) {
                            var emojiIconAffix = index === activeIndexCategory ? "".concat(category, "-active") : category;
                            var categoryClassName = index === activeIndexCategory ? "active-category" : "";
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiCategoryItem, {
                                onClick: function() {
                                    return handleClickCategory(category);
                                },
                                className: categoryClassName,
                                title: category,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/compose-emoji-".concat(emojiIconAffix, ".svg"),
                                    style: {
                                        width: "20px",
                                        height: "20px"
                                    }
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                        placeholder: "Search Emoji",
                        width: "100%",
                        height: "35px",
                        // @ts-expect-error
                        my: "16px",
                        p: "4px",
                        onChange: function(e) {
                            return onChangeKeyword(e.target.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmojiListContainer, {
                id: EMOJI_LIST_ID,
                onScroll: handleScrollEmojiList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "".concat(CATEGORIES_ID.FREQUENT),
                        id: "section-".concat(CATEGORIES_ID.FREQUENT),
                        children: recentListEmoji.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.midgray */.Z.midgray,
                                    mb: "16px",
                                    children: "Frequent"
                                }),
                                recentListEmoji.map(function(emoji) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiItem, {
                                        onClick: function() {
                                            return handleClickEmoji(emoji);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "img",
                                            children: emoji
                                        })
                                    }, "emoji-".concat(emoji));
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoRecentEmoji, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "13px",
                                color: color/* default.highgray */.Z.highgray,
                                children: WORDING_NO_RECENT_EMOJI
                            })
                        })
                    }),
                    listEmoji.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmojiListSection, {
                            className: "".concat(category.id ? category.id : "result"),
                            id: "section-".concat(category.id ? category.id : "result"),
                            children: [
                                category.id && // @ts-expect-error
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.midgray */.Z.midgray,
                                    mb: "16px",
                                    children: category.id
                                }),
                                category.emojis.map(function(emoji) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiItem, {
                                        onClick: function() {
                                            return handleClickEmoji(emoji);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "img",
                                            children: emoji
                                        })
                                    }, "emoji-".concat(emoji));
                                })
                            ]
                        }, category.id ? category.id : "result");
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Pickers_EmojiPicker = (EmojiPicker);


/***/ }),

/***/ 7674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pickers_GifPicker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(40827);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Pickers/GifPicker/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  :hover {\n    border-color: ",
        " !important;\n  }\n\n  input::placeholder, input::-webkit-input-placeholder {\n    color: #E4E4E4 !important;\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px\n  }\n\n  .ant-input-clear-icon {\n    display: flex;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 200px;\n  overflow-y: auto;\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var SearchInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-9638bdd2-0"
})(_templateObject(), color/* default.downgray */.Z.downgray, color/* default.downgray */.Z.downgray);
var GifPickerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9638bdd2-1"
})(_templateObject1());
var MasonryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9638bdd2-2"
})(_templateObject2());
var GifWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9638bdd2-3"
})(_templateObject3());


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/general.js
var general = __webpack_require__(69042);
;// CONCATENATED MODULE: ./src/global/Pickers/GifPicker/store.ts





var gifPickerStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        data: [],
        totalCount: 0,
        isLoading: false,
        fetchGif: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var type, keyword, _offset, offset, request;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            type = param.type, keyword = param.keyword, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
                            set({
                                isLoading: true
                            });
                            request = type === "trending" ? general/* default.getTrendingGif */.Z.getTrendingGif(offset) : general/* default.getSearchGif */.Z.getSearchGif(keyword, offset);
                            request.then(function(res) {
                                var _data = res.data, data = _data.data, _meta = _data.meta, error = _meta.error_code, _pagination = _data.pagination, totalCount = _pagination.total_count;
                                if (!error) {
                                    var listData = offset > 0 ? (0,_to_consumable_array/* default */.Z)(get().data).concat((0,_to_consumable_array/* default */.Z)(data)) : data;
                                    set({
                                        data: listData,
                                        totalCount: totalCount,
                                        isLoading: false
                                    });
                                }
                            }).catch(function() {});
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store = (gifPickerStore);

;// CONCATENATED MODULE: ./src/global/Pickers/GifPicker/index.tsx
/* eslint-disable react/no-array-index-key */ 







function GifPicker(param) {
    var onSelectGif = param.onSelectGif, _gifColumns = param.gifColumns, gifColumns = _gifColumns === void 0 ? 3 : _gifColumns;
    var fetchGif = store(function(store) {
        return store.fetchGif;
    });
    var gifData = store(function(store) {
        return store.data;
    });
    var isLoading = store(function(store) {
        return store.isLoading;
    });
    var totalCount = store(function(store) {
        return store.totalCount;
    });
    var ref = (0,react.useState)(""), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react.useState)(0), offset = ref1[0], setOffset = ref1[1];
    var keywordDebounce = (0,useDebounce/* default */.Z)(keyword, 500);
    var wrapperRef = (0,react.useRef)();
    var handleLoadMore = function(visible) {
        if (!isLoading && offset < totalCount && visible) {
            var newOffset = offset + 30;
            if (keyword.length === 0) {
                fetchGif({
                    type: "trending",
                    keyword: keyword,
                    offset: offset
                });
            } else {
                fetchGif({
                    type: "search",
                    keyword: keyword,
                    offset: offset
                });
            }
            setOffset(newOffset);
        }
    };
    var onChangeKeyword = function(e) {
        var value = e.target.value;
        setKeyword(value);
    };
    (0,react.useEffect)(function() {
        if (keyword.length > 0) {
            fetchGif({
                type: "search",
                offset: 0,
                keyword: keyword
            });
        } else {
            fetchGif({
                type: "trending",
                offset: 0,
                keyword: keyword
            });
        }
        setOffset(0);
    }, [
        keywordDebounce
    ]);
    var handleSelectGif = function(e, image) {
        e.stopPropagation();
        var previewGif = image.fixed_width_small, postGif = image.fixed_height;
        var data = {
            post: postGif.url,
            preview: previewGif.url
        };
        onSelectGif(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GifPickerWrapper, {
                ref: wrapperRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                        placeholder: "Search GIFs...",
                        height: "35px",
                        width: "100%",
                        // @ts-expect-error
                        mb: "4px",
                        py: "10px",
                        px: "15px",
                        onChange: onChangeKeyword,
                        onPressEnter: function(e) {
                            return e.preventDefault();
                        },
                        allowClear: true
                    }, "search-input"),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MasonryWrapper, {
                        id: "masonry-wrapper",
                        ref: wrapperRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                                breakpointCols: gifColumns,
                                className: "my-masonry-grid",
                                columnClassName: "my-masonry-grid_column",
                                children: gifData.map(function(param) {
                                    var id = param.id, images = param.images;
                                    var previewSmallGif = images.fixed_width_small;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GifWrapper, {
                                        onClick: function(e) {
                                            return handleSelectGif(e, images);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: previewSmallGif.url,
                                            alt: id,
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    }, id);
                                })
                            }),
                            !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                                onChange: handleLoadMore,
                                scrollCheck: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "\xa0"
                                })
                            }, "visibility-sensor")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: "giphy-attributes",
                src: "/images/giphyattr.png",
                style: {
                    height: "10px",
                    margin: "8px 4px"
                }
            })
        ]
    });
}
/* harmony default export */ var Pickers_GifPicker = (GifPicker);


/***/ }),

/***/ 62780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51767);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85945);


var queryClient = new _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .QueryClient */ .S({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
var QueryProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryClientProvider */ .aH, {
        client: queryClient,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QueryProvider);


/***/ }),

/***/ 23892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CommentSettingPopover; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/StreamCompose/styled.ts
var styled = __webpack_require__(94134);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
;// CONCATENATED MODULE: ./src/global/StreamCompose/CommentSetting/CommentSettingItem.tsx





function CommentSettingItem(param) {
    var icon = param.icon, label = param.label, isActive = param.isActive, onChange = param.onChange, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        className: "comment-setting-item",
        justify: "space-between",
        // @ts-expect-error
        mt: "15px",
        py: "3px",
        pr: "3px",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                width: "16",
                height: "16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "icon/".concat(icon)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "12px",
                        weight: "400",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Checkbox */.XZ, {
                className: "comment-setting-checkbox-".concat(type),
                checked: isActive,
                onChange: onChange
            })
        ]
    });
}
/* harmony default export */ var CommentSetting_CommentSettingItem = (CommentSettingItem);

;// CONCATENATED MODULE: ./src/global/StreamCompose/CommentSetting/CommentSettingPopover.tsx







function PopoverCommentSetting(param) {
    var commenter = param.commenter, commentSettingList = param.commentSettingList, onChangeCommenter = param.onChangeCommenter;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentSettingContainer */.U6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        weight: "700",
                        height: "19px",
                        family: "bold",
                        children: "Who can comment?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "8px",
                        size: "12px",
                        weight: "400",
                        height: "16px",
                        children: "Choose who is allowed to comment on this post."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: commentSettingList.map(function(item) {
                    return /*#__PURE__*/ (0,react.createElement)(CommentSetting_CommentSettingItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        key: item.id,
                        isActive: commenter.id === item.id,
                        onChange: function() {
                            return onChangeCommenter(item);
                        }
                    }));
                })
            })
        ]
    });
}
/* harmony default export */ var CommentSettingPopover = (PopoverCommentSetting);


/***/ }),

/***/ 99172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var global_StreamWidget_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11237);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9571);







function FileContainer(param) {
    var documents = param.documents, onSetDocuments = param.onSetDocuments;
    var handleRemoveFile = function(file) {
        var docIndex = documents.findIndex(function(doc) {
            return doc === file;
        });
        var documentFiles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(documents);
        documentFiles.splice(docIndex, 1);
        // remove file here
        onSetDocuments(documentFiles);
    };
    var getDocumentType = function(document) {
        var filename = document.name || (0,global_StreamWidget_utils__WEBPACK_IMPORTED_MODULE_4__/* .showFileName */ .yk)(document);
        var parsedFilename = filename.length > 33 ? filename.substr(0, 20) + "..." + filename.substr(filename.length - 6, 6) : filename;
        var extension = parsedFilename.split(".").pop();
        switch(extension){
            case "pdf":
                return "PDF";
            case "xls":
            case "xlsx":
                return "XLS";
            case "doc":
            case "docx":
                return "DOC";
            default:
                return "PPT";
        }
    };
    if (documents.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: documents.map(function(doc) {
            var extension = getDocumentType(doc);
            var humanFilename = doc.name || (0,global_StreamWidget_utils__WEBPACK_IMPORTED_MODULE_4__/* .showFileName */ .yk)(doc);
            var parsedFileName = humanFilename.length > 33 ? humanFilename.substr(0, 20) + "..." + humanFilename.substr(humanFilename.length - 6, 6) : humanFilename;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .FileItem */ .jU, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .ExtensionBadge */ .Wp, {
                                extension: extension,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light,
                                    family: "bold",
                                    weight: "700",
                                    size: "9px",
                                    height: "16px",
                                    // @ts-expect-error
                                    pt: "1px",
                                    children: extension
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                as: "a",
                                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary,
                                ellipsis: true,
                                children: parsedFileName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .IconCloseFile */ .f4, {
                        className: "icon-compose_close",
                        onClick: function() {
                            return handleRemoveFile(doc);
                        }
                    })
                ]
            });
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FileContainer);


/***/ }),

/***/ 9571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wp": function() { return /* binding */ ExtensionBadge; },
/* harmony export */   "f4": function() { return /* binding */ IconCloseFile; },
/* harmony export */   "jU": function() { return /* binding */ FileItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 24px 0 0;\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  width: 100%;\n  padding: 14px 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 4px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  max-height: 16px;\n\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  border-radius: 2px;\n  margin-left: 5px;\n  line-height: 12px;\n  font-weight: 700;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var FileItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-2f0a0aae-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var ExtensionBadge = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-2f0a0aae-1"
})(_templateObject1(), function(param) {
    var extension = param.extension;
    switch(extension){
        case "DOC":
            return "#2479b4";
        case "PDF":
            return "#ee4a49";
        case "XLS":
            return "#00ab6b";
        default:
            return "#ffad01";
    }
});
var IconCloseFile = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2f0a0aae-2"
})(_templateObject2());



/***/ }),

/***/ 85895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15807);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);



function IconFooter(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, src = param.src, alt = param.alt, onClick = param.onClick, title = param.title, iconRef = param.iconRef;
    if (isVisible) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .IconFooterWrapper */ .$7, {
            onClick: onClick,
            title: title,
            ref: iconRef,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_1__/* .IconWrapper */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .FooterIcon */ .LA, {
                    src: src,
                    alt: alt
                })
            })
        });
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (IconFooter);


/***/ }),

/***/ 3:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$7": function() { return /* binding */ IconFooterWrapper; },
/* harmony export */   "BU": function() { return /* binding */ GifContainer; },
/* harmony export */   "GX": function() { return /* binding */ ButtonSubmit; },
/* harmony export */   "LA": function() { return /* binding */ FooterIcon; },
/* harmony export */   "VB": function() { return /* binding */ ButtonPinned; },
/* harmony export */   "W8": function() { return /* binding */ EmojiContainer; },
/* harmony export */   "bk": function() { return /* binding */ FooterContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: transparent;\n  border: none;\n  color: ",
        ";\n  cursor: pointer;\n  padding: 0px;\n  width: 34px;\n  height: 28px;\n  margin-right: 6px;\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px 20px;\n  width: 100%;\n  margin-top: 26px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px 10px;\n\n  img.compose-pin-icon {\n    height: 16px;\n    width: 16px;\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-left: 5px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:disabled {\n    background: #8cd9bc !important;\n    color: ",
        ";\n    border: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  bottom: 25px;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding: 0;\n  @media ",
        " {\n    position: relative;\n    bottom: unset;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  bottom: 25px;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding: 20px 20px 10px 20px;\n  @media ",
        " {\n    position: relative;\n    bottom: unset;\n    padding: 20px 20px 0px 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var IconFooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.attrs */ .ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-9a92edd-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var FooterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "space-between",
    wrap: "wrap"
}).withConfig({
    componentId: "sc-9a92edd-1"
})(_templateObject2(), // @ts-expect-error
function(param) {
    var repost = param.repost;
    return repost && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1());
});
var FooterIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9a92edd-2"
})(_templateObject3());
var ButtonPinned = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9a92edd-3"
})(_templateObject4());
var ButtonSubmit = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9a92edd-4"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, function(param) {
    var loading = param.loading;
    return loading && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject5());
});
var EmojiContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a92edd-5"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var GifContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9a92edd-6"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);



/***/ }),

/***/ 23529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ig": function() { return /* binding */ Relative; },
/* harmony export */   "R8": function() { return /* binding */ CloseWrapper; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "rd": function() { return /* binding */ ImgUpload; }
/* harmony export */ });
/* unused harmony export ImgModal */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84607);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 64px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: center;\n  height: 80px;\n  max-height: 80px;\n  background: ",
        ";\n  overflow: hidden;\n  cursor: pointer;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  border-radius: 100%;\n  background: ",
        "",
        ";\n  padding: 4px;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: initial;\n  object-fit: cover;\n  object-position: 50% 50%;\n  height: 80px;\n  max-width: 144px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 80vh;\n  max-width: 50vw;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 8px;\n  font-weight: bold;\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var Relative = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-80897171-0"
})(_templateObject());
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-80897171-1"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].whisper */ .Z.whisper, function(param) {
    var haveWings = param.haveWings;
    return haveWings && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
});
var CloseWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-80897171-2"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray, (0,_deprecated_ui_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(70));
var ImgUpload = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-80897171-3"
})(_templateObject4());
var ImgModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-80897171-4"
})(_templateObject5());
var IconClose = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-80897171-5"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);



/***/ }),

/***/ 74319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ PostLimitContainer; },
/* harmony export */   "W": function() { return /* binding */ ModalConfirm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-radius: 3px 3px 0 0;\n  }\n  .ant-modal-content {\n    border-radius: 3px !important;\n  }\n  .ant-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n  }\n  button {\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 1.5px 0;\n  .text-container {\n    margin: 0 32px;\n    width: 336px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ModalConfirm = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-78871f8d-0"
})(_templateObject());
var PostLimitContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-78871f8d-1"
})(_templateObject1());



/***/ }),

/***/ 76897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_StreamCompose; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/StreamCompose/FileContainer/index.tsx
var FileContainer = __webpack_require__(99172);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(77325);
// EXTERNAL MODULE: ./src/global/Pickers/EmojiPicker/index.tsx + 3 modules
var EmojiPicker = __webpack_require__(79372);
// EXTERNAL MODULE: ./src/global/Pickers/GifPicker/index.tsx + 2 modules
var GifPicker = __webpack_require__(7674);
// EXTERNAL MODULE: ./src/global/Image/index.js
var global_Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
// EXTERNAL MODULE: ./src/global/StreamCompose/Footer/styled.ts
var styled = __webpack_require__(3);
// EXTERNAL MODULE: ./src/global/StreamCompose/Footer/IconFooter.tsx
var IconFooter = __webpack_require__(85895);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Footer/index.tsx
/* eslint-disable no-param-reassign */ /* eslint-disable consistent-return */ 

















function Footer(param) {
    var mode = param.mode, onCancel = param.onCancel, onSubmit = param.onSubmit, isLoading = param.isLoading, onSelectEmoji = param.onSelectEmoji, onSelectGif = param.onSelectGif, onTogglePolling = param.onTogglePolling, onToggleTargetPrice = param.onToggleTargetPrice, isOpenPolling = param.isOpenPolling, documents = param.documents, onSetDocuments = param.onSetDocuments, onSetImages = param.onSetImages, images = param.images, onErrorMaxSize = param.onErrorMaxSize, isSubmitDisabled = param.isSubmitDisabled, isPostComment = param.isPostComment, isPinned = param.isPinned, onTogglePin = param.onTogglePin, showPinButton = param.showPinButton;
    var pictureRef = (0,react.useRef)(null);
    var documentRef = (0,react.useRef)(null);
    var emojiContainerRef = (0,react.useRef)(null);
    var emojiButtonRef = (0,react.useRef)(null);
    var gifContainerRef = (0,react.useRef)(null);
    var gifButtonRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showEmoji = ref[0], setShowEmoji = ref[1];
    var ref1 = (0,react.useState)(false), showGif = ref1[0], setShowGif = ref1[1];
    var openPictureAttachment = function() {
        setShowEmoji(false);
        if (images.length <= 10) {
            pictureRef.current.click();
        } else {
            (0,AlertMessage/* default */.Z)({
                content: "Max Allowed Upload Images is 10 Images",
                alertType: "plain-default",
                messageType: "error"
            });
        }
    };
    var openDocumentAttachment = function() {
        setShowEmoji(false);
        documentRef.current.click();
    };
    var processImages = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(imageFiles) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", Promise.all(imageFiles.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(imageFile) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                                var isImageAvailable = images.findIndex(function(image) {
                                                    return image.fileName === (imageFile === null || imageFile === void 0 ? void 0 : imageFile.name);
                                                }) > -1;
                                                if (isImageAvailable) {
                                                    resolve(false);
                                                }
                                                var reader = new FileReader();
                                                reader.readAsArrayBuffer(imageFile);
                                                reader.onloadend = function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                                        var imageType, imagePreviewUrl, dimensions, imageData, deletedExif;
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    imageType = imageFile.type;
                                                                    if (imageFile.size > constants/* MAX_IMAGE_SIZE */.n0) {
                                                                        onErrorMaxSize(true);
                                                                        resolve(false);
                                                                    }
                                                                    imagePreviewUrl = URL.createObjectURL(imageFile);
                                                                    _ctx.next = 5;
                                                                    return (0,utils_image/* getImageDimensions */.p)(imagePreviewUrl);
                                                                case 5:
                                                                    dimensions = _ctx.sent;
                                                                    imageData = {
                                                                        isNew: true,
                                                                        type: constants/* IMAGE_TYPE_COMMON */.EZ,
                                                                        imagePreviewUrl: imagePreviewUrl,
                                                                        dimensions: dimensions,
                                                                        fileName: imageFile === null || imageFile === void 0 ? void 0 : imageFile.name
                                                                    };
                                                                    if (imageType === "image/jpeg" || imageType === "image/jpg") {
                                                                        // in some case some image form not have
                                                                        // format that can be deleted exif, so we try catch this block
                                                                        // to prevent user cannot upload the image
                                                                        try {
                                                                            deletedExif = (0,utils_image/* deleteImageExif */.T)(e.target.result, imageType);
                                                                            imageData.file = deletedExif;
                                                                        } catch (err) {
                                                                            imageData.file = imageFile;
                                                                        }
                                                                    } else {
                                                                        imageData.file = imageFile;
                                                                    }
                                                                    resolve(imageData);
                                                                case 9:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    }));
                                                    return function(e) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }();
                                            }));
                                        case 1:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(imageFile) {
                                return _ref.apply(this, arguments);
                            };
                        }())));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function processImages(imageFiles) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePicture = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var selectedFiles, imageFiles, processedImages, validImages, hasGifImage, oldImages, listImage, newListImage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        selectedFiles = e.target.files;
                        imageFiles = Array.from(selectedFiles);
                        _ctx.next = 5;
                        return processImages(imageFiles);
                    case 5:
                        processedImages = _ctx.sent;
                        validImages = processedImages.filter(function(image) {
                            return image;
                        });
                        hasGifImage = images.find(function(data) {
                            return data.type === constants/* IMAGE_TYPE_GIF */.p$;
                        });
                        oldImages = images;
                        if (hasGifImage) {
                            oldImages = [];
                        }
                        listImage = (0,_to_consumable_array/* default */.Z)(oldImages).concat((0,_to_consumable_array/* default */.Z)(validImages));
                        newListImage = listImage.length > 10 ? listImage.slice(0, 10) : listImage;
                        onSetImages(newListImage);
                        e.target.value = null;
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangePicture(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeDocument = function(e) {
        e.preventDefault();
        var documentFiles = (0,_to_consumable_array/* default */.Z)(documents);
        var sameFileCounter = 0;
        // validate documents
        Array.from(e.target.files).forEach(function(fileTarget) {
            // Reference: [web legacy]/app/components/stream/smart/ComposeStream.js
            // line: 489 - 528
            if (fileTarget.type.match("image.*")) {
                (0,AlertMessage/* default */.Z)({
                    content: errorMessage/* default.DOCUMENT_IMAGE_NOT_ALLOWED */.Z.DOCUMENT_IMAGE_NOT_ALLOWED,
                    alertType: "default",
                    messageType: "error",
                    hasCloseIcon: false
                });
                return false;
            }
            // Max document upload size 20 MB = 20971520 bytes.
            if (fileTarget.size > constants/* MAX_FILE_SIZE */.Tb) {
                (0,AlertMessage/* default */.Z)({
                    content: "File too large. The maximum size is ".concat(constants/* MAX_FILE_SIZE_MB */.C1, "MB"),
                    alertType: "plain-default",
                    messageType: "error",
                    hasCloseIcon: false
                });
                return false;
            }
            // If the file is unique, push into upload file stack
            var fileInStack = documentFiles.filter(function(doc) {
                return doc.name === fileTarget.name;
            });
            if (fileInStack.length === 0 || documentFiles.length === 0) {
                documentFiles.push(fileTarget);
            } else {
                sameFileCounter += 1;
            }
        });
        if (e.target.files.length + documents.length - sameFileCounter > 1 || e.target.files.length > 1) {
            return (0,AlertMessage/* default */.Z)({
                content: errorMessage/* default.MAX_UPLOAD_FILES */.Z.MAX_UPLOAD_FILES,
                alertType: "default",
                messageType: "error",
                hasCloseIcon: false
            });
        }
        if (documentFiles.length > 0 && documentFiles.length < 2) {
            onSetDocuments(documentFiles);
        }
        // reset input file
        // eslint-disable-next-line no-param-reassign
        e.target.value = null;
    };
    var handleSelectEmoji = function(emoji) {
        onSelectEmoji(emoji);
    };
    var handleSelectGif = function(gifData) {
        var hasCommonImage = images.find(function(data) {
            return data.type === constants/* IMAGE_TYPE_COMMON */.EZ;
        });
        var oldFile = images;
        if (hasCommonImage) {
            oldFile = [];
        }
        var newGifData = {
            file: gifData.post,
            imagePreviewUrl: gifData.preview,
            isNew: true,
            type: constants/* IMAGE_TYPE_GIF */.p$
        };
        onSelectGif((0,_to_consumable_array/* default */.Z)(oldFile).concat([
            newGifData
        ]));
        setShowGif(false);
    };
    var onClickGifButton = function() {
        setShowGif(function(prev) {
            return !prev;
        });
        setShowEmoji(false);
    };
    var onClickEmojiButton = function() {
        setShowEmoji(function(prev) {
            return !prev;
        });
        setShowGif(false);
    };
    var handleClickOutsideEmoji = function(event) {
        var ref, ref1;
        var isClickButtonEmoji = emojiButtonRef.current && !((ref = emojiButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target));
        var isClickResultEmoji = emojiContainerRef.current && !((ref1 = emojiContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target));
        if (isClickButtonEmoji && isClickResultEmoji) {
            onClickEmojiButton();
        }
    };
    var handleClickOutsideGif = function(event) {
        var ref, ref1;
        var isClickButtonGif = gifButtonRef.current && !((ref = gifButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target));
        var isClickResultGif = gifContainerRef.current && !((ref1 = gifContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target));
        if (isClickButtonGif && isClickResultGif) {
            setShowGif(false);
        }
    };
    var onClickTooglePolling = function() {
        onTogglePolling();
        setShowEmoji(false);
    };
    var onClickToggleTargetPrice = function() {
        onToggleTargetPrice();
        setShowEmoji(false);
    };
    var handleClickCancel = function() {
        setShowEmoji(false);
        setShowGif(false);
        onCancel();
    };
    var handleClickSubmit = function(e) {
        onSubmit(e);
        setShowEmoji(false);
        setShowGif(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClickOutsideGif, true);
        document.addEventListener("click", handleClickOutsideEmoji, true);
        return function() {
            document.removeEventListener("click", handleClickOutsideGif, true);
            document.removeEventListener("click", handleClickOutsideEmoji, true);
        };
    }, []);
    var showPollingButton = mode === constants/* COMPOSE_MODE.COMPOSE */.ZX.COMPOSE;
    var iconGif = "/icon/compose-gif".concat(showGif ? "-active" : "", ".svg");
    var iconEmoji = "/icon/compose-smiley".concat(showEmoji ? "-active" : "", ".svg");
    var iconPinned = "/icon/compose-pinned".concat(isPinned ? "-active" : "", ".svg");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            showEmoji && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* EmojiContainer */.W8, {
                ref: emojiContainerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmojiPicker["default"], {
                    onSelectEmoji: handleSelectEmoji
                })
            }),
            showGif && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* GifContainer */.BU, {
                ref: gifContainerRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GifPicker["default"], {
                    onSelectGif: handleSelectGif,
                    gifColumns: 5
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FooterContainer */.bk, {
                repost: mode === constants/* COMPOSE_MODE.REPOST */.ZX.REPOST,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: openPictureAttachment,
                                title: "Image",
                                src: "/icon/compose-image.svg",
                                alt: "compose-image",
                                isVisible: !isOpenPolling
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: openDocumentAttachment,
                                title: "Attachment",
                                src: "/icon/compose-attach.svg",
                                alt: "compose-attachment",
                                isVisible: !isOpenPolling
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: onClickEmojiButton,
                                title: "Emoji",
                                src: iconEmoji,
                                alt: "compose-emoji",
                                iconRef: emojiButtonRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: onClickGifButton,
                                title: "Gif",
                                src: iconGif,
                                alt: "compose-gif",
                                isVisible: !isOpenPolling,
                                iconRef: gifButtonRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: onClickTooglePolling,
                                title: "Poling",
                                src: "/icon/compose-pols.svg",
                                alt: "compose-pols",
                                isVisible: showPollingButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFooter/* default */.Z, {
                                onClick: onClickToggleTargetPrice,
                                title: "Target",
                                src: "/icon/compose-target.svg",
                                alt: "compose-target",
                                isVisible: mode !== constants/* COMPOSE_MODE.SHARE_TEXT */.ZX.SHARE_TEXT
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            showPinButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonPinned */.VB, {
                                type: "borderless",
                                htmlType: "button",
                                height: "28px",
                                onClick: onTogglePin,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                        src: iconPinned,
                                        alt: "compose-pin",
                                        className: "compose-pin-icon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.midgray */.Z.midgray,
                                        size: "12px",
                                        children: "Pin this post"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "borderless",
                                htmlType: "button",
                                height: "28px",
                                onClick: handleClickCancel,
                                disabled: isLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.primary */.Z.primary,
                                    family: "bold",
                                    size: "12px",
                                    children: "Cancel"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonSubmit */.GX, {
                                type: "primary",
                                htmlType: "submit",
                                height: "28px",
                                onClick: handleClickSubmit,
                                disabled: isSubmitDisabled,
                                loading: isLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "inherit",
                                    family: "bold",
                                    size: "12px",
                                    children: "Post"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        ref: pictureRef,
                        style: {
                            display: "none"
                        },
                        accept: "image/*",
                        onChange: handleChangePicture,
                        multiple: !isPostComment
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        ref: documentRef,
                        style: {
                            display: "none"
                        },
                        accept: constants/* ALLOWED_DOC_EXT.join */.ox.join(","),
                        onChange: handleChangeDocument,
                        multiple: true
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamCompose_Footer = (Footer);

// EXTERNAL MODULE: ./src/global/ImageSlider/Modal/index.tsx + 2 modules
var Modal = __webpack_require__(52579);
// EXTERNAL MODULE: ./src/global/StreamCompose/ImageContainer/styled.ts
var ImageContainer_styled = __webpack_require__(23529);
;// CONCATENATED MODULE: ./src/global/StreamCompose/ImageContainer/Item.tsx



function ImageItem(param) {
    var imageSrc = param.image, onDelete = param.onDelete, dimensions = param.dimensions, onClick = param.onClick;
    if (!imageSrc) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var haveWings = (dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) > (dimensions === null || dimensions === void 0 ? void 0 : dimensions.width);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageContainer_styled/* Relative */.Ig, {
        draggable: "false",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer_styled/* CloseWrapper */.R8, {
                onClick: onDelete,
                draggable: "false",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer_styled/* IconClose */.bM, {
                    className: "icon-compose_close"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer_styled/* Container */.W2, {
                onClick: onClick,
                haveWings: haveWings,
                draggable: "false",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer_styled/* ImgUpload */.rd, {
                    draggable: "false",
                    alt: "uploader",
                    src: imageSrc
                })
            })
        ]
    });
}
/* harmony default export */ var Item = (/*#__PURE__*/react.memo(ImageItem));

;// CONCATENATED MODULE: ./src/global/StreamCompose/ImageContainer/index.tsx




function ImageList(param) {
    var images = param.images, onResetImage = param.onResetImage;
    var ref = (0,react.useState)(false), isModalVisible = ref[0], setVisibilityModal = ref[1];
    var ref1 = (0,react.useState)(0), active = ref1[0], setActive = ref1[1];
    var transformedImages = (0,react.useMemo)(function() {
        return images.map(function(item) {
            return item.imagePreviewUrl;
        });
    }, [
        images
    ]);
    if (images.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    var onClickImage = function(i) {
        setActive(i);
        setVisibilityModal(!isModalVisible);
    };
    var renderImageList = function() {
        return images.map(function(image, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                onClick: function() {
                    return onClickImage(i);
                },
                image: image.imagePreviewUrl,
                dimensions: image.dimensions,
                onDelete: function() {
                    return onResetImage(i);
                }
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderImageList(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                images: transformedImages,
                visible: isModalVisible,
                onClose: function() {
                    return setVisibilityModal(false);
                },
                active: active,
                setActive: setActive
            })
        ]
    });
}
/* harmony default export */ var ImageContainer = (/*#__PURE__*/react.memo(ImageList));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/lib/entities/user.js
var user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/StreamCompose/styled.ts
var StreamCompose_styled = __webpack_require__(94134);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Textarea/index.tsx
















function Textarea(_param) {
    var value = _param.value, onChange = _param.onChange, onSearch = _param.onSearch, isExpand = _param.isExpand, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "onSearch",
        "isExpand"
    ]);
    var ref = (0,react.useState)(""), searchKeyword = ref[0], setSearchKeyword = ref[1];
    var ref1 = (0,react.useState)("@"), mentionPrefix = ref1[0], setMentionPrefix = ref1[1];
    var ref2 = (0,react.useState)(0), timeInterval = ref2[0], setTimeInterval = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,es/* useSelector */.v9)(user/* selectors */.wl), _search = ref3.search, userSearch = _search.data;
    var ref4 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search1 = ref4.search, companySearch = _search1.data;
    var SEARCH_DATA = {
        "@": {
            data: userSearch,
            dispatch: user/* effects.searchUser */.Sz.searchUser
        },
        $: {
            data: companySearch,
            dispatch: company/* effects.getSearchCompany */.Sz.getSearchCompany
        }
    };
    var handleSearch = function(keyword, prefix) {
        setSearchKeyword(keyword);
        setMentionPrefix(prefix);
        var action = SEARCH_DATA[prefix].dispatch;
        if (keyword.length >= 2) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                dispatch(action(keyword));
            }, 500));
        }
    };
    var searchResult = (0,react.useMemo)(function() {
        if (searchKeyword.length >= 2) {
            var ref;
            return (ref = SEARCH_DATA[mentionPrefix]) === null || ref === void 0 ? void 0 : ref.data;
        }
        return [];
    }, [
        userSearch,
        companySearch,
        searchKeyword
    ]);
    (0,react.useEffect)(function() {
        if (isExpand && value.length) {
            setTimeout(function() {
                onChange("");
                onChange(value);
            }, 0);
        }
    }, [
        isExpand
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: isExpand,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_styled/* MentionSuggestionResult */.np, {
                id: "compose-mention-container"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_styled/* TextareaMentions */.Xf, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                prefix: [
                    "@",
                    "$"
                ],
                value: value,
                onChange: onChange,
                onSearch: handleSearch,
                notFoundContent: null,
                getPopupContainer: function() {
                    return document.getElementById("compose-mention-container");
                },
                autoFocus: true,
                children: searchResult.map(function(_param, index) /*#__PURE__*/ {
                    var id = _param.id, name = _param.name, data = (0,_object_without_properties/* default */.Z)(_param, [
                        "id",
                        "name"
                    ]);
                    return (0,jsx_runtime.jsx)(StreamCompose_styled/* MentionOption */.wo, {
                        value: name,
                        className: "compose-mention-option",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            align: "center",
                            children: [
                                mentionPrefix === "@" && // @ts-expect-error
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    size: "x-small",
                                    mr: "8px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                        alt: "avatar-user",
                                        src: "".concat(api/* AVATAR_URL */.q$, "/").concat(data.img),
                                        onError: function(e) {
                                            return (0,general/* handleErrorAvatar */.Tk)(e, name);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    mr: "8px",
                                    children: [
                                        mentionPrefix,
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: data.desc
                                })
                            ]
                        })
                    }, "".concat(id, "-").concat(index));
                })
            }))
        ]
    });
}
/* harmony default export */ var StreamCompose_Textarea = (Textarea);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconBase64.js
var IconBase64 = __webpack_require__(37949);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/assets/base64icon/index.js
var base64icon = __webpack_require__(54392);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  width: calc(100% - 60px);\n\n  .ant-input-affix-wrapper {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input::placeholder {\n    font-family: var(--font-bold);\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: -18px;\n  top: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 20px;\n  right: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 5px;\n  width: 100%;\n  label {\n    font-size: 12px;\n    padding-right: 6px;\n  }\n  select {\n    padding: 0px 20px 0px 6px;\n    height: 28px;\n    border: 1px solid ",
        ";\n    width: calc(100% - 50px);\n  }\n  label,\n  select {\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    justify-content: left;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n  padding-top: 15px;\n  margin-top: 15px;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  white-space: nowrap;\n  width: 100%;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 28px;\n  color: ",
        ";\n  & > span {\n    font-size: 14px;\n    color: ",
        ";\n    max-width: 100px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    vertical-align: middle;\n    cursor: pointer;\n  }\n  @media ",
        " {\n    & > span {\n      max-width: unset;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media ",
        " {\n    padding-left: 12px;\n    input,\n    button {\n      display: inline-block;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -28px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  @media ",
        " {\n    position: relative;\n    right: unset;\n    bottom: unset;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: 1px solid ",
        ";\n  padding: 20px 20px 20px 30px;\n  background: ",
        ";\n  margin-bottom: 20px;\n  border-radius: 0 0 3px 3px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-bottom: none;\n  padding: 20px 20px 20px 30px;\n  border-radius: 3px 3px 0 0;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}









var InputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-0"
})(_templateObject());
var styled_Input = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-79f173cc-1"
})(_templateObject1(), color/* default.midgray */.Z.midgray);
var IconAbsolute = (0,styled_components_browser_esm/* default */.ZP)(IconBase64/* default */.Z).attrs({
    iconSize: "16px"
}).withConfig({
    componentId: "sc-79f173cc-2"
})(_templateObject2());
var IconRemove = (0,styled_components_browser_esm/* default */.ZP)(IconAbsolute).attrs({
    icon: base64icon/* removeIcon */.O4
}).withConfig({
    componentId: "sc-79f173cc-3"
})(_templateObject3());
var IconClose = (0,styled_components_browser_esm/* default */.ZP)(IconAbsolute).attrs({
    icon: base64icon/* pollingCloseIcon */.wJ
}).withConfig({
    componentId: "sc-79f173cc-4"
})(_templateObject4());
// Polling checkbox
var CheckBoxContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-5"
})(_templateObject5());
// Polling date
var SelectDateWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-6"
})(_templateObject6(), color/* default.gainsboro */.Z.gainsboro, // @ts-expect-error
function(param) {
    var disabled = param.disabled;
    return disabled ? color/* default.midgray */.Z.midgray : color/* default.highempahis */.Z.highempahis;
}, device/* default.tablet */.Z.tablet);
// Pinned polling
var PinnedPollingLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-7"
})(_templateObject7());
// Polling footer
var PollingFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-8"
})(_templateObject8(), color/* default.gainsboro */.Z.gainsboro);
var ReverseFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79f173cc-9"
})(_templateObject9(), device/* default.tablet */.Z.tablet);
var PollingTimeLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-79f173cc-10"
})(_templateObject10(), color/* default.midgray */.Z.midgray, color/* default.primary */.Z.primary, device/* default.tablet */.Z.tablet);
var PollingTimeContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f173cc-11"
})(_templateObject11(), device/* default.tablet */.Z.tablet);
var ButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-79f173cc-12"
})(_templateObject12(), color/* default.gainsboro */.Z.gainsboro, color/* default.whisper */.Z.whisper, color/* default.highempahis */.Z.highempahis, device/* default.tablet */.Z.tablet);
var PollingContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f173cc-13"
})(_templateObject13(), color/* default.gainsboro */.Z.gainsboro, color/* default.snow */.Z.snow);
var PollingTextBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-79f173cc-14"
})(_templateObject14(), color/* default.gainsboro */.Z.gainsboro);


;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/Checkbox.tsx








var CheckBox = /*#__PURE__*/ react.memo(function(_param) {
    var label = _param.label, onChange = _param.onChange, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "onChange",
        "className"
    ]);
    var inputRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckBoxContainer, {
        className: className,
        onClick: function() {
            return onChange(inputRef);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                type: "checkbox",
                ref: inputRef,
                onChange: function() {
                    return onChange(inputRef);
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                color: color/* default.midgray */.Z.midgray,
                padding: "0 4px",
                children: label
            })
        ]
    });
});
/* harmony default export */ var Checkbox = (CheckBox);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/PollingPinnedLabel.tsx









function PollingPinnedLabel(_param) {
    var children = _param.children, onClick = _param.onClick, isActive = _param.isActive, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "onClick",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PinnedPollingLabelContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onClick: onClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                size: "20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    className: "icon-toolbar_pinned".concat(isActive ? "-fill" : ""),
                    size: "20px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                color: color/* default.midgray */.Z.midgray,
                children: children
            })
        ]
    }));
}
/* harmony default export */ var Polling_PollingPinnedLabel = (PollingPinnedLabel);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/SelectDate.tsx







var SelectDate = /*#__PURE__*/ react.memo(function(_param) // @ts-expect-error
/*#__PURE__*/ {
    var label = _param.label, children = _param.children, className = _param.className, disabled = _param.disabled, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "children",
        "className",
        "disabled",
        "onChange"
    ]);
    return (0,jsx_runtime.jsxs)(SelectDateWrapper, {
        className: className,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                as: "label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                onChange: onChange,
                disabled: disabled,
                style: {
                    height: "28px"
                },
                children: children
            }))
        ]
    });
});
/* harmony default export */ var Polling_SelectDate = (SelectDate);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/RenderSelectList.tsx
/* eslint-disable react/no-array-index-key */ 




var RenderSelectList = /*#__PURE__*/ react.memo(function(param) {
    var isSelectDisable = param.isSelectDisable, selectValue = param.selectValue, setSelectValue = param.setSelectValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_SelectDate, {
                label: "Days",
                disabled: isSelectDisable,
                value: selectValue.Days,
                onChange: function(el) {
                    return setSelectValue({
                        Days: el.currentTarget.value
                    });
                },
                children: (0,_to_consumable_array/* default */.Z)(Array(31)).map(function(_el, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "option",
                        children: i
                    }, i);
                })
            }, "Days"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_SelectDate, {
                label: "Hours",
                disabled: isSelectDisable,
                value: selectValue.Hours,
                onChange: function(el) {
                    return setSelectValue({
                        Hours: el.currentTarget.value
                    });
                },
                children: (0,_to_consumable_array/* default */.Z)(Array(24)).map(function(_el, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "option",
                        children: i
                    }, i);
                })
            }, "Hours"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_SelectDate, {
                label: "Mins",
                disabled: isSelectDisable,
                value: selectValue.Mins,
                onChange: function(el) {
                    return setSelectValue({
                        Mins: el.currentTarget.value
                    });
                },
                children: (0,_to_consumable_array/* default */.Z)(Array(60)).map(function(_el, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "option",
                        children: i
                    }, i);
                })
            }, "Mins")
        ]
    });
});
/* harmony default export */ var Polling_RenderSelectList = (RenderSelectList);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/PollingFooter.tsx









function PollingFooter(param) {
    var onChangeDuration = param.onChangeDuration, onPin = param.onPin, isPinned = param.isPinned, duration = param.duration;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref.data;
    var ref1 = (0,react.useState)(false), isPollingContentVisible = ref1[0], setPollingContentVisibility = ref1[1];
    var ref2 = (0,react.useState)(false), isChecked = ref2[0], setCheckBox = ref2[1];
    var ref3 = (0,react.useState)(false), isSelectDisable = ref3[0], setDisableSelect = ref3[1];
    var handleChangeDuration = function(data) {
        var isUnlimited = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var val = {
            data: data,
            isUnlimited: isUnlimited
        };
        onChangeDuration(val);
    };
    (0,react.useEffect)(function() {
        // initiate polling end on mount
        handleChangeDuration({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleChangePinPolling = function() {
        onPin({
            polling_pin: isPinned ? 0 : 1
        });
    };
    var setPollingLabelTime = function() {
        var filteredSelect = Object.keys(duration).filter(function(e) {
            return duration[e] > 0;
        });
        if (!filteredSelect[0]) {
            return "No end date";
        }
        return filteredSelect.reduce(function(acc, cur) {
            var label = acc;
            label += "".concat(duration[cur], " ").concat(cur, " ");
            return label;
        }, "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingFooterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReverseFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingTimeLabel, {
                        children: [
                            "Poll length :",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: "span",
                                onClick: function() {
                                    return setPollingContentVisibility(true);
                                },
                                children: !isPollingContentVisible && setPollingLabelTime()
                            })
                        ]
                    }),
                    isPollingContentVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingTimeContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReverseFlex, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_RenderSelectList, {
                                        isSelectDisable: isSelectDisable,
                                        selectValue: duration,
                                        setSelectValue: handleChangeDuration
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirm, {
                                        onClick: function() {
                                            return setPollingContentVisibility(false);
                                        },
                                        children: "OK"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                                label: "No end Date",
                                checked: isChecked,
                                onChange: function() {
                                    setCheckBox(!isChecked);
                                    setDisableSelect(!isSelectDisable);
                                    handleChangeDuration({
                                        Days: !isSelectDisable ? 0 : 1,
                                        Hours: 0,
                                        Mins: 0
                                    }, !isChecked);
                                }
                            })
                        ]
                    })
                ]
            }),
            !isPollingContentVisible && parseInt(dataProfile.user_priv, 10) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_PollingPinnedLabel, {
                onClick: handleChangePinPolling,
                isActive: isPinned,
                children: "Pin this polling"
            })
        ]
    });
}
/* harmony default export */ var Polling_PollingFooter = (PollingFooter);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/PollingInputChoice.tsx








function PollingInputChoice(_param) {
    var iconRemove = _param.iconRemove, onChange = _param.onChange, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "iconRemove",
        "onChange"
    ]);
    var ref = (0,react.useState)(25), maxCharLabel = ref[0], setMaxCharLabel = ref[1];
    var maxChar = 25;
    var subtract = function(varible, constant) {
        return constant - varible;
    };
    var suffix = /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        size: "14px",
        color: color/* default.midgray */.Z.midgray,
        children: maxCharLabel
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                onChange: function(e) {
                    onChange(e);
                    setMaxCharLabel(subtract(e.currentTarget.value.length, maxChar));
                },
                maxLength: maxChar,
                height: "40px",
                // @ts-expect-error
                mb: "14px",
                width: "100%",
                suffix: suffix
            })),
            iconRemove && iconRemove()
        ]
    });
}
/* harmony default export */ var Polling_PollingInputChoice = (PollingInputChoice);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/PollingInputChoiceList.tsx








function PollingInputChoiceList(param) {
    var onChangeList = param.onChangeList;
    var ref = (0,react.useState)(0), timeInterval = ref[0], setTimeInterval = ref[1];
    var ref1 = (0,react.useState)([
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: ""
        }, 
    ]), listChoice = ref1[0], setListChoice = ref1[1];
    (0,react.useEffect)(function() {
        var data = {
            polling_options: listChoice
        };
        onChangeList(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listChoice.length
    ]);
    var onChangeInputChoice = function(e, key) {
        var choiceIdx = listChoice.findIndex(function(c) {
            return c.id === key;
        });
        var newChoice = listChoice.map(function(c) {
            return (0,_object_spread/* default */.Z)({}, c);
        });
        if (choiceIdx > -1) {
            newChoice[choiceIdx].value = e.target.value;
            setListChoice(newChoice);
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                onChangeList({
                    polling_options: newChoice
                });
            }, 300));
        }
    };
    var addChoice = function() {
        // Prevent duplicate key if user delete and add new choice
        var newChoiceKey = listChoice[listChoice.length - 1].id + 1;
        setListChoice(function(prevState) {
            return prevState.concat({
                id: newChoiceKey,
                value: ""
            });
        });
    };
    var removeChoice = function(key) {
        setListChoice(function(prevState) {
            return prevState.filter(function(e) {
                return e.id !== key;
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            listChoice.map(function(e, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_PollingInputChoice, {
                    onChange: function(el) {
                        return onChangeInputChoice(el, e.id);
                    },
                    placeholder: "Choice ".concat(e.id),
                    iconRemove: i === listChoice.length - 1 && i > 1 ? function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRemove, {
                            onClick: function() {
                                return removeChoice(e.id);
                            }
                        });
                    } : function() {}
                }, e.id);
            }),
            listChoice.length < 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "borderless",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.primary */.Z.primary,
                    onClick: addChoice,
                    children: "+ Add a Choice"
                })
            })
        ]
    });
}
/* harmony default export */ var Polling_PollingInputChoiceList = (PollingInputChoiceList);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Polling/index.tsx








function Polling(param) {
    var content = param.content, onChangeContent = param.onChangeContent, polling = param.polling, onChangePolling = param.onChangePolling, onClosePolling = param.onClosePolling, isExpand = param.isExpand;
    var handleChangePolling = function(val) {
        var data = (0,_object_spread/* default */.Z)({}, polling, val);
        onChangePolling(data);
    };
    var setTimestampPolling = function(duration) {
        var durationConvert = {
            Days: 24 * 60 * 60,
            Hours: 60 * 60,
            Mins: 60
        };
        var totalTime = Object.entries(duration).reduce(// @ts-ignore
        function(dur, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
            return dur + parseInt(val, 10) * durationConvert[key];
        }, 0);
        // @ts-ignore
        var timeStampTotal = moment_default()(moment_default()().unix()) + totalTime;
        return timeStampTotal;
    };
    var handleChangePollingDuration = function(param) {
        var data = param.data, isUnlimited = param.isUnlimited;
        var newDuration = (0,_object_spread/* default */.Z)({}, polling.duration, data);
        var pollingEnd = isUnlimited ? 0 : setTimestampPolling(newDuration);
        onChangePolling({
            duration: newDuration,
            polling_end: pollingEnd
        });
    };
    var handleClosePolling = function() {
        onClosePolling();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingTextBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_Textarea, {
                    placeholder: "Ask a question...",
                    autoSize: {
                        minRows: 4
                    },
                    value: content,
                    onChange: onChangeContent,
                    isExpand: isExpand
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {
                        onClick: handleClosePolling
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_PollingInputChoiceList, {
                        onChangeList: handleChangePolling
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Polling_PollingFooter, {
                        onPin: handleChangePolling,
                        onChangeDuration: handleChangePollingDuration,
                        isPinned: polling.polling_pin,
                        duration: polling.duration
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamCompose_Polling = (Polling);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 16px;\n  flex-direction: column;\n  width: 100%;\n\n  @media ",
        " {\n    flex-direction: row;\n    align-items: center;\n    width: auto;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n  padding-bottom: 8px;\n\n  @media ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80%;\n\n  input::placeholder {\n    font-family: var(--font-bold);\n    color: ",
        ";\n  }\n\n  @media ",
        " {\n    margin: 0 15px;\n    width: 120px;\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 15px;\n  font-size: 13px;\n  height: 30px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  background: ",
        ";\n\n  :focus {\n    outline: 0;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  width: 80%;\n  padding: 0 4px;\n\n  @media ",
        " {\n    margin: 0 15px;\n    width: 100%;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 0px;\n  height: 30px;\n  width: 100%;\n  padding: 0 12px;\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  flex-direction: column;\n  & > div:not(:first-of-type) {\n    label {\n      display: none;\n    }\n  }\n\n  @media ",
        " {\n    flex-direction: row;\n    & > div:not(:first-of-type) {\n      label {\n        display: block;\n      }\n    }\n  }\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-end;\n  width: 100%;\n  button {\n    font-size: 14px;\n    border: none;\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n    :focus {\n      outline: 0;\n    }\n  }\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






/**
 * Search and input container
 */ var styled_InputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d5693ec8-0"
})(styled_templateObject(), device/* default.tablet */.Z.tablet);
var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "label"
}).withConfig({
    componentId: "sc-d5693ec8-1"
})(styled_templateObject1(), device/* default.tablet */.Z.tablet);
var SearchContainer = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.Z).withConfig({
    componentId: "sc-d5693ec8-2"
})(styled_templateObject2(), color/* default.midgray */.Z.midgray, device/* default.tablet */.Z.tablet);
var TargetPrice_styled_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-d5693ec8-3"
})(styled_templateObject3(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light);
/**
 * Select containers
 */ var SelectContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d5693ec8-4"
})(styled_templateObject4(), color/* default.gainsboro */.Z.gainsboro, device/* default.tablet */.Z.tablet);
var SelectInner = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-d5693ec8-5"
})(styled_templateObject5(), color/* default.light */.Z.light);
var Option = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
    componentId: "sc-d5693ec8-6"
})(styled_templateObject6());
/**
 * Target price main container
 */ var TargetPriceContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d5693ec8-7"
})(styled_templateObject7(), color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet);
var FooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d5693ec8-8"
})(styled_templateObject8(), color/* default.light */.Z.light, color/* default.silver */.Z.silver);


// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/TargetPriceInputNumber.tsx




function TargetPriceInputNumber(param) {
    var price = param.price, onChangePrice = param.onChangePrice;
    var handleChangePrice = function(val) {
        // update redux targetPrice
        var data = {
            target_price: val
        };
        onChangePrice(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_InputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "is"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* InputNumberContainer */.B, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                    step: 1,
                    max: "9007199254740991",
                    min: "0",
                    formatter: function(value) {
                        return numeral_default()(value).format("0,0");
                    },
                    parser: function(value) {
                        return value.replace(",", "");
                    },
                    style: {
                        width: "200px",
                        textAlign: "center"
                    },
                    value: price,
                    onChange: handleChangePrice
                })
            })
        ]
    });
}
/* harmony default export */ var TargetPrice_TargetPriceInputNumber = (TargetPriceInputNumber);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/TargetPriceSearch.tsx








var TargetPriceSearch_Tag = Tag/* default.Tag */.Z.Tag;
function TargetPriceSearch(param) {
    var symbol = param.symbol, onChangeSymbol = param.onChangeSymbol;
    var ref = (0,react.useState)(0), timeInterval = ref[0], setTimeInterval = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    // selectors
    var ref1 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search = ref1.search, dataSearch = _search.data;
    var handleSearch = function(val) {
        // dispatch redux search company disini
        if (val.length > 1) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                dispatch(company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
            }, 1000));
        }
    };
    var handleChange = function(e) {
        var value = e.target.value;
        var data = {
            target_symbol: String(value).toUpperCase()
        };
        onChangeSymbol(data);
    };
    var handleSelectCompany = function(val) {
        // dispatch redux select target symbol disini
        var data = {
            target_symbol: val
        };
        onChangeSymbol(data);
    };
    var options = dataSearch.map(function(param) {
        var name = param.name, desc = param.desc;
        return {
            value: name,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceSearch_Tag, {
                        size: "s",
                        type: "grey",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "10px",
                        size: "13px",
                        ellipsis: true,
                        children: desc
                    })
                ]
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_InputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "My Target Price For"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContainer, {
                options: options,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                onSearch: handleSearch,
                onSelect: handleSelectCompany,
                value: symbol,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPrice_styled_Input, {
                    placeholder: "Stock Symbol",
                    onChange: handleChange
                })
            })
        ]
    });
}
/* harmony default export */ var TargetPrice_TargetPriceSearch = (TargetPriceSearch);

;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/Select.tsx







function Select(_param) {
    var className = _param.className, label = _param.label, children = _param.children, selectRef = _param.selectRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "label",
        "children",
        "selectRef"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_InputContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        size: "30px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-widget_alert",
                            size: "22px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectInner, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: selectRef
                    }, props), {
                        children: children
                    }))
                ]
            })
        ]
    });
}
/* harmony default export */ var TargetPrice_Select = (Select);

;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/TargetPriceSelect.tsx



function TargetPriceSelect(param) {
    var duration = param.duration, onChangeDuration = param.onChangeDuration;
    var handleChange = function(e) {
        var data = {
            target_duration: e.target.value
        };
        onChangeDuration(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TargetPrice_Select, {
        label: "within",
        value: duration,
        selectRef: function() {},
        onChange: handleChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "7",
                children: "1 Week"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "30",
                children: "1 Month"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "90",
                children: "3 Months"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "180",
                children: "6 Months"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "365",
                children: "1 year"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "730",
                children: "2 years"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                value: "1095",
                children: "3 years"
            })
        ]
    });
}
/* harmony default export */ var TargetPrice_TargetPriceSelect = (TargetPriceSelect);

;// CONCATENATED MODULE: ./src/global/StreamCompose/TargetPrice/index.tsx






function TargetPrice(param) {
    var targetPrice = param.targetPrice, onChange = param.onChange, onClose = param.onClose;
    var handleChange = function(val) {
        onChange(val);
    };
    var handleCloseTargetPrice = function() {
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TargetPriceContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPrice_TargetPriceSearch, {
                symbol: targetPrice.target_symbol,
                onChangeSymbol: handleChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPrice_TargetPriceInputNumber, {
                price: targetPrice.target_price,
                onChangePrice: handleChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPrice_TargetPriceSelect, {
                duration: targetPrice.target_duration,
                onChangeDuration: handleChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "button",
                    onClick: handleCloseTargetPrice,
                    children: "Remove"
                })
            })
        ]
    });
}
/* harmony default export */ var StreamCompose_TargetPrice = (TargetPrice);

// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
;// CONCATENATED MODULE: ./src/global/StreamCompose/RepostBox.tsx












function RepostBox(param) {
    var post = param.post;
    var ref;
    var postData = post.repostedfrom ? post.repostedfrom : post;
    var content = postData.content_original, title = postData.title, newsSource = postData.newsfeed_source, newsLabel = postData.newsfeed_label, newsImg = postData.newsfeed_img, avatar = postData.avatar, username = postData.username, official = postData.official, mask_html = postData.mask_html, imagesData = postData.images_data, imageFrameType = postData.image_frame_type;
    var avatarUrl = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith("http")) ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    var trimmedTextContent = (content === null || content === void 0 ? void 0 : content.substring(0, 400)) || "";
    trimmedTextContent = trimmedTextContent.substring(0, Math.min(trimmedTextContent.length, trimmedTextContent.lastIndexOf(" ")));
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* RepostBoxContainer */.Iy, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    mb: "8px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: "x-small",
                            mr: "12px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                                src: avatarUrl,
                                alt: username,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            size: "16px",
                            children: username
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                            deprecatedVerifiedStatus: official > 0,
                            verifiedStatus: postData === null || postData === void 0 ? void 0 : postData.verified_status
                        })
                    ]
                }),
                isHaveImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                    images: imagesData,
                    frameType: imageFrameType,
                    clickable: false
                }),
                title && // @ts-expect-error
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.primary */.Z.primary,
                    mb: "8px",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    height: "22.475px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                        content: content,
                        maskedHtml: mask_html,
                        isDefaultExpand: true,
                        isRepost: true,
                        style: {
                            marginBottom: 0
                        }
                    })
                }),
                newsSource && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                            alt: newsLabel,
                            src: newsImg,
                            style: {
                                width: "16px",
                                marginRight: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "12px",
                            children: newsLabel
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var StreamCompose_RepostBox = (RepostBox);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./src/hooks/useTooltip.ts
var useTooltip = __webpack_require__(30627);
// EXTERNAL MODULE: ./src/features/stream/analytics/CommentAnalytics.ts
var CommentAnalytics = __webpack_require__(90506);
// EXTERNAL MODULE: ./src/global/StreamCompose/CommentSetting/CommentSettingPopover.tsx + 1 modules
var CommentSettingPopover = __webpack_require__(23892);
;// CONCATENATED MODULE: ./src/global/StreamCompose/CommentSetting/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 











var LS_TOOLTIP_COMMENT_SETTING = "tooltipCommentSettings";
var commentSettingTooltipTitle = "Atur siapa yang boleh berkomentar";
var commentSettingTooltipText = "Pilih siapa yang bisa berkomentar di postingan kamu. Pilihan hanya berlaku untuk postingan ini.";
function CommentSetting(param) {
    var commenter = param.commenter, zIndex = param.zIndex, onChangeCommenter = param.onChangeCommenter;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,useTooltip/* default */.Z)(LS_TOOLTIP_COMMENT_SETTING), showTooltip = ref1.showTooltip, onCloseTooltip = ref1.onCloseTooltip;
    var handleChangeCommenter = function(data) {
        onChangeCommenter(data);
        setVisible(false);
        CommentAnalytics/* default.Action.ChooseComment */.Z.Action.ChooseComment(data.label);
    };
    var handleVisibleChange = function(show) {
        setVisible(show);
    };
    var handleClickCommentSetting = function() {
        setVisible(!visible);
        CommentAnalytics/* default.Action.CommentInfo */.Z.Action.CommentInfo();
    };
    (0,react.useEffect)(function() {
        CommentAnalytics/* default.Navigate.ViewPage */.Z.Navigate.ViewPage();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
        visible: visible,
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentSettingPopover/* default */.Z, {
            commenter: commenter,
            commentSettingList: constants/* COMMENT_SETTING_LIST */.l2,
            onChangeCommenter: handleChangeCommenter
        }),
        title: null,
        onVisibleChange: handleVisibleChange,
        trigger: "click",
        placement: "bottomLeft",
        zIndex: zIndex,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            placement: "right",
            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: onCloseTooltip,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.light */.Z.light,
                        family: "bold",
                        size: "12px",
                        // @ts-expect-error
                        mb: "8px",
                        height: "18px",
                        children: commentSettingTooltipTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.light */.Z.light,
                        size: "12px",
                        children: commentSettingTooltipText
                    })
                ]
            }),
            trigger: "click",
            visible: showTooltip,
            onVisibleChange: function() {
                return onCloseTooltip();
            },
            overlayClassName: "tooltip-overlay-green",
            overlayInnerStyle: {
                background: color/* default.primary */.Z.primary,
                width: "295px",
                padding: "12px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamCompose_styled/* ComposeCommentSetting */.nO, {
                onClick: handleClickCommentSetting,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                        src: "icon/".concat(commenter.icon),
                        width: "12",
                        height: "12"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        ml: "4px",
                        mr: "6px",
                        size: "11px",
                        color: color/* default.highgray */.Z.highgray,
                        children: [
                            commenter.label,
                            " can comment"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                        src: "icon/compose-settings/arrow-down.svg",
                        width: "12",
                        height: "12"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var StreamCompose_CommentSetting = (CommentSetting);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Header/index.tsx










function Header(param) {
    var avatar = param.avatar, username = param.username, isExpand = param.isExpand, commenter = param.commenter, mode = param.mode, onExpand = param.onExpand, onChangeCommenter = param.onChangeCommenter;
    var commentSettingZIndex = mode === constants/* COMPOSE_MODE.COMPOSE */.ZX.COMPOSE ? 20 : 99999;
    var avatarUrl = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith("http")) ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        padding: isExpand ? "20px 20px 0 20px" : "20px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(global_Image/* default */.Z, {
                    alt: "avatar",
                    src: avatarUrl,
                    onError: function(e) {
                        return (0,general/* handleErrorAvatar */.Tk)(e, username);
                    }
                })
            }),
            isExpand ? // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                ml: "20px",
                justify: "center",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        size: "16px",
                        mb: "2px",
                        children: username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_CommentSetting, {
                        commenter: commenter,
                        zIndex: commentSettingZIndex,
                        onChangeCommenter: onChangeCommenter
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_styled/* PlaceHolder */.i, {
                onClick: onExpand,
                "data-cy": "stream-compose-textarea-header",
                children: "Tulis ide kamu disini..."
            })
        ]
    });
}
/* harmony default export */ var StreamCompose_Header = (Header);

// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/global/StreamCompose/Modal/styled.ts
var Modal_styled = __webpack_require__(74319);
;// CONCATENATED MODULE: ./src/global/StreamCompose/Modal/ModalFailedPost.tsx










function ModalFailedPost(_param) {
    var onSubmit = _param.onSubmit, onCancel = _param.onCancel, isLoading = _param.isLoading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onSubmit",
        "onCancel",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styled/* ModalConfirm */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onCancel: onCancel,
        centered: true,
        closable: false,
        width: 400,
        zIndex: 1200,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "20px",
            height: "40px",
            family: "bold",
            // @ts-expect-error
            pt: "20px",
            pl: "20px",
            pr: "20px",
            children: "Gagal Memposting"
        }),
        footer: // @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            pb: "20px",
            px: "20px",
            justify: "flex-end",
            align: "flex-end",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    height: "40px",
                    type: "borderless",
                    color: "primary",
                    // @ts-expect-error
                    mx: "9px",
                    onClick: onCancel,
                    children: "Batal"
                }, "cancel"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    height: "40px",
                    width: "126px",
                    onClick: onSubmit,
                    loading: isLoading,
                    children: "Coba Lagi"
                }, "confirm")
            ]
        }),
        maskStyle: {
            backgroundColor: "".concat(color/* default.black */.Z.black).concat((0,hexOpacity/* default */.Z)(80))
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            pt: "10px",
            pb: "20px",
            px: "20px",
            children: "Postingan kamu gagal terkirim. Coba lagi untuk mengirim ulang."
        })
    }));
}
/* harmony default export */ var Modal_ModalFailedPost = (ModalFailedPost);

;// CONCATENATED MODULE: ./src/global/StreamCompose/Modal/ModalMaximumSize.tsx










function ModalMaximumSize(_param) {
    var onCancel = _param.onCancel, isLoading = _param.isLoading, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styled/* ModalConfirm */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onCancel: onCancel,
        centered: true,
        closable: false,
        width: 400,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "20px",
            height: "40px",
            family: "bold",
            // @ts-expect-error
            pt: "20px",
            pl: "20px",
            pr: "20px",
            children: "File too large"
        }),
        footer: // @ts-expect-error
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            pb: "20px",
            px: "20px",
            justify: "flex-end",
            align: "flex-end",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: "primary",
                // @ts-expect-error
                padding: "10px 30px",
                width: "80px",
                height: "40px",
                radius: "4px",
                onClick: onCancel,
                children: "OK"
            }, "confirm")
        }),
        maskStyle: {
            backgroundColor: "".concat(color/* default.black */.Z.black).concat((0,hexOpacity/* default */.Z)(80))
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            pt: "10px",
            pb: "20px",
            px: "20px",
            children: "File is too large and cannot be uploaded. The maximum size for each file is 2MB"
        })
    }));
}
/* harmony default export */ var Modal_ModalMaximumSize = (ModalMaximumSize);

;// CONCATENATED MODULE: ./src/global/StreamCompose/useDropFile.tsx








var DRAG_AREA_CLASSNAME = "show-drag-area";
var IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp", 
];
var DOCUMENT_TYPES = [
    "application/pdf"
];
var MAX_IMAGE_LENGTH = 10;
var isType = function(fileType, types) {
    return types.includes(fileType.toLowerCase());
};
var isImage = function(fileType) {
    return isType(fileType, IMAGE_TYPES);
};
var isDocument = function(fileType) {
    return isType(fileType, DOCUMENT_TYPES);
};
var getImageDimensions = function(file) {
    return new Promise(function(resolved) {
        var i = new Image();
        i.src = file;
        i.onload = function() {
            resolved({
                width: i.width,
                height: i.height
            });
        };
    });
};
function useDropFile(param) {
    var isAllowedToUpload = param.isAllowedToUpload, setDocuments = param.setDocuments, setImages = param.setImages, onErrorMaxSize = param.onErrorMaxSize, images = param.images, documents = param.documents;
    var dropzoneRef = (0,react.useRef)();
    var handleOnDragStart = function(e) {
        e.preventDefault();
        if (isAllowedToUpload) {
            var dropZone = dropzoneRef.current;
            dropZone.classList.add(DRAG_AREA_CLASSNAME);
        }
    };
    var handleOnDragOver = function(e) {
        e.preventDefault();
    };
    var handleOnDrop = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var listDocuments, listImages, dataTransfer, dropZone, arrayDataTransfer, uploadedData, promisesList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        listDocuments = (0,_to_consumable_array/* default */.Z)(documents);
                        listImages = (0,_to_consumable_array/* default */.Z)(images);
                        if (isAllowedToUpload) {
                            dataTransfer = e.dataTransfer;
                            dataTransfer.dropEffect = "copy";
                            dropZone = dropzoneRef === null || dropzoneRef === void 0 ? void 0 : dropzoneRef.current;
                            dropZone.classList.remove(DRAG_AREA_CLASSNAME);
                            if (e.dataTransfer.files.length !== 0 && e.dataTransfer.items) {
                                arrayDataTransfer = Object.values(e.dataTransfer.items);
                                uploadedData = arrayDataTransfer.length > MAX_IMAGE_LENGTH ? arrayDataTransfer.slice(0, MAX_IMAGE_LENGTH) : arrayDataTransfer;
                                promisesList = [];
                                uploadedData.forEach(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                        var process;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (item) {
                                                        process = new Promise(function(resolve, reject) {
                                                            var readerBuffer = new FileReader();
                                                            // @ts-ignore
                                                            var file = item.getAsFile();
                                                            var fileType = file.type, size = file.size;
                                                            var fileSize = size / 1024 / 1024;
                                                            readerBuffer.readAsArrayBuffer(file);
                                                            readerBuffer.onloadend = function() {
                                                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                                                                    var isImageNeverAdded, imagePreviewUrl, dimensions, imageData, deletedExif, isFileNeverAdded;
                                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                                            case 0:
                                                                                if (!isImage(fileType)) {
                                                                                    _ctx.next = 16;
                                                                                    break;
                                                                                }
                                                                                if (!(fileSize > constants/* MAX_IMAGE_SIZE_MB */.Jo)) {
                                                                                    _ctx.next = 5;
                                                                                    break;
                                                                                }
                                                                                {
                                                                                    onErrorMaxSize(true);
                                                                                }
                                                                                _ctx.next = 14;
                                                                                break;
                                                                            case 5:
                                                                                isImageNeverAdded = listImages.findIndex(function(image) {
                                                                                    return image.fileName === (file === null || file === void 0 ? void 0 : file.name);
                                                                                }) === -1;
                                                                                if (!isImageNeverAdded) {
                                                                                    _ctx.next = 14;
                                                                                    break;
                                                                                }
                                                                                imagePreviewUrl = URL.createObjectURL(file);
                                                                                _ctx.next = 10;
                                                                                return getImageDimensions(imagePreviewUrl);
                                                                            case 10:
                                                                                dimensions = _ctx.sent;
                                                                                imageData = {
                                                                                    isNew: true,
                                                                                    type: constants/* IMAGE_TYPE_COMMON */.EZ,
                                                                                    imagePreviewUrl: imagePreviewUrl,
                                                                                    dimensions: dimensions,
                                                                                    fileName: file === null || file === void 0 ? void 0 : file.name
                                                                                };
                                                                                if (fileType === "image/jpeg" || fileType === "image/jpg") {
                                                                                    deletedExif = (0,utils_image/* deleteImageExif */.T)(event.target.result, fileType);
                                                                                    try {
                                                                                        // @ts-ignore
                                                                                        imageData.file = deletedExif;
                                                                                    } catch (err) {
                                                                                        imageData.file = file;
                                                                                    }
                                                                                } else {
                                                                                    imageData.file = file;
                                                                                }
                                                                                // onChangeImage(imageData);
                                                                                resolve({
                                                                                    type: "image",
                                                                                    data: imageData
                                                                                });
                                                                            case 14:
                                                                                _ctx.next = 17;
                                                                                break;
                                                                            case 16:
                                                                                if (isDocument(fileType)) {
                                                                                    if (fileSize > constants/* MAX_FILE_SIZE_MB */.C1) {
                                                                                        reject(new Error("File too large. The maximum size is ".concat(constants/* MAX_FILE_SIZE_MB */.C1, "MB")));
                                                                                    } else {
                                                                                        isFileNeverAdded = listDocuments.findIndex(function(document) {
                                                                                            return document.name === (file === null || file === void 0 ? void 0 : file.name);
                                                                                        }) === -1;
                                                                                        if (isFileNeverAdded) {
                                                                                            // onChangeDocument(file);
                                                                                            resolve({
                                                                                                type: "document",
                                                                                                data: file
                                                                                            });
                                                                                        }
                                                                                    }
                                                                                }
                                                                            case 17:
                                                                            case "end":
                                                                                return _ctx.stop();
                                                                        }
                                                                    }, _callee);
                                                                }));
                                                                return function(event) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }();
                                                        });
                                                        promisesList.push(process);
                                                    }
                                                case 1:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                Promise.all(promisesList).then(function(res) {
                                    // eslint-disable-next-line array-callback-return
                                    res.forEach(function(item) {
                                        if (item.type === "image") {
                                            listImages.push(item.data);
                                        }
                                        if (item.type === "document") {
                                            if (listDocuments.length < 1) {
                                                listDocuments.push(item.data);
                                            } else {
                                                throw new Error(errorMessage/* default.MAX_UPLOAD_FILES */.Z.MAX_UPLOAD_FILES);
                                            }
                                        }
                                    });
                                }).then(function() {
                                    setDocuments(listDocuments);
                                    if (listImages.length < 10) {
                                        setImages(listImages);
                                    }
                                }).catch(function(err) {
                                    (0,AlertMessage/* default */.Z)({
                                        content: err.message,
                                        alertType: "plain-default",
                                        messageType: "error",
                                        hasCloseIcon: false
                                    });
                                });
                            }
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnDrop(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        dropzoneRef: dropzoneRef,
        handleOnDragStart: handleOnDragStart,
        handleOnDragOver: handleOnDragOver,
        handleOnDrop: handleOnDrop
    };
}
/* harmony default export */ var StreamCompose_useDropFile = (useDropFile);

;// CONCATENATED MODULE: ./src/global/StreamCompose/index.tsx



























function StreamCompose(param) {
    var _onCancel = param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, onSubmit = param.onSubmit, isLoading = param.isLoading, _mode = param.mode, mode = _mode === void 0 ? constants/* COMPOSE_MODE.COMPOSE */.ZX.COMPOSE : _mode, initialValues = param.initialValues, post = param.post, autoExpand = param.autoExpand, _showPinned = param.showPinned, showPinned = _showPinned === void 0 ? false : _showPinned;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), _data = ref.data, avatar = _data.avatar, username = _data.username, user_priv = _data.user_priv;
    var defaultExpand = mode !== constants/* COMPOSE_MODE.COMPOSE */.ZX.COMPOSE;
    var ref1 = (0,react.useState)(defaultExpand), isExpand = ref1[0], setIsExpand = ref1[1];
    var showPinButton = constants/* ADMIN_USER_PRIVILEGE.includes */.vS.includes(user_priv) && showPinned;
    // Cannot get component ref using useRef
    var ref2 = (0,react.useState)(null), textAreaComponent = ref2[0], setTextAreaComponent = ref2[1];
    // documents' state
    var ref3 = (0,react.useState)([]), documents = ref3[0], setDocuments = ref3[1];
    var ref4 = (0,react.useState)([]), images = ref4[0], setImages = ref4[1];
    // valueState
    var ref5 = (0,react.useState)(""), content = ref5[0], setContent = ref5[1];
    var ref6 = (0,react.useState)(constants/* initialPolling */.fg), polling = ref6[0], setPolling = ref6[1];
    var ref7 = (0,react.useState)(constants/* initialTargetPrice */.Wk), targetPrice = ref7[0], setTargetPrice = ref7[1];
    var ref8 = (0,react.useState)(constants/* COMMENT_SETTING_LIST.0 */.l2[0]), commenter = ref8[0], setCommenter = ref8[1];
    var ref9 = (0,react.useState)(false), postTypeComment = ref9[0], setPostTypeComment = ref9[1];
    var ref10 = (0,react.useState)(false), errorModalVisible = ref10[0], setErrorModalVisible = ref10[1];
    var ref11 = (0,react.useState)(false), errorModalMaxSizeVisible = ref11[0], setErrorModalMaxSizeVisible = ref11[1];
    var ref12 = (0,react.useState)(false), pinnedPost = ref12[0], setPinnedPost = ref12[1];
    var ref13 = StreamCompose_useDropFile({
        isAllowedToUpload: mode !== constants/* COMPOSE_MODE.SHARE */.ZX.SHARE && isExpand,
        onErrorMaxSize: setErrorModalMaxSizeVisible,
        setDocuments: setDocuments,
        setImages: setImages,
        images: images,
        documents: documents
    }), dropzoneRef = ref13.dropzoneRef, handleOnDragOver = ref13.handleOnDragOver, handleOnDragStart = ref13.handleOnDragStart, handleOnDrop = ref13.handleOnDrop;
    (0,react.useEffect)(function() {
        setTextAreaComponent(document.getElementById("stream-compose-textarea"));
    }, []);
    // Did mount on edit post
    (0,react.useEffect)(function() {
        var isInitialOpen = content === "" && polling === constants/* initialPolling */.fg && targetPrice === constants/* initialTargetPrice */.Wk && documents.length === 0 && images.length === 0;
        // set initial content
        if (initialValues && isInitialOpen) {
            // update states
            setContent(initialValues.content);
            setDocuments(initialValues.documents);
            var _images_data;
            var listImage = (0,stream/* parseExistImage */.Nk)((_images_data = initialValues.images_data) !== null && _images_data !== void 0 ? _images_data : []);
            setImages(listImage);
            //  if there's target price data
            if (initialValues.targetPrice) {
                setTargetPrice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialValues.targetPrice), {
                    isOpen: true
                }));
            }
            if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.commenter_type) {
                var commenterType = constants/* COMMENT_SETTING_LIST.find */.l2.find(function(comment) {
                    return comment.type === (initialValues === null || initialValues === void 0 ? void 0 : initialValues.commenter_type);
                });
                setCommenter(commenterType);
            }
        }
        // set post type if post is comment or not
        if (initialValues && constants/* COMPOSE_MODE.EDIT */.ZX.EDIT === mode) {
            var postId = initialValues.postId, parentPostId = initialValues.parentPostId;
            if (postId !== parentPostId && parentPostId !== 0) {
                setPostTypeComment(true);
            }
        }
        // set to expanded, of course
        if (autoExpand) {
            setIsExpand(true);
        }
    }, [
        autoExpand,
        initialValues
    ]);
    var handleToggleExpand = function() {
        setIsExpand(!isExpand);
    };
    var handleReset = function() {
        var ref;
        var initialContent = (ref = initialValues === null || initialValues === void 0 ? void 0 : initialValues.content) !== null && ref !== void 0 ? ref : "";
        setContent(initialContent);
        setDocuments([]);
        setImages([]);
        setTargetPrice(constants/* initialTargetPrice */.Wk);
        setPolling(constants/* initialPolling */.fg);
        setPinnedPost(false);
    };
    var handleChangeContent = function(text) {
        setContent(text);
    };
    var handleSelectEmoji = function(emoji) {
        // @ts-ignore
        if ((textAreaComponent === null || textAreaComponent === void 0 ? void 0 : textAreaComponent.selectionStart) !== undefined) {
            // @ts-ignore
            var insertEmojiIndex = textAreaComponent === null || textAreaComponent === void 0 ? void 0 : textAreaComponent.selectionStart;
            setContent("".concat("".concat(content.slice(0, insertEmojiIndex), " ").concat(emoji).concat(content.slice(insertEmojiIndex))));
            setTimeout(function() {
                var insertEmojiIndexEnd = insertEmojiIndex + 3; // (space)emoji
                textAreaComponent === null || textAreaComponent === void 0 ? void 0 : textAreaComponent.focus();
                // @ts-ignore
                textAreaComponent === null || textAreaComponent === void 0 ? void 0 : textAreaComponent.setSelectionRange(insertEmojiIndexEnd, insertEmojiIndexEnd);
            }, 0);
            return;
        }
        setContent("".concat(content, " ").concat(emoji, " "));
    };
    var handleChangePolling = function(data) {
        setPolling((0,_object_spread/* default */.Z)({}, polling, data));
    };
    var handleTogglePolling = function(isOpen) {
        setPolling((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* initialPolling */.fg), {
            isOpen: isOpen
        }));
        setTargetPrice(constants/* initialTargetPrice */.Wk);
        // reset attachment data if polling opened
        if (isOpen) {
            setDocuments([]);
            setImages([]);
        }
    };
    var handleChangeTargetPrice = function(data) {
        setTargetPrice((0,_object_spread/* default */.Z)({}, targetPrice, data));
    };
    var handleToggleTargetPrice = function(isOpen) {
        setTargetPrice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* initialTargetPrice */.Wk), {
            isOpen: isOpen
        }));
        if (isOpen) {
            setPolling(constants/* initialPolling */.fg);
        }
    };
    var handleTogglePinned = function() {
        setPinnedPost(!pinnedPost);
    };
    var handleChangeCommenter = function(data) {
        setCommenter(data);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, isopenTarget, price, otherTargetData, contentText, data, isOpen, duration, options, otherPollingData, submit, isError, showRetryModal, isErrorResponse, isSuccess;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        e.preventDefault();
                        if (content) {
                            _ctx.next = 5;
                            break;
                        }
                        (0,AlertMessage/* default */.Z)({
                            content: errorMessage/* default.STREAM_TEXT_REQUIRED */.Z.STREAM_TEXT_REQUIRED,
                            alertType: "plain-default",
                            messageType: "error"
                        });
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(targetPrice.isOpen && (targetPrice.target_price <= 0 || targetPrice.target_price === undefined))) {
                            _ctx.next = 8;
                            break;
                        }
                        (0,AlertMessage/* default */.Z)({
                            content: errorMessage/* default.STREAM_TARGET_PRICE_REQUIRED */.Z.STREAM_TARGET_PRICE_REQUIRED,
                            alertType: "plain-default",
                            messageType: "error"
                        });
                        return _ctx.abrupt("return");
                    case 8:
                        isopenTarget = targetPrice.isOpen, price = targetPrice.target_price, otherTargetData = (0,_object_without_properties/* default */.Z)(targetPrice, [
                            "isOpen",
                            "target_price"
                        ]);
                        contentText = "".concat(content.trim().replace(/\n{3,}/gm, "\n\n"));
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            content: contentText,
                            image: images,
                            file: documents
                        }, otherTargetData), {
                            target_price: price.toFixed(6),
                            commenter_type: commenter.type
                        });
                        // inject polling data if polling opened
                        if (polling.isOpen && mode !== constants/* COMPOSE_MODE.EDIT */.ZX.EDIT) {
                            isOpen = polling.isOpen, duration = polling.duration, options = polling.polling_options, otherPollingData = (0,_object_without_properties/* default */.Z)(polling, [
                                "isOpen",
                                "duration",
                                "polling_options"
                            ]);
                            data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                polling: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherPollingData), {
                                    polling_options: JSON.stringify(options)
                                })
                            });
                        }
                        // post with pinned post
                        if (pinnedPost) {
                            data.isPinned = pinnedPost;
                        }
                        _ctx.next = 15;
                        return onSubmit(data);
                    case 15:
                        submit = _ctx.sent;
                        isError = (0,_instanceof/* default */.Z)(submit, Error);
                        showRetryModal = isError && (images.length > 0 || documents.length > 0) && (submit === null || submit === void 0 ? void 0 : submit.message) === errorMessage/* default.STREAM_ERROR_UPLOAD_FILE */.Z.STREAM_ERROR_UPLOAD_FILE;
                        // Check if it can be retryable
                        if (showRetryModal) {
                            setErrorModalVisible(true);
                        }
                        isErrorResponse = (submit === null || submit === void 0 ? void 0 : (ref = submit.response) === null || ref === void 0 ? void 0 : ref.status) >= 500;
                        if (isError && (submit === null || submit === void 0 ? void 0 : submit.message) === "Network Error" || isErrorResponse) {
                            (0,AlertMessage/* default */.Z)({
                                content: "Postingan kamu gagal terkirim. Coba lagi untuk mengirim ulang.",
                                alertType: "snackbar",
                                messageType: "error",
                                hasCloseIcon: true
                            });
                        }
                        isSuccess = !isError && !submit;
                        if (isSuccess) {
                            handleReset();
                            setIsExpand(false);
                            setErrorModalVisible(false);
                        }
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        // reset local state and redux
        handleReset();
        setIsExpand(false);
        // if user want to add additional cancel
        // like close modal on click cancel buton, etc.
        onCancel();
    };
    var handleResetImage = function(i) {
        var newImages = Array.from(images);
        newImages.splice(i, 1);
        setImages(newImages);
    };
    var handleCloseFailedModal = function() {
        setErrorModalVisible(false);
        handleReset();
        setIsExpand(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_styled/* ComposeBox */.yz, {
        noBorder: mode !== constants/* COMPOSE_MODE.COMPOSE */.ZX.COMPOSE,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onDragEnter: handleOnDragStart,
            onDragOver: handleOnDragOver,
            onDrop: handleOnDrop,
            ref: dropzoneRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_Header, {
                            avatar: avatar,
                            username: username,
                            isExpand: isExpand,
                            commenter: commenter,
                            mode: mode,
                            onExpand: handleToggleExpand,
                            onChangeCommenter: handleChangeCommenter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamCompose_styled/* ComposeContent */.Hp, {
                                isExpand: isExpand,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamCompose_styled/* ComposePostContent */.ci, {
                                        mode: mode,
                                        children: [
                                            polling.isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_Polling, {
                                                content: content,
                                                onChangeContent: handleChangeContent,
                                                polling: polling,
                                                onChangePolling: handleChangePolling,
                                                onClosePolling: function() {
                                                    return handleTogglePolling(false);
                                                },
                                                isExpand: isExpand
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_Textarea, {
                                                        id: "stream-compose-textarea",
                                                        placeholder: "Tulis ide kamu disini...",
                                                        value: content,
                                                        onChange: handleChangeContent,
                                                        "data-cy": "stream-compose-textarea",
                                                        isExpand: isExpand
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_styled/* ImageListContainer */.$l, {
                                                        hasImage: images.length > 0,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                                                            images: images,
                                                            onResetImage: function(i) {
                                                                return handleResetImage(i);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mb: documents.length > 0 ? "20px" : "0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileContainer/* default */.Z, {
                                                            documents: documents,
                                                            onSetDocuments: setDocuments
                                                        })
                                                    }),
                                                    targetPrice.isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_TargetPrice, {
                                                        targetPrice: targetPrice,
                                                        onChange: handleChangeTargetPrice,
                                                        onClose: function() {
                                                            return handleToggleTargetPrice(false);
                                                        }
                                                    })
                                                ]
                                            }),
                                            mode === constants/* COMPOSE_MODE.REPOST */.ZX.REPOST && post && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_RepostBox, {
                                                post: post
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose_Footer, {
                                        mode: mode,
                                        onCancel: handleCancel,
                                        onSubmit: handleSubmit,
                                        isLoading: isLoading,
                                        onSelectEmoji: handleSelectEmoji,
                                        onSelectGif: setImages,
                                        isOpenPolling: polling.isOpen,
                                        isPinned: pinnedPost,
                                        onTogglePolling: function() {
                                            return handleTogglePolling(!polling.isOpen);
                                        },
                                        onToggleTargetPrice: function() {
                                            return handleToggleTargetPrice(!targetPrice.isOpen);
                                        },
                                        onTogglePin: handleTogglePinned,
                                        documents: documents,
                                        onSetDocuments: setDocuments,
                                        onSetImages: setImages,
                                        onErrorMaxSize: setErrorModalMaxSizeVisible,
                                        images: images,
                                        isSubmitDisabled: content.length === 0,
                                        isPostComment: postTypeComment,
                                        showPinButton: showPinButton
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalFailedPost, {
                    onSubmit: function(e) {
                        return handleSubmit(e);
                    },
                    onCancel: handleCloseFailedModal,
                    visible: errorModalVisible,
                    isLoading: isLoading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalMaximumSize, {
                    onCancel: function() {
                        return setErrorModalMaxSizeVisible(false);
                    },
                    visible: errorModalMaxSizeVisible
                })
            ]
        })
    });
}
/* harmony default export */ var global_StreamCompose = (StreamCompose);


/***/ }),

/***/ 94134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ ImageListContainer; },
/* harmony export */   "Hp": function() { return /* binding */ ComposeContent; },
/* harmony export */   "U6": function() { return /* binding */ CommentSettingContainer; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "Xf": function() { return /* binding */ TextareaMentions; },
/* harmony export */   "ci": function() { return /* binding */ ComposePostContent; },
/* harmony export */   "i": function() { return /* binding */ PlaceHolder; },
/* harmony export */   "nO": function() { return /* binding */ ComposeCommentSetting; },
/* harmony export */   "np": function() { return /* binding */ MentionSuggestionResult; },
/* harmony export */   "wo": function() { return /* binding */ MentionOption; },
/* harmony export */   "yz": function() { return /* binding */ ComposeBox; }
/* harmony export */ });
/* unused harmony export Textarea */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46457);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79030);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n      padding: 0px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  transition: height 0.2s ease;\n  background: ",
        ";\n  border-radius: 3px;\n\n  .show-drag-area {\n    border-style: dashed;\n    border-width: 2px;\n    border-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: block;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: none;\n  margin-top: 24px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 15px;\n  line-height: 50px;\n  padding-left: 20px;\n  color: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none !important;\n  box-shadow: none !important;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none !important;\n  box-shadow: none !important;\n  font-family: 'ProximaNovaRg';\n  margin-bottom: 12px;\n  resize: none;\n  width: 100%;\n\n  textarea {\n    padding: 0;\n  }\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: scroll;\n  height: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 11.5px;\n  width: max-content;\n  cursor: pointer;\n  padding: 0 6px;\n  height: 23px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  width: 280px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      max-height: 340px;\n      overflow-y: auto;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-bottom: 20px;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    .ant-mentions-dropdown-menu-item {\n      border-bottom: 1px solid #f5f6f5;\n      height: 40px;\n\n      & > div {\n        height: -webkit-fill-available;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-active {\n      p {\n        font-family: var(--font-bold) !important;\n      }\n    }\n    .ant-mentions-dropdown-menu-item-disabled {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}








var TextArea = _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"].TextArea */ .Z.TextArea;
var MentionOption = antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Option */ .Z.Option;
// Compose box components
var ComposeBox = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed3bd63c-0"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject());
});
var ComposeContent = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed3bd63c-1"
})(_templateObject3(), function(param) {
    var isExpand = param.isExpand;
    return isExpand && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject2());
});
var PlaceHolder = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ed3bd63c-2"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].midgray */ .Z.midgray);
var Textarea = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(TextArea).attrs(function(props) {
    return {
        placeholder: props.placeholder || "Write here...",
        autoSize: props.autoSize || {
            minRows: 3
        }
    };
}).withConfig({
    componentId: "sc-ed3bd63c-3"
})(_templateObject5());
var TextareaMentions = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs(function(props) {
    return {
        placeholder: props.placeholder || "Write here...",
        autoSize: props.autoSize || {
            minRows: 3
        }
    };
}).withConfig({
    componentId: "sc-ed3bd63c-4"
})(_templateObject6());
var ImageListContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ed3bd63c-5"
})(_templateObject7(), function(param) {
    var hasImage = param.hasImage;
    return hasImage ? "auto" : "0px";
});
var ComposeCommentSetting = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-ed3bd63c-6"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].downgray */ .Z.downgray);
var CommentSettingContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed3bd63c-7"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].downgray */ .Z.downgray);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ed3bd63c-8"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary);
var ComposePostContent = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed3bd63c-9"
})(_templateObject13(), function(param) {
    var mode = param.mode;
    return mode !== _constants__WEBPACK_IMPORTED_MODULE_6__/* .COMPOSE_MODE.COMPOSE */ .ZX.COMPOSE && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject11());
}, function(param) {
    var mode = param.mode;
    return mode === _constants__WEBPACK_IMPORTED_MODULE_6__/* .COMPOSE_MODE.REPOST */ .ZX.REPOST && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject12());
});
var MentionSuggestionResult = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed3bd63c-10"
})(_templateObject14());



/***/ }),

/***/ 16047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65299);





function EmptySearch() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .EmptyStateWrapper */ .$c, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                src: "/illustration/search-friends-not-found.svg",
                alt: "Empty Search Result"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ContentWrapper */ .vs, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    size: "14px",
                    mt: "16px",
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highgray */ .Z.highgray,
                    children: "Tidak ada hasil yang ditemukan"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EmptySearch);


/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ ButtonDiscover; },
/* harmony export */   "$c": function() { return /* binding */ EmptyStateWrapper; },
/* harmony export */   "Ei": function() { return /* binding */ Img; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "xY": function() { return /* binding */ ButtonCompose; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 60vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  height: 44px;\n  margin: auto;\n  width: 200px;\n\n  :hover {\n    background: #3a3a3a;\n    border-color: #3a3a3a;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 13px;\n  height: 40px;\n  margin: auto;\n  width: 150px;\n  border-radius: 4px;\n  border: 1px solid #00ab6b;\n  background: #ffffff;\n  color: #00ab6b;\n  font-weight: bold;\n\n  svg {\n    margin-right: 4px;\n  }\n\n  :hover,\n  :focus {\n    border: 1px solid #00ab6b;\n    background: #ffffff;\n    color: #00ab6b;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var EmptyStateWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bcc16102-0"
})(_templateObject());
var Img = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bcc16102-1"
})(_templateObject1());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bcc16102-2"
})(_templateObject2(), _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var ButtonDiscover = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-bcc16102-3"
})(_templateObject3());
var ButtonCompose = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bcc16102-4"
})(_templateObject4());



/***/ }),

/***/ 77977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ Popover_PopoverCompany; },
  "q": function() { return /* reexport */ Popover_PopoverUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/utils.ts
var utils = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-left: none;\n  height: 30px;\n  padding: 2px 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 200px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-left: 5px solid ",
        ";\n  height: 30px;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1 1 auto;\n\n  border-left: 0;\n  border-bottom: 0;\n  :last-child {\n    border-right: 0;\n  }\n\n  &:hover,\n  &:focus {\n    border-left: 0;\n    border-bottom: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\25B2';\n    display: inline-block;\n    font-size: 13px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n"
    ], [
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\\\25B2';\n    display: inline-block;\n    font-size: 13px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 4px;\n    padding-left: 5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  word-break: break-word;\n  max-height: 90px;\n  overflow: hidden;\n  min-height: 50px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: none;\n  margin-bottom: 0;\n  padding: 10px 10px 11px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 18px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 2px 5px;\n  color: ",
        ";\n  border: 1px solid rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var IconMore = (0,styled_components_browser_esm/* default */.ZP)(IconMoreOptions/* default */.Z).withConfig({
    componentId: "sc-99b8e37a-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
var OptionItem = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "a",
    height: "28px",
    padding: "0 10px"
}).withConfig({
    componentId: "sc-99b8e37a-1"
})(_templateObject1(), color/* default.whisper */.Z.whisper);
// This container will be replaced with chart plotter library
var PlainChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b8e37a-2"
})(_templateObject2(), color/* default.gainsboro */.Z.gainsboro);
var CompanySymbol = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        valueType: props.valueType || "none"
    };
}).withConfig({
    componentId: "sc-99b8e37a-3"
})(_templateObject3(), color/* default.highempahis */.Z.highempahis, function(props) {
    return props.valueType;
});
var ButtonFooter = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    height: "30px"
}).withConfig({
    componentId: "sc-99b8e37a-4"
})(_templateObject4());
var IconStockChange = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).withConfig({
    componentId: "sc-99b8e37a-5"
})(_templateObject5());
var TextAbout = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    height: "21px"
}).withConfig({
    componentId: "sc-99b8e37a-6"
})(_templateObject6());
var EmptyChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b8e37a-7"
})(_templateObject7(), color/* default.light */.Z.light);
var EmptyChartText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "13px",
    color: color/* default.highgray */.Z.highgray
}).withConfig({
    componentId: "sc-99b8e37a-8"
})(_templateObject8());
var SuspendedBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b8e37a-9"
})(_templateObject9(), color/* default.sunsetOrange */.Z.sunsetOrange);


// EXTERNAL MODULE: ./node_modules/chartjs-adapter-date-fns/dist/chartjs-adapter-date-fns.esm.js + 32 modules
var chartjs_adapter_date_fns_esm = __webpack_require__(66543);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentCompany/StockChart.tsx








function StockChart(param) {
    var chart = param.chart;
    var ref = chart !== null && chart !== void 0 ? chart : {}, _prices = ref.prices, prices = _prices === void 0 ? [] : _prices, _previous = ref.previous, previous = _previous === void 0 ? 0 : _previous;
    var fillColor = color/* default.clearDay */.Z.clearDay;
    var lineColor = color/* default.mountainMeadow */.Z.mountainMeadow;
    var data = {
        labels: prices.map(function(price) {
            return price.formatted_date && price.date !== "0" ? moment_default()(price.formatted_date).format("HH:mm") : "";
        }),
        datasets: [
            {
                fill: true,
                tension: 0,
                backgroundColor: fillColor,
                borderColor: lineColor,
                borderCapStyle: "butt",
                borderDashOffset: 0.0,
                borderDash: [],
                borderJoinStyle: "miter",
                borderWidth: 1.75,
                data: prices.map(function(pr) {
                    return parseInt(pr.value, 10);
                })
            }, 
        ]
    };
    var options = {
        layout: {
            padding: {
                top: 40,
                right: 10,
                left: 10,
                bottom: 10
            }
        },
        animation: {
            duration: 0
        },
        resizeDelay: 0,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        },
        scales: {
            y: {
                position: "right",
                grid: {
                    display: false,
                    drawBorder: false
                },
                ticks: {
                    maxTicksLimit: 5,
                    callback: function callback(val) {
                        var price = val;
                        // if price contain decimal, then hide tick
                        if (typeof price === "number" && price % 1 !== 0) price = null;
                        return price || null;
                    }
                }
            },
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    align: "start",
                    maxTicksLimit: 5,
                    maxRotation: 0,
                    callback: function callback(val) {
                        // @ts-ignore
                        // eslint-disable-next-line react/no-this-in-sfc
                        return this.getLabelForValue(Number(val)) || null;
                    }
                }
            }
        },
        elements: {
            point: {
                radius: 0
            }
        }
    };
    var finalChartData = (0,react.useMemo)(function() {
        if (prices.length === 0) {
            return {
                datasets: [
                    {
                        data: previous ? [
                            previous,
                            previous
                        ] : [],
                        borderColor: "#E5E5E5",
                        borderDash: [
                            4,
                            4
                        ],
                        borderWidth: 1,
                        fill: false
                    }, 
                ],
                labels: [
                    "",
                    ""
                ]
            };
        }
        return data;
    }, [
        data,
        previous,
        prices
    ]);
    if (chart === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyChartContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/illustration/chart-unavailable.svg",
                    alt: "Empty Chart"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChartText, {
                    children: "Data Chart Belum Tersedia"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: finalChartData,
        options: options
    });
}
/* harmony default export */ var PopoverContentCompany_StockChart = (StockChart);

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var StreamWidget_constants = __webpack_require__(21390);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentCompany/StockChangeWrapper.tsx








function StockChangeWrapper(param) {
    var _symbol = param.symbol, _symbol1 = _symbol.symbol, symbol = _symbol1 === void 0 ? "" : _symbol1, _change = _symbol.change, change = _change === void 0 ? "0" : _change, _price = _symbol.price, price = _price === void 0 ? "0" : _price, _percentage = _symbol.percentage, percentage = _percentage === void 0 ? 0 : _percentage, _status = _symbol.status, status = _status === void 0 ? "" : _status;
    var isCompanySuspended = status === "STATUS_SUSPENDED";
    var isCompanyDelisted = status === "STATUS_DELISTED";
    var numeralChange = (0,react.useMemo)(function() {
        return numeral_default()(change);
    }, [
        change
    ]);
    var priceType = (0,react.useMemo)(function() {
        if (numeralChange.value() > 0) return "up";
        if (numeralChange.value() < 0) return "down";
        return "netral";
    }, [
        numeralChange
    ]);
    var formattedPrice = (0,react.useMemo)(function() {
        return numeral_default()(price).format("0,0.[00]");
    }, [
        price
    ]);
    var formattedChange = (0,react.useMemo)(function() {
        var val = numeralChange.value();
        if (Number.isNaN(val)) return "NA";
        return numeralChange.format("0,0.00");
    }, [
        numeralChange
    ]);
    var formattedPercentage = (0,react.useMemo)(function() {
        var val = numeralChange.value();
        if (val === 0) return "0.00%";
        return "".concat(numeral_default()(percentage).format("+0.00"), "%");
    }, [
        numeralChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySymbol, {
                valueType: StreamWidget_constants/* stockChange */.cT[priceType].color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.light */.Z.light,
                    family: "bold",
                    size: "18px",
                    padding: "3px 20px 0 8px",
                    children: symbol
                })
            }),
            isCompanySuspended && // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                pl: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspendedBadge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "span",
                        size: "12px",
                        color: "inherit",
                        children: "Suspended"
                    })
                })
            }),
            isCompanyDelisted && // @ts-expect-error
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                pl: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspendedBadge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "span",
                        size: "12px",
                        color: "inherit",
                        children: "Delisted"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                size: "16px",
                padding: "0 0 0 10px",
                children: formattedPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStockChange, {
                as: "span",
                className: StreamWidget_constants/* stockChange */.cT[priceType].icon,
                color: StreamWidget_constants/* stockChange */.cT[priceType].color,
                hoverColor: StreamWidget_constants/* stockChange */.cT[priceType].color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: StreamWidget_constants/* stockChange */.cT[priceType].color,
                padding: "0 2px",
                children: formattedChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: StreamWidget_constants/* stockChange */.cT[priceType].color,
                padding: "0 2px",
                children: formattedPercentage
            })
        ]
    });
}
/* harmony default export */ var PopoverContentCompany_StockChangeWrapper = (StockChangeWrapper);

// EXTERNAL MODULE: ./src/utils/company.ts
var utils_company = __webpack_require__(4168);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentCompany/index.tsx


















var isReksaDana = utils_company/* default.isReksaDana */.Z.isReksaDana;
var navsLabel = {
    keystats: "Key Stats",
    financials: "Financials",
    fundachart: "Fundachart",
    chartbit: "Chartbit"
};
var PopoverContentCompany = function(param) {
    var symbol = param.symbol, chart = param.chart, currentSymbol = param.currentSymbol, handleFollowCompany = param.handleFollowCompany;
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var navs = (0,react.useMemo)(function() {
        if (!currentSymbol || currentSymbol.type_company !== "Saham") {
            return [
                "chartbit"
            ];
        }
        if ((currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.country) === "ID") {
            return [
                "keystats",
                "financials",
                "fundachart",
                "chartbit"
            ];
        }
        return [
            "keystats",
            "chartbit"
        ];
    }, [
        currentSymbol
    ]);
    var onBuyBottonClick = function() {
        (0,utils/* showTradingModalWithAuth */.Y)({
            symbol: symbol,
            orderType: constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContentWrapper */.R_, {
        "data-cy": "stream-popover-company-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: country === "ID",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainChart, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentCompany_StockChart, {
                            chart: chart
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        padding: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentCompany_StockChangeWrapper, {
                                symbol: currentSymbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        height: "30px",
                                        // @ts-expect-error
                                        padding: "0 8px",
                                        margin: "0 5px",
                                        round: true,
                                        onClick: handleFollowCompany,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                            className: (currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.followed) ? "icon-toolbar_check" : "icon-toolbar_plus",
                                            size: "14px",
                                            color: color/* default.primary */.Z.primary
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: (currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.tradeable) && !isReksaDana(currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.type_company),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            "data-cy": "stream-popover-company-buy",
                                            type: "primary",
                                            height: "30px",
                                            // @ts-expect-error
                                            padding: "0 25px",
                                            round: true,
                                            onClick: onBuyBottonClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: color/* default.light */.Z.light,
                                                align: "center",
                                                children: "Buy"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: navs.map(function(tab) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/symbol/".concat(symbol, "/").concat(tab),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFooter, {
                                    as: "a",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        align: "center",
                                        as: "span",
                                        children: navsLabel[tab]
                                    })
                                })
                            }, tab);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "MY",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 200
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var PopoverCompany_PopoverContentCompany = (PopoverContentCompany);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var api_company = __webpack_require__(1349);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(66350);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/features/company/FRPage/useOnClickBuyFR.ts
var useOnClickBuyFR = __webpack_require__(80842);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentFR/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 200px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid #EDEDED;\n  padding: 10px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  max-height: 800px;\n  border-radius: 2px;\n  max-width: 400px;\n  position: relative;\n  border: 1px solid #EDEDED;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  padding: 12px;\n  align-items: center;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #333333;\n  border-left: 5px solid #00AB6B;\n  height: 30px;\n  border-radius: 2px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  padding: 2px 5px;\n  color: #EE4A49;\n  border: 1px solid rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n  top: 12px;\n  left: 12px;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ChartContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cdc277-0"
})(styled_templateObject());
var PopoverContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cdc277-1"
})(styled_templateObject1());
var styled_ButtonFooter = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-1cdc277-2"
})(styled_templateObject2());
var styled_CompanySymbol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cdc277-3"
})(styled_templateObject3());
var styled_SuspendedBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1cdc277-4"
})(styled_templateObject4());

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentFR/Chart.tsx





var fillColor = color/* default.clearDay */.Z.clearDay;
var lineColor = color/* default.mountainMeadow */.Z.mountainMeadow;
var Chart = function(param) {
    var chart = param.chart, chartType = param.chartType;
    var prices = chart === null || chart === void 0 ? void 0 : chart.chart_points;
    var labels = (0,react.useMemo)(function() {
        var data = [];
        var dateStart = moment_default()().subtract(11, "month");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "months") <= 0){
            data.push(dateStart.format("MMM YYYY"));
            dateStart.add(1, "month");
        }
        return data;
    }, [
        prices
    ]);
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: prices.map(function(price) {
                if (!price.formated_date && price.date === "0") return "";
                var formattedDate = moment_default()(price.formated_date);
                var monthYear = formattedDate.format("MMM YYYY");
                var month = formattedDate.format("MMM");
                if (labels.includes(monthYear)) {
                    labels.splice(labels.indexOf(monthYear), 1);
                    return month;
                }
                return "";
            }),
            datasets: [
                {
                    fill: true,
                    tension: 0,
                    backgroundColor: fillColor,
                    borderColor: lineColor,
                    borderCapStyle: "butt",
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    borderWidth: 1.75,
                    data: prices.map(function(pr) {
                        var number = pr.values.find(function(val) {
                            return val.key === chartType;
                        }).value;
                        var parsedNumber = parseFloat(number);
                        return parseFloat(parsedNumber.toFixed(2));
                    })
                }, 
            ]
        };
    }, [
        prices,
        chartType
    ]);
    var options = (0,react.useMemo)(function() {
        return {
            animation: {
                duration: 0
            },
            resizeDelay: 0,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            },
            maintainAspectRatio: false,
            scales: {
                y: {
                    position: "right",
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        maxTicksLimit: 5,
                        callback: function callback(val) {
                            var parsedNumber = parseFloat("".concat(val));
                            return "".concat(parsedNumber.toFixed(2), "%");
                        }
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        align: "start",
                        maxTicksLimit: 5,
                        maxRotation: 0,
                        callback: function callback(val) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            return this.getLabelForValue(Number(val)) || null;
                        },
                        autoSkip: true
                    }
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            events: [
                "click"
            ],
            onClick: function() {}
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: chartData,
        options: options,
        height: 300
    });
};
/* harmony default export */ var PopoverContentFR_Chart = (Chart);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/PopoverContentFR/index.tsx




















var TIMEFRAME = "1y";
var PopoverContentFR = function(param) {
    var symbol = param.symbol, isFollowed = param.isFollowed, handleFollowCompany = param.handleFollowCompany;
    var onBuyBottonClick = (0,useOnClickBuyFR/* default */.Z)(symbol);
    var ref = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "company-info-data",
            symbol
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_company/* default.getCompanyInfoV2 */.Z.getCompanyInfoV2(symbol, "IDX");
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to get detail company");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))
    }), companyData = ref.data;
    var ref1 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "company-fin-data",
            symbol
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return api_company/* default.getCompanyFinItem */.Z.getCompanyFinItem(symbol, "IDX");
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data.data.fr_fitem);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to detail company");
                        return _ctx.abrupt("return", undefined);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        })),
        retry: false
    }), finItem = ref1.data;
    var ref2 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "company-chart-data",
            symbol
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, response, responseData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return api_company/* default.getCompanyChartV2 */.Z.getCompanyChartV2(symbol, TIMEFRAME);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 7:
                        responseData = (ref = response.data) === null || ref === void 0 ? void 0 : ref.data;
                        return _ctx.abrupt("return", responseData);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,errors/* errorHandler */.P)(_ctx.t0, "Failed to get detail company chart");
                        return _ctx.abrupt("return", undefined);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        })),
        retry: false,
        initialData: function() {
            return {
                chart_points: []
            };
        }
    }), chartData = ref2.data;
    var isMatured = (0,react.useMemo)(function() {
        if (companyData) {
            if (companyData.tags.length > 0 && companyData.tags.some(function(item) {
                return item.name === "MATURED";
            })) {
                return true;
            }
        }
        return false;
    }, [
        companyData
    ]);
    var isTradable = (0,react.useMemo)(function() {
        if (companyData) {
            return companyData.tradable === 1;
        }
        return false;
    }, [
        companyData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverContentWrapper, {
        children: [
            isMatured && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_SuspendedBadge, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "span",
                    size: "12px",
                    color: "inherit",
                    children: "Matured"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                    condition: !!chartData,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentFR_Chart, {
                            chart: chartData,
                            chartType: "yield"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyChartContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/illustration/chart-unavailable.svg",
                                        alt: "Empty Chart"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChartText, {
                                        children: "Data Chart Belum Tersedia"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                padding: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_CompanySymbol, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.light */.Z.light,
                                    family: "bold",
                                    size: "18px",
                                    padding: "3px 20px 0 8px",
                                    children: symbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                ml: "12px",
                                size: "13px",
                                color: "#858585",
                                children: "Yield"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                family: "bold",
                                ml: "6px",
                                children: [
                                    numeral_default()(finItem === null || finItem === void 0 ? void 0 : finItem.yield).format("0.00") || "",
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                height: "30px",
                                // @ts-expect-error
                                padding: "0 8px",
                                margin: "0 5px",
                                round: true,
                                onClick: handleFollowCompany,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: isFollowed ? "icon-toolbar_check" : "icon-toolbar_plus",
                                    size: "14px",
                                    color: color/* default.primary */.Z.primary
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                condition: isTradable,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-cy": "stream-popover-company-buy",
                                    type: "primary",
                                    height: "30px",
                                    // @ts-expect-error
                                    padding: "0 25px",
                                    round: true,
                                    onClick: onBuyBottonClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.light */.Z.light,
                                        align: "center",
                                        children: "Buy"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/symbol/".concat(symbol),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ButtonFooter, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            as: "span",
                            weight: "bold",
                            children: [
                                "Tentang Obligasi ",
                                symbol
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "icon/chevron-right-gray.svg",
                            width: "18",
                            height: "18"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var PopoverCompany_PopoverContentFR = (PopoverContentFR);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverCompany/index.tsx
/* eslint-disable import/named */ 











function PopoverCompany(_param) {
    var children = _param.children, symbol = _param.symbol, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "symbol"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _detail = ref1.detail, detailSymbol = _detail.data, _chart = ref1.chart, chartSymbol = _chart.popoverData;
    var currentSymbol = (detailSymbol === null || detailSymbol === void 0 ? void 0 : detailSymbol[symbol]) || {};
    var handleGetChart = function() {
        var params = {
            symbol: symbol,
            timeframe: "today",
            isPopover: true
        };
        dispatch(company/* effects.getCompanyChart */.Sz.getCompanyChart(params));
    };
    var handleEnter = function() {
        if (country === "ID") {
            dispatch(company/* effects.getCompanyDetail */.Sz.getCompanyDetail(symbol));
            handleGetChart();
        }
    };
    var handleFollowCompany = function() {
        // @ts-ignore
        var ref = auth/* default.getUserAccess */.Z.getUserAccess(), watchlistId = ref.watchlist_id;
        var action = (currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.followed) ? company/* effects.postUnfollowCompany */.Sz.postUnfollowCompany : company/* effects.postFollowCompany */.Sz.postFollowCompany;
        var data = {
            watchlistId: watchlistId,
            companyId: currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.id,
            stateToUpdate: company/* STATE_DETAIL */._P
        };
        dispatch(action(data));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                    trigger: "hover",
                    placement: "bottom",
                    overlayStyle: {
                        minWidth: "400px"
                    },
                    // @ts-expect-error
                    onMouseEnter: handleEnter,
                    content: function() {
                        if ((currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.type_company) === "FR") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverCompany_PopoverContentFR, {
                                symbol: symbol,
                                handleFollowCompany: handleFollowCompany,
                                isFollowed: currentSymbol === null || currentSymbol === void 0 ? void 0 : currentSymbol.followed
                            });
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverCompany_PopoverContentCompany, {
                            chart: chartSymbol[symbol],
                            currentSymbol: currentSymbol,
                            handleFollowCompany: handleFollowCompany,
                            symbol: symbol
                        });
                    },
                    children: children
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "MY",
                children: children
            })
        ]
    });
}
/* harmony default export */ var Popover_PopoverCompany = (PopoverCompany);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/lib/entities/user.js
var entities_user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/lib/entities/watchlist/index.ts
var watchlist = __webpack_require__(14675);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverUser/Username.tsx




function Username(param) {
    var user = param.user;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "16px",
                weight: "bold",
                children: user === null || user === void 0 ? void 0 : (ref = user.profile) === null || ref === void 0 ? void 0 : ref.username
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                deprecatedVerifiedStatus: user === null || user === void 0 ? void 0 : (ref1 = user.badge) === null || ref1 === void 0 ? void 0 : ref1.is_verified,
                verifiedStatus: user === null || user === void 0 ? void 0 : (ref2 = user.badge) === null || ref2 === void 0 ? void 0 : ref2.verified_status
            }),
            (user === null || user === void 0 ? void 0 : (ref3 = user.badge) === null || ref3 === void 0 ? void 0 : ref3.is_top) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelTopUser */.QP, {}),
            (user === null || user === void 0 ? void 0 : (ref4 = user.badge) === null || ref4 === void 0 ? void 0 : ref4.is_admin) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                privilege: 1
            })
        ]
    });
}
/* harmony default export */ var PopoverUser_Username = (Username);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverUser/UserStat.tsx




function UserStat(param) {
    var value = param.value, icon = param.icon, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        size: "16px",
                        children: value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                        padding: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: icon,
                            size: "12px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: label
            })
        ]
    });
}
/* harmony default export */ var PopoverUser_UserStat = (UserStat);

// EXTERNAL MODULE: ./src/global/Moderation/Modals/index.jsx + 7 modules
var Modals = __webpack_require__(31359);
// EXTERNAL MODULE: ./src/hooks/useChat.ts
var useChat = __webpack_require__(71534);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverUser/ButtonMore.tsx








function ButtonMore(param) {
    var username = param.username, user = param.user;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openChat = (0,useChat/* default */.Z)().openChat;
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)(false), modalBlock = ref2[0], showModalBlock = ref2[1];
    /**
   * @param {Event} e
   */ var handleSetAlert = function(e) {
        e.stopPropagation();
        var data = {
            userid: user.user_id,
            username: username
        };
        // @ts-ignore
        dispatch(entities_user/* effects.setNotificationAlertUser */.Sz.setNotificationAlertUser(data));
        setVisible(false);
    };
    /**
   * @param {Event} e
   */ // const handleToggleAddWatchlist = (e) => {
    //   e.stopPropagation();
    //   const type = user.is_followed ? 'UNFOLLOW' : 'FOLLOW';
    //   const data = {
    //     userid: user.id,
    //     username,
    //     type,
    //   };
    //   dispatch(watchlistEffects.followUser(data));
    // };
    /**
   *
   * @param {Event} e
   * @param {boolean} state
   */ var handleShowModalBlock = function(e) {
        e.stopPropagation();
        showModalBlock(true);
        setVisible(false);
    };
    var isAlertEnabled = user === null || user === void 0 ? void 0 : (ref = user.status) === null || ref === void 0 ? void 0 : ref.is_post_alert_enabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                trigger: "click",
                placement: "bottomRight",
                overlayStyle: {
                    minWidth: "145px"
                },
                visible: visible,
                onVisibleChange: function(show) {
                    return setVisible(show);
                },
                content: function() {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContentWrapper */.R_, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItem, {
                                onClick: function() {
                                    return openChat({
                                        username: username,
                                        onEligible: function() {
                                            return setVisible(false);
                                        },
                                        onIneligible: function() {
                                            return setVisible(false);
                                        }
                                    });
                                },
                                children: [
                                    "Private message @",
                                    username
                                ]
                            }),
                            (user === null || user === void 0 ? void 0 : (ref = user.status) === null || ref === void 0 ? void 0 : ref.is_followed) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItem, {
                                onClick: handleSetAlert,
                                children: [
                                    "Turn ",
                                    isAlertEnabled ? "off" : "on",
                                    " alert for @",
                                    username,
                                    " post"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionItem, {
                                onClick: function(e) {
                                    return handleShowModalBlock(e);
                                },
                                children: [
                                    "Block @",
                                    username
                                ]
                            })
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMore, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalBlockUser */.y2, {
                visible: modalBlock,
                username: username,
                userId: user.user_id,
                onCancel: function() {
                    return showModalBlock(false);
                },
                zIndex: 1042
            })
        ]
    });
}
/* harmony default export */ var PopoverUser_ButtonMore = (ButtonMore);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/PopoverUser/index.tsx

























function PopoverUser(_param) {
    var children = _param.children, username = _param.username, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "username"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref8 = (0,react.useState)(false), visible = ref8[0], setVisible = ref8[1];
    var ref9 = (0,es/* useSelector */.v9)(entities_user/* selectors */.wl), userDetail = ref9.detail;
    var currentUser = userDetail[username] ? userDetail[username] : {};
    var userAvatar = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.profile) === null || ref === void 0 ? void 0 : (ref1 = ref.avatar_urls) === null || ref1 === void 0 ? void 0 : ref1.default_url;
    var avatarUrl = (userAvatar === null || userAvatar === void 0 ? void 0 : userAvatar.startsWith("http")) ? userAvatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(currentUser === null || currentUser === void 0 ? void 0 : (ref2 = currentUser.profile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.avatar_urls) === null || ref3 === void 0 ? void 0 : ref3.default_url);
    var handleEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, request;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (userDetail[username]) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return dispatch(entities_user/* effects.getUserProfile */.Sz.getUserProfile(username));
                    case 4:
                        request = _ctx.sent;
                        // @ts-ignore
                        if (request === null || request === void 0 ? void 0 : (ref = request.payload) === null || ref === void 0 ? void 0 : ref.data) {
                            setVisible(true);
                        }
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            setVisible(true);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleEnter() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * @param {Event} e
   */ var handleFollowUser = function(e) {
        var ref;
        e.stopPropagation();
        var type = (currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.status) === null || ref === void 0 ? void 0 : ref.is_followed) ? "UNFOLLOW" : "FOLLOW";
        var data = {
            username: username,
            userid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_id,
            type: type
        };
        dispatch(watchlist/* effects.followUser */.Sz.followUser(data));
    };
    var userStatData = [
        {
            value: (currentUser === null || currentUser === void 0 ? void 0 : (ref4 = currentUser.statistic) === null || ref4 === void 0 ? void 0 : ref4.idea_count) || 0,
            icon: "icon-profile_post",
            label: "Post"
        },
        {
            value: (currentUser === null || currentUser === void 0 ? void 0 : (ref5 = currentUser.statistic) === null || ref5 === void 0 ? void 0 : ref5.follower_count) || 0,
            icon: "icon-profile_people",
            label: "Followers"
        },
        {
            value: (currentUser === null || currentUser === void 0 ? void 0 : (ref6 = currentUser.statistic) === null || ref6 === void 0 ? void 0 : ref6.following_count) || 0,
            icon: "icon-profile_people",
            label: "Following"
        }, 
    ];
    // @ts-ignore
    var showFollowButton = username !== ((ref7 = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref7 === void 0 ? void 0 : ref7.username);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        trigger: "hover",
        placement: "rightTop",
        overlayStyle: {
            minWidth: "300px"
        },
        mouseEnterDelay: 0.7,
        // @ts-expect-error
        onMouseEnter: handleEnter,
        onVisibleChange: function(show) {
            setVisible(show);
        },
        content: function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Popover/* PopoverContentWrapper */.R_, {
                padding: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    maxWidth: "200px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverUser_Username, {
                                        user: currentUser
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAbout, {
                                        padding: "10px 10px 10px 0",
                                        children: currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.profile) === null || ref === void 0 ? void 0 : ref.about
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                size: "large",
                                padding: "0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "",
                                    src: avatarUrl,
                                    onError: function(e) {
                                        return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justify: "space-between",
                        margin: "16px 0",
                        width: "85%",
                        children: userStatData.map(function(param) {
                            var value = param.value, icon = param.icon, label = param.label;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverUser_UserStat, {
                                value: value,
                                icon: icon,
                                label: label
                            }, label);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showFollowButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    height: "30px",
                                    onClick: handleFollowUser,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.primary */.Z.primary,
                                        children: (currentUser === null || currentUser === void 0 ? void 0 : (ref1 = currentUser.status) === null || ref1 === void 0 ? void 0 : ref1.is_followed) ? "Following" : "Follow"
                                    })
                                }),
                                visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverUser_ButtonMore, {
                                    username: username,
                                    user: currentUser
                                })
                            ]
                        })
                    })
                ]
            });
        },
        children: children
    }));
}
/* harmony default export */ var Popover_PopoverUser = (PopoverUser);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Popover/index.tsx




/***/ }),

/***/ 97986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Iw": function() { return /* binding */ BadgeJunk; },
/* harmony export */   "Iy": function() { return /* binding */ RepostBoxContainer; },
/* harmony export */   "JN": function() { return /* binding */ StreamOptionContainer; },
/* harmony export */   "Jm": function() { return /* binding */ BadgeJunkWrapper; },
/* harmony export */   "OF": function() { return /* binding */ OptionItemContainer; },
/* harmony export */   "Vj": function() { return /* binding */ StreamBoxContainer; },
/* harmony export */   "Y": function() { return /* binding */ TextHeader; },
/* harmony export */   "YA": function() { return /* binding */ RepostImageContainer; },
/* harmony export */   "bQ": function() { return /* binding */ CommentContainer; },
/* harmony export */   "bk": function() { return /* binding */ FooterContainer; },
/* harmony export */   "cm": function() { return /* binding */ FollowingActivityAvatarItem; },
/* harmony export */   "fj": function() { return /* binding */ YoutubeWrapper; },
/* harmony export */   "gp": function() { return /* binding */ NotifText; },
/* harmony export */   "gu": function() { return /* binding */ FollowingActivityAvatar; },
/* harmony export */   "kG": function() { return /* binding */ UnstyledButton; },
/* harmony export */   "lU": function() { return /* binding */ TextContainer; },
/* harmony export */   "oB": function() { return /* binding */ HeaderContent; },
/* harmony export */   "to": function() { return /* binding */ StreamOptionDivider; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "ze": function() { return /* binding */ IconStyle; }
/* harmony export */ });
/* unused harmony exports FlagPro, ImgWrapper, ImgModal, ImgContent, ImgContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  align-items: normal;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  padding: 2px 3px;\n  margin-left: 6px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n\n  :hover {\n    color: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  margin-left: 10px;\n\n  @media ",
        " {\n    margin-left: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    color: inherit;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n\n  mark {\n    background-color: #ff0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  margin-bottom: 0px;\n  margin-top: 15px;\n\n  a.likes-info {\n    color: #858585;\n    font-size: 12px;\n  }\n  a.likes-info:hover {\n    color: unset;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  padding: 20px 19px;\n  &:last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  margin-left: 5px;\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n    margin-left: 70px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 70vh;\n  max-width: 70vw;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  object-position: center;\n  object-fit: cover;\n  /* position: absolute; */\n  top: 0;\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 15px;\n  background: ",
        ";\n  border-radius: 3px;\n  margin-top: 20px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: solid 1px ",
        ";\n  margin-top: 16px;\n  padding: 12px;\n  border-radius: 3px;\n  cursor: pointer;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  width: 280px;\n  box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%) !important;\n\n  & > :last-child {\n    margin-bottom: 0px !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  background: #f1f1f1;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding-bottom: 56.25%;\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 10px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  height: 20px;\n  min-width: 30px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n\n  img {\n    width: 22px !important;\n    height: 22px !important;\n    border-radius: 50%;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  border: 1px solid black;\n  border-radius: 4px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 4px 8px;\n  margin: 0 12px 0 4px;\n  pointer: cusor;\n\n  img {\n    margin-right: 2px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover > svg > path {\n    stroke: #00ab6b;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}






var OptionItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    mb: "16px"
}).withConfig({
    componentId: "sc-46d9091c-0"
})(_templateObject());
// Label pro
var FlagPro = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-46d9091c-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].suvaGrey */ .Z.suvaGrey, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro);
/**
 *
 *  Stream Header Area
 *
 */ var HeaderContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-46d9091c-2"
})(_templateObject2(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var TextHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-46d9091c-3"
})(_templateObject4(), function(param) {
    var textColor = param.color;
    return textColor && (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject3(), textColor);
});
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-46d9091c-4"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
/**
 * Stream component container
 */ var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-5"
})(_templateObject6());
var ImgContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-6"
})(_templateObject7());
var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-7"
})(_templateObject8());
var StreamBoxContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-8"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro);
var NotifText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary
}).withConfig({
    componentId: "sc-46d9091c-9"
})(_templateObject10(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
/**
 *
 *  Stream Content Image Area
 *
 */ var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-10"
})(_templateObject11(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var ImgModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-46d9091c-11"
})(_templateObject12());
var ImgWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        height: props.height || "300px"
    };
}).withConfig({
    componentId: "sc-46d9091c-12"
})(_templateObject13(), function(param) {
    var height = param.height;
    return height;
});
var ImgContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-46d9091c-13"
})(_templateObject14());
/**
 * Comment / Last reply
 */ var CommentContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(ContentWrapper).withConfig({
    componentId: "sc-46d9091c-14"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].component */ .Z.component);
/**
 * Repost box
 */ var RepostBoxContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-15"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var StreamOptionContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-16"
})(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var StreamOptionDivider = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-17"
})(_templateObject18());
var YoutubeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-18"
})(_templateObject19());
var RepostImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-19"
})(_templateObject20());
var FollowingActivityAvatar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-20"
})(_templateObject21());
var FollowingActivityAvatarItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-21"
})(_templateObject22(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
var BadgeJunkWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-46d9091c-22"
})(_templateObject23());
var BadgeJunk = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type,
        visible: props.visible
    };
}).withConfig({
    componentId: "sc-46d9091c-23"
})(_templateObject24(), function(param) {
    var visible = param.visible;
    return visible ? "flex" : "none";
}, function(param) {
    var type = param.type;
    if (type === "junk") {
        return "\n        border-color: #F5931B;\n        color: #F5931B;\n      ";
    }
    if (type === "spam") {
        return "\n        border-color: #EE4A49;\n        color: #EE4A49;\n      ";
    }
    return "";
});
var UnstyledButton = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-46d9091c-24"
})(_templateObject25());
var IconStyle = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46d9091c-25"
})(_templateObject26());



/***/ }),

/***/ 13683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_string_replace_recursively__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54253);
/* harmony import */ var react_string_replace_recursively__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_string_replace_recursively__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14601);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64435);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2497);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11237);
/* harmony import */ var _Popover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77977);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31608);
/* eslint-disable react/no-array-index-key */ 














function TextContent(_param) {
    var content = _param.content, maskedHtml = _param.maskedHtml, _style = _param.style, style = _style === void 0 ? {} : _style, _isDefaultExpand = _param.isDefaultExpand, isDefaultExpand = _isDefaultExpand === void 0 ? false : _isDefaultExpand, _isRepost = _param.isRepost, isRepost = _isRepost === void 0 ? false : _isRepost, _highlightWord = _param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _needParsed = _param.needParsed, needParsed = _needParsed === void 0 ? true : _needParsed, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_param, [
        "content",
        "maskedHtml",
        "style",
        "isDefaultExpand",
        "isRepost",
        "highlightWord",
        "needParsed"
    ]);
    var defaultHeight = 200;
    var MAX_TEXT_LENGTH = 400;
    var MAX_TRIM_TEXT = 140;
    var textRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(defaultHeight), contentHeight = ref[0], setContentHeight = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(isDefaultExpand), isExpand = ref1[0], setIsExpand = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showReadMore = ref2[0], setShowReadMore = ref2[1];
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_7__/* .selectors */ .wl).isLoggedIn;
    // Due to different format between exodus API and base API regarding `mask_html` data format
    // we need to transform the `mask_html` data to object first to support both api
    var parseHtmlMask = function(mask) {
        if (Array.isArray(maskedHtml)) {
            var parsed = mask.reduce(function(obj, curr) {
                // eslint-disable-next-line no-param-reassign
                obj[curr.mask] = curr;
                return obj;
            }, {});
            return parsed;
        }
        return mask;
    };
    var parsedText = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var tempParsedText = (0,utils_stream__WEBPACK_IMPORTED_MODULE_6__/* .parseEmoji */ .qm)(content);
        if (isRepost && (tempParsedText === null || tempParsedText === void 0 ? void 0 : tempParsedText.length) > MAX_TEXT_LENGTH) {
            // trim the string to the maximum length
            var trimmedString = tempParsedText.substr(0, MAX_TEXT_LENGTH);
            // re-trim if we are in the middle of a word
            tempParsedText = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
        }
        var parsedHtml = parseHtmlMask(maskedHtml);
        var config = {
            breaks: {
                pattern: /(\n|\r\n)/g,
                matcherFn: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    });
                }
            },
            symbols: {
                pattern: /(\[%[a-z0-9]*%\])/gi,
                textFn: function(text) {
                    var cleanedSymbol = text.match(/\w+/g);
                    return cleanedSymbol;
                },
                matcherFn: function(rawText) {
                    var ref, ref1;
                    var htmlData = parsedHtml[rawText];
                    var _attr = htmlData.attr, attr = _attr === void 0 ? {} : _attr, text = htmlData.text, _tag = htmlData.tag, tag = _tag === void 0 ? "" : _tag;
                    var textContent = text.substr(1);
                    var textColor = htmlData === null || htmlData === void 0 ? void 0 : (ref = htmlData.attr) === null || ref === void 0 ? void 0 : (ref1 = ref.color) === null || ref1 === void 0 ? void 0 : ref1.light;
                    var attrClass = (attr === null || attr === void 0 ? void 0 : attr.class) || "";
                    var isSymbolLink = attrClass === "stock-indicator" || attrClass === "fr-bonds-indicator";
                    if (isSymbolLink) {
                        return isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/".concat(attr.href),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Popover__WEBPACK_IMPORTED_MODULE_10__/* .PopoverCompany */ .h, {
                                    symbol: textContent,
                                    children: text
                                })
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            as: "span",
                            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                            children: text
                        });
                    }
                    if (attrClass === "user-indicator") {
                        return isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: tag === "deactivatedUser" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/".concat(attr.href),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "deactive-user-label",
                                    children: text
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/".concat(attr.href),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Popover__WEBPACK_IMPORTED_MODULE_10__/* .PopoverUser */ .q, {
                                        username: textContent,
                                        children: text
                                    })
                                })
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            as: "span",
                            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                            children: text
                        });
                    }
                    if (tag === "span" && attrClass === "insider-indicator") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            as: "span",
                            style: textColor !== "" ? {
                                color: textColor
                            } : {},
                            children: text
                        });
                    }
                    if (tag === "a" && attrClass === "insider-indicator") {
                        return isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            style: {
                                color: "#0BA16B",
                                cursor: "pointer",
                                border: "none",
                                background: "none",
                                display: "inline"
                            },
                            type: "button",
                            onClick: function() {
                                var ref;
                                var _href;
                                var str = (_href = attr.href) !== null && _href !== void 0 ? _href : "";
                                var id = (ref = str.split("/")) === null || ref === void 0 ? void 0 : ref[1];
                                var isForeign = content.includes("Foreign");
                                var nationality = isForeign ? "NATIONALITY_TYPE_FOREIGN" : "NATIONALITY_TYPE_LOCAL";
                                var customEvent = new CustomEvent("host-insider-activity", {
                                    detail: {
                                        eventName: "insider-detail",
                                        id: id,
                                        name: attr.data_insider,
                                        nationality: nationality
                                    }
                                });
                                window.dispatchEvent(customEvent);
                            },
                            children: text
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            as: "span",
                            color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                            children: text
                        });
                    }
                    if (tag === "a") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: attr.href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: attrClass,
                                children: text
                            })
                        });
                    }
                    if (tag === "b") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            className: attrClass,
                            children: text
                        });
                    }
                    if (tag === "span") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: attrClass,
                            children: text
                        });
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: attrClass,
                        children: text
                    });
                }
            }
        };
        if (needParsed) {
            tempParsedText = react_string_replace_recursively__WEBPACK_IMPORTED_MODULE_5___default()(config)(tempParsedText);
        } else {
            tempParsedText = tempParsedText.length > MAX_TRIM_TEXT ? [
                "".concat(tempParsedText.substring(0, MAX_TRIM_TEXT), " ...")
            ] : [
                tempParsedText
            ];
        }
        return tempParsedText;
    }, [
        content
    ]);
    var handleExpand = function() {
        var text = textRef.current;
        setIsExpand(true);
        setContentHeight(text.offsetHeight);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!(textRef === null || textRef === void 0 ? void 0 : textRef.current)) return;
        var offsetHeight = textRef.current.offsetHeight;
        var isHeightOverflow = offsetHeight > contentHeight;
        setShowReadMore(isHeightOverflow);
        if (isDefaultExpand && !isRepost) {
            setContentHeight(offsetHeight);
        }
        if (highlightWord !== "") {
            (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .highlightWords */ .zk)(highlightWord, textRef.current, "mark");
        }
    }, []);
    var hideLoggedInText = !isExpand && showReadMore && isLoggedIn;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .TextContainer */ .l, {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    maxHeight: "".concat(contentHeight, "px")
                }, style),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .FormatedText */ .P, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                    padding: "0px",
                    height: "1.55",
                    ref: textRef,
                    style: {
                        wordWrap: !isRepost ? "break-word" : "unset"
                    }
                }, props), {
                    children: parsedText === null || parsedText === void 0 ? void 0 : parsedText.map(function(item, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: item
                        }, i);
                    })
                }))
            }, "stream-formatted-text"),
            hideLoggedInText && !isRepost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                onClick: handleExpand,
                style: {
                    cursor: "pointer"
                },
                children: "Read more..."
            }, "stream-readmore-text"),
            !isExpand && content.length > MAX_TEXT_LENGTH && !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/register",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary,
                    as: "a",
                    children: "Read more..."
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_4__.memo)(TextContent));


/***/ }),

/***/ 31608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ FormatedText; },
/* harmony export */   "l": function() { return /* binding */ TextContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin-bottom: 12px;\n  transition: all 0.3s ease-in-out;\n  -webkit-line-clamp: 2;\n\n  .deactive-user-label {\n    color: ",
        " !important;\n    font-family: var(--font-bold);\n  }\n\n  // styling for masking text\n  .insider-indicator.green {\n    color: ",
        ";\n    background: transparent;\n  }\n  .insider-indicator.red {\n    color: ",
        ";\n    background: transparent;\n  }\n\n  // styling for masking text at safari\n  @supports (font: -apple-system-body) and (-webkit-appearance: none) {\n    p {\n      line-height: 1.6;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mark {\n    background-color: #ff0;\n    padding: 0px;\n    color: ",
        ";\n  }\n\n  a > span > mark {\n    color: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7f9f3cba-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var FormatedText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7f9f3cba-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dark */ .Z.dark);



/***/ }),

/***/ 11237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GC": function() { return /* binding */ decideFileType; },
/* harmony export */   "TL": function() { return /* binding */ getActiveReportType; },
/* harmony export */   "a9": function() { return /* binding */ getStreamCategories; },
/* harmony export */   "i0": function() { return /* binding */ getFilterParamFromLocalStorage; },
/* harmony export */   "sw": function() { return /* binding */ getActiveCategory; },
/* harmony export */   "wR": function() { return /* binding */ handleAnalyticsTabView; },
/* harmony export */   "yk": function() { return /* binding */ showFileName; },
/* harmony export */   "zk": function() { return /* binding */ highlightWords; }
/* harmony export */ });
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99093);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21390);



var getStreamCategories = function(streamType) {
    var streamCategories = _constants__WEBPACK_IMPORTED_MODULE_2__/* .categories */ .bd[streamType];
    return streamCategories;
};
var getActiveCategory = function(key) {
    var streamCategories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_2__/* .categories */ .bd[_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_TYPE.GENERIC */ .R5.GENERIC];
    return streamCategories.find(function(cat) {
        return cat.key === key;
    }) || streamCategories[0];
};
var getActiveReportType = function(key) {
    var reportTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_2__/* .reportCategories */ .U1;
    return reportTypes.find(function(report) {
        return report.key === key;
    }) || _constants__WEBPACK_IMPORTED_MODULE_2__/* .reportCategories[0] */ .U1[0];
};
function decideFileType(file) {
    var filename = String(file.split("/").pop());
    var parsedFilename = filename.length > 33 ? "".concat(filename.substr(0, 20), "...").concat(filename.substr(filename.length - 6, 6)) : filename;
    var extension = parsedFilename.split(".").pop();
    switch(extension){
        case "pdf":
            return "file-pdf";
        case "xls":
        case "xlsx":
            return "file-xls";
        case "doc":
        case "docx":
            return "file-doc";
        default:
            return "file-ppt";
    }
}
var showFileName = function(url) {
    var cleanUrl = url.split("?")[0];
    var fullFilename = cleanUrl.split("/").pop() || "";
    var dotIndex = fullFilename.lastIndexOf(".");
    var name = dotIndex !== -1 ? fullFilename.slice(0, dotIndex) : fullFilename;
    var extension = dotIndex !== -1 ? fullFilename.slice(dotIndex) : ".pdf";
    if (name.length > 33) {
        return "".concat(name.substr(0, 20), "...").concat(name.substr(-6)).concat(extension);
    }
    return name + extension;
};
var getFilterParamFromLocalStorage = function() {
    if (true) {
        var filter = {};
        if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.CATEGORY */ .eB.CATEGORY)) {
            filter.category = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.CATEGORY */ .eB.CATEGORY);
        }
        if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.TYPE */ .eB.TYPE)) {
            var ref;
            filter.type = ((ref = _constants__WEBPACK_IMPORTED_MODULE_2__/* .streamTypes.find */ .J1.find(function(item) {
                return item.lsKey === localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.TYPE */ .eB.TYPE);
            })) === null || ref === void 0 ? void 0 : ref.key) || "latest";
        }
        if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.TAB */ .eB.TAB)) {
            filter.tabHeader = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .STREAM_STATE.TAB */ .eB.TAB);
        }
        if (localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_STREAM_TRENDING_TAB_DATE */ .oE)) {
            filter.date = localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__/* .LS_STREAM_TRENDING_TAB_DATE */ .oE);
        }
        return filter;
    }
    return null;
};
var handleAnalyticsTabView = function(currentTab, filter) {
    switch(currentTab){
        case "reports":
            var ref;
            // eslint-disable-next-line no-case-declarations
            var reportLabel = ((ref = _constants__WEBPACK_IMPORTED_MODULE_2__/* .reportCategories.find */ .U1.find(function(item) {
                return item.key === filter;
            })) === null || ref === void 0 ? void 0 : ref.label) || "";
            return features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].reports.View.onReportsViewed */ .ZP.reports.View.onReportsViewed(reportLabel);
        case "predictions":
            return features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].predictions.View.onPredictionsViewed */ .ZP.predictions.View.onPredictionsViewed();
        case "insider":
            return features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].insiders.View.onInsidersViewed */ .ZP.insiders.View.onInsidersViewed();
        case "charts":
            return features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].charts.View.onChartsViewed */ .ZP.charts.View.onChartsViewed();
        case "ideas":
        default:
            var ref1;
            // eslint-disable-next-line no-case-declarations
            var ideasType = ((ref1 = _constants__WEBPACK_IMPORTED_MODULE_2__/* .streamTypes.find */ .J1.find(function(item) {
                return item.key === filter;
            })) === null || ref1 === void 0 ? void 0 : ref1.label) || "";
            return features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ideas.View.onIdeasViewed */ .ZP.ideas.View.onIdeasViewed(ideasType);
    }
};
// Stolen from https://stackoverflow.com/questions/8644428/how-to-highlight-text-using-javascript
function highlightWords(keyword, element) {
    var tagName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "mark";
    // nosemgrep - detect-non-literal-regexp
    var keywordRegex = new RegExp((0,utils_general__WEBPACK_IMPORTED_MODULE_1__/* .escapeRegExp */ .hr)(keyword), "gi");
    var nodes = Array.from(element.childNodes);
    // Sort longer matches first to avoid highlighting keywords within keywords.
    nodes.forEach(function(node) {
        var textContent = node.textContent, parentNode = node.parentNode, nodeType = node.nodeType;
        if (nodeType !== Node.TEXT_NODE) {
            // not a text node
            highlightWords(keyword, node);
        } else if (keywordRegex.test(textContent)) {
            var fragment = document.createDocumentFragment();
            var lastIdx = 0;
            textContent.replace(keywordRegex, function(match, idx) {
                var part = document.createTextNode(textContent.slice(lastIdx, idx));
                var highlighted = document.createElement(tagName);
                highlighted.textContent = match;
                fragment.appendChild(part);
                fragment.appendChild(highlighted);
                lastIdx = idx + match.length;
                return match;
            });
            var end = document.createTextNode(textContent.slice(lastIdx));
            fragment.appendChild(end);
            parentNode.replaceChild(fragment, node);
        }
    });
}



/***/ }),

/***/ 15077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Form value with state wrapper
 * @param {Object=} props
 * @param {*=} props.initialState
 * @returns {[*, function]}
 */ function useForm(param) {
    var _initialState = param.initialState, initialState = _initialState === void 0 ? "" : _initialState;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), value = ref[0], setValue = ref[1];
    var handleChange = function(e) {
        setValue(e.target.value);
    };
    return [
        value,
        handleChange
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useForm);


/***/ }),

/***/ 30627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useTooltip(localStorageKey) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var renderTooltip = function() {
        var ref;
        if (!(window === null || window === void 0 ? void 0 : (ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.getItem(localStorageKey))) {
            localStorage.setItem(localStorageKey, JSON.stringify(true));
            setShowTooltip(true);
        } else {
            var ref1;
            setShowTooltip(JSON.parse(window === null || window === void 0 ? void 0 : (ref1 = window.localStorage) === null || ref1 === void 0 ? void 0 : ref1.getItem(localStorageKey)));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        renderTooltip();
    }, []);
    var onCloseTooltip = function() {
        localStorage.setItem(localStorageKey, JSON.stringify(false));
        setShowTooltip(false);
    };
    return {
        showTooltip: showTooltip,
        onCloseTooltip: onCloseTooltip
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useTooltip);


/***/ }),

/***/ 66350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ errorHandler; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);

var errorHandler = function(error, defaultMessage) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
        throw new Error(error.message);
    }
    if (typeof error === "string") {
        throw new Error(error);
    }
    throw new Error(defaultMessage);
};


/***/ }),

/***/ 77325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ deleteImageExif; },
/* harmony export */   "p": function() { return /* binding */ getImageDimensions; }
/* harmony export */ });
/* harmony import */ var exifremove__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9922);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];

/**
 * Get Image Dimension from loaded image, from FileReader
 * @param file
 */ var getImageDimensions = function(file) {
    return new Promise(function(resolved) {
        var i = new Image();
        i.src = file;
        i.onload = function() {
            resolved({
                width: i.width,
                height: i.height
            });
        };
    });
};
/**
 * Delete Image Exif
 * @description
 * delete exif data from jpg or jpeg image
 * and return clean image
 * @param {string | ArrayBuffer} image
 * @param {any} imageType
 * @returns
 */ var deleteImageExif = function(image, imageType) {
    // @ts-ignore
    var buffer = Buffer.from(image);
    var tempBuffer = exifremove__WEBPACK_IMPORTED_MODULE_0__.remove(buffer);
    var blob = new Blob([
        tempBuffer
    ], {
        type: imageType
    });
    var resultImageDeletedExif = new File([
        blob
    ], "temp.".concat(imageType.split("/")[1]), {
        type: imageType
    });
    return resultImageDeletedExif;
};



/***/ }),

/***/ 6426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ handleErrorPostStream; }
/* harmony export */ });
/* harmony import */ var features_stream_ModalError_stores_useGlobalStreamError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20510);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);



var checkErrorPostLink = function(error) {
    var ref, ref1, ref2, ref3;
    var errorComposeLink = (ref1 = (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.errors) || []) === null || ref1 === void 0 ? void 0 : ref1.find(function(err) {
        return err.key === "LINK";
    });
    return (error === null || error === void 0 ? void 0 : (ref2 = error.cause) === null || ref2 === void 0 ? void 0 : ref2.status) === 400 && (error === null || error === void 0 ? void 0 : (ref3 = error.cause) === null || ref3 === void 0 ? void 0 : ref3.errorType) === "INVALID_PARAMETER" && !!errorComposeLink;
};
var handleErrorPostStream = function(error, type) {
    var ref, ref1;
    if (!error) {
        return;
    }
    if (((ref = error.cause) === null || ref === void 0 ? void 0 : ref.errorType) === "POST_REACHED_LIMIT" || ((ref1 = error.cause) === null || ref1 === void 0 ? void 0 : ref1.errorType) === "POST_IS_NOT_ALLOWED") {
        features_stream_ModalError_stores_useGlobalStreamError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().openModal(features_stream_ModalError_stores_useGlobalStreamError__WEBPACK_IMPORTED_MODULE_0__/* .ModalNames.STREAM_POST_LIMIT */ .s.STREAM_POST_LIMIT, error.cause.message, type !== null && type !== void 0 ? type : "");
    } else if (checkErrorPostLink(error)) {
        features_stream_ModalError_stores_useGlobalStreamError__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().openModal(features_stream_ModalError_stores_useGlobalStreamError__WEBPACK_IMPORTED_MODULE_0__/* .ModalNames.COMPOSE_ERROR_LINK */ .s.COMPOSE_ERROR_LINK);
    } else {
        var ref2;
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(error === null || error === void 0 ? void 0 : (ref2 = error.cause) === null || ref2 === void 0 ? void 0 : ref2.message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
    }
};


/***/ })

}]);